/*!
* mudu-player.js v0.36.3
* commit: 106a31c4
* Copyright © 目睹 http://mudu.tv
*/
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.muduPlayer = factory());
}(this, (function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  var userAgent = navigator.userAgent;

  var userAgentMatch = function userAgentMatch(regex) {
    return userAgent.match(regex) !== null;
  };

  function lazyUserAgentMatch(regex) {
    return function () {
      return userAgentMatch(regex);
    };
  }

  function isFlashInstalled() {
    var version = flashVersion();
    return !!version;
  }
  function isFlashSupported() {
    var version = flashVersion();
    return !!(version && version >= "5.0.2-15");
  }
  var isFF = lazyUserAgentMatch(/gecko\//i);
  var isIETrident = lazyUserAgentMatch(/trident\/.+rv:\s*11/i);
  var isIPod = lazyUserAgentMatch(/iP(hone|od)/i);
  var isIPad = lazyUserAgentMatch(/iPad/i);
  var isOSX = lazyUserAgentMatch(/Macintosh/i); // Check for Facebook App Version to see if it's Facebook

  var isFacebook = lazyUserAgentMatch(/FBAV/i);
  var isEdge = function isEdge() {
    return userAgentMatch(/\sEdge\/\d+/i);
  };
  var isMSIE = function isMSIE() {
    return userAgentMatch(/msie/i);
  };
  var isChrome = function isChrome() {
    return userAgentMatch(/\s(?:(?:Headless)?Chrome|CriOS)\//i) && !isEdge() && !userAgentMatch(/UCBrowser/i);
  };
  var isIE = function isIE() {
    return isEdge() || isIETrident() || isMSIE();
  };
  var isSafari = function isSafari() {
    return userAgentMatch(/safari/i) && !userAgentMatch(/(?:Chrome|CriOS|chromium|android|phantom)/i);
  };
  var isIOS = function isIOS() {
    return userAgentMatch(/iP(hone|ad|od)/i);
  };
  var isDebugMode = function isDebugMode() {
    return window.location.href.indexOf('playerdebug') >= 0;
  };
  var getLanguage = function getLanguage() {
    return navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;
  };
  var isAndroidNative = function isAndroidNative() {
    if (userAgentMatch(/chrome\/[123456789]/i) && !userAgentMatch(/chrome\/18/i) && !isFF()) {
      return false;
    }

    return isAndroid();
  };
  var getWebkitVersion = function getWebkitVersion() {
    var u = userAgent.toLowerCase();
    return /webkit/.test(u) ? parseFloat(u.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, '$1')) : false;
  };
  var isAndroid = function isAndroid() {
    return userAgentMatch(/Android/i) && !userAgentMatch(/Windows Phone/i);
  };
  var isMobile = function isMobile() {
    return isIOS() || isAndroid() || userAgentMatch(/Windows Phone/i);
  };
  var isWindows = function isWindows() {
    return userAgentMatch('Windows') > -1;
  };
  var isIframe = function isIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };
  var isX5Layer = function isX5Layer() {
    return isWxLayer() || isQQLayer();
  };
  var isWxLayer = function isWxLayer() {
    var ua = userAgent;
    var res = /tbs\/(\d+) /gi.exec(ua);
    var hasWechat = /wechat|micromessenger/gi.test(ua);

    if (!isAndroid(ua)) {
      return false;
    }

    if (res || hasWechat) {
      return hasWechat || (res[1] || '') > '036849';
    }

    return false;
  };
  var isQQLayer = function isQQLayer() {
    var ua = userAgent;
    var res = /MQQBrowser\/([\d+.]+) /gi.exec(ua);

    if (!isAndroid(ua)) {
      return false;
    }

    if (res) {
      return +(res[1] || '') >= 7.1;
    }

    return false;
  };
  var flashVersion = function flashVersion() {
    if (isAndroid()) {
      return 0;
    }

    var plugins = navigator.plugins;
    var flash;

    if (plugins) {
      flash = plugins['Shockwave Flash'];

      if (flash && flash.description) {
        return parseFloat(flash.description.replace(/\D+(\d+\.?\d*).*/, '$1'));
      }
    }

    if (typeof window.ActiveXObject !== 'undefined') {
      try {
        flash = new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash');

        if (flash) {
          return parseFloat(flash.GetVariable('$version').split(' ')[1].replace(/\s*,\s*/, '.'));
        }
      } catch (e) {
        return 0;
      }

      return flash;
    }

    return 0;
  };

  function browserVersion(browserEnvironment, agent) {
    var version;
    var major;
    var minor;
    var ix;

    if (browserEnvironment.chrome) {
      // A Chrome UA either contains "Chrome" (desktop/android) or "CriOS" (iOS)
      if (agent.indexOf('Chrome') !== -1) {
        version = agent.substring(agent.indexOf('Chrome') + 7);
      } else {
        version = agent.substring(agent.indexOf('CriOS') + 6);
      }
    } else if (browserEnvironment.safari) {
      // Safari sets its version after the "Version" string in the agent
      version = agent.substring(agent.indexOf('Version') + 8);
    } else if (browserEnvironment.firefox) {
      version = agent.substring(agent.indexOf('Firefox') + 8);
    } else if (browserEnvironment.edge) {
      version = agent.substring(agent.indexOf('Edge') + 5);
    } else if (browserEnvironment.ie) {
      // Older versions of IE use MSIE; IE11 uses rv:
      if (agent.indexOf('rv:') !== -1) {
        version = agent.substring(agent.indexOf('rv:') + 3);
      } else if (agent.indexOf('MSIE') !== -1) {
        version = agent.substring(agent.indexOf('MSIE') + 5);
      }
    }

    if (version) {
      // trim the version string
      if ((ix = version.indexOf(';')) !== -1) {
        version = version.substring(0, ix);
      }

      if ((ix = version.indexOf(' ')) !== -1) {
        version = version.substring(0, ix);
      }

      if ((ix = version.indexOf(')')) !== -1) {
        version = version.substring(0, ix);
      }

      major = parseInt(version, 10); // Versions will always be in the d.d.d format

      minor = parseInt(version.split('.')[1], 10);
    } // Allow undefined to represent unknown agents


    return {
      version: version,
      major: major,
      minor: minor
    };
  }

  function execResult(array, index) {
    if (array && array.length > index) {
      return array[index];
    }
  }

  function osVersion(osEnvironment, agent) {
    var version;
    var major;
    var minor;

    if (osEnvironment.windows) {
      version = execResult(/Windows(?: NT|)? ([._\d]+)/.exec(agent), 1); // Map the Windows NT version to the canonical Windows version

      switch (version) {
        case '6.1':
          version = '7.0';
          break;

        case '6.2':
          version = '8.0';
          break;

        case '6.3':
          version = '8.1';
          break;

        default:
          break;
      }
    } else if (osEnvironment.android) {
      version = execResult(/Android ([._\d]+)/.exec(agent), 1);
    } else if (osEnvironment.iOS) {
      version = execResult(/OS ([._\d]+)/.exec(agent), 1);
    } else if (osEnvironment.mac) {
      version = execResult(/Mac OS X (10[._\d]+)/.exec(agent), 1);
    }

    if (version) {
      major = parseInt(version, 10); // Versions may be in the d.d.d or d_d_d format

      var versionNumbers = version.split(/[._]/);

      if (versionNumbers) {
        minor = parseInt(versionNumbers[1], 10);
      }
    } // Allow undefined to represent unknown agents


    return {
      version: version,
      major: major,
      minor: minor
    };
  }

  var userAgent$1 = navigator.userAgent;
  var browser = {
    chrome: isChrome(),
    edge: isEdge(),
    firefox: isFF(),
    ie: isIE(),
    msie: isMSIE(),
    safari: isSafari()
  };
  browser.version = browserVersion(browser, userAgent$1);
  var os = {
    android: isAndroid(),
    iOS: isIOS(),
    mobile: isMobile(),
    mac: isOSX(),
    iPad: isIPad(),
    iPhone: isIPod(),
    windows: isWindows()
  };
  os.version = osVersion(os, userAgent$1);
  var others = {
    flashInstalled: isFlashInstalled(),
    flashSupported: isFlashSupported(),
    flashVersion: flashVersion(),
    iframe: isIframe()
  };
  var envor = {
    browser: browser,
    os: os,
    others: others
  };
  var browserVersion$1 = browser.version;
  var osVersion$1 = os.version;
  var getEnvor = function getEnvor() {
    return JSON.parse(JSON.stringify(envor));
  };

  var browser$1 = /*#__PURE__*/Object.freeze({
    browserVersion: browserVersion$1,
    osVersion: osVersion$1,
    getEnvor: getEnvor,
    isFlashInstalled: isFlashInstalled,
    isFlashSupported: isFlashSupported,
    isFF: isFF,
    isIETrident: isIETrident,
    isIPod: isIPod,
    isIPad: isIPad,
    isOSX: isOSX,
    isFacebook: isFacebook,
    isEdge: isEdge,
    isMSIE: isMSIE,
    isChrome: isChrome,
    isIE: isIE,
    isSafari: isSafari,
    isIOS: isIOS,
    isDebugMode: isDebugMode,
    getLanguage: getLanguage,
    isAndroidNative: isAndroidNative,
    getWebkitVersion: getWebkitVersion,
    isAndroid: isAndroid,
    isMobile: isMobile,
    isWindows: isWindows,
    isIframe: isIframe,
    isX5Layer: isX5Layer,
    isWxLayer: isWxLayer,
    isQQLayer: isQQLayer,
    flashVersion: flashVersion
  });

  /* This program is free software. It comes without any warranty, to
       * the extent permitted by applicable law. You can redistribute it
       * and/or modify it under the terms of the Do What The Fuck You Want
       * To Public License, Version 2, as published by Sam Hocevar. See
       * http://www.wtfpl.net/ for more details. */
  var leftPad_1 = leftPad;

  var cache = [
    '',
    ' ',
    '  ',
    '   ',
    '    ',
    '     ',
    '      ',
    '       ',
    '        ',
    '         '
  ];

  function leftPad (str, len, ch) {
    // convert `str` to a `string`
    str = str + '';
    // `len` is the `pad`'s length now
    len = len - str.length;
    // doesn't need to pad
    if (len <= 0) return str;
    // `ch` defaults to `' '`
    if (!ch && ch !== 0) ch = ' ';
    // convert `ch` to a `string` cuz it could be a number
    ch = ch + '';
    // cache common use cases
    if (ch === ' ' && len < 10) return cache[len] + str;
    // `pad` starts with an empty string
    var pad = '';
    // loop
    while (true) {
      // add `ch` to `pad` if `len` is odd
      if (len & 1) pad += ch;
      // divide `len` by 2, ditch the remainder
      len >>= 1;
      // "double" the `ch` so this operation count grows logarithmically on `len`
      // each time `ch` is "doubled", the `len` would need to be "doubled" too
      // similar to finding a value in binary search tree, hence O(log(n))
      if (len) ch += ch;
      // `len` is 0, exit the loop
      else break;
    }
    // pad `str`!
    return pad + str;
  }

  function uniqBy(array, fn) {
    var uniqed = [];
    var ret = [];

    for (var i = 0; i < array.length; i++) {
      var u = fn(array[i], i, array);

      if (uniqed.indexOf(u) >= 0) {
        continue;
      } else {
        ret.push(array[i]);
        uniqed.push(u);
      }
    }

    return ret;
  }
  function is(type, value) {
    var vtype = Object.prototype.toString.call(value);
    return "[object ".concat(type.toLowerCase(), "]") === vtype.toLowerCase();
  }
  function cssLength(value) {
    if (is('number', value)) {
      if (value <= 0) {
        // ie < 0 will throw error
        return 0;
      } else if (value <= 1) {
        return value * 100 + '%';
      } else {
        return value + 'px';
      }
    }

    return value;
  }
  function noop() {}
  var returnTrue = function returnTrue() {
    return true;
  };
  var returnFalse = function returnFalse() {
    return false;
  };
  function objectKeys(obj) {
    var ret = [];

    for (var i in obj) {
      ret.push(i);
    }

    return ret;
  }
  function rtmpStreamToParts(src) {
    var parts = {
      connection: '',
      stream: ''
    };

    if (!src) {
      return parts;
    } // Look for the normal URL separator we expect, '&'.
    // If found, we split the URL into two pieces around the
    // first '&'.


    var connEnd = src.search(/&(?!\w+=)/);
    var streamBegin;

    if (connEnd !== -1) {
      streamBegin = connEnd;
    } else {
      // If there's not a '&', we use the last '/' as the delimiter.
      connEnd = streamBegin = src.lastIndexOf('/');

      if (connEnd === 0) {
        // really, there's not a '/'?
        connEnd = streamBegin = src.length;
      }
    }

    parts.connection = src.substring(0, connEnd);
    parts.stream = src.substring(streamBegin + 1, src.length);
    return parts;
  }
  /**
   * Parse second to time string
   *
   * @param {Number} second
   * @return {String} 00:00 or 00:00:00
   */

  function secondToTime(second) {
    var isMinus = second < 0;

    if (isMinus) {
      second = -second;
    }

    var add0 = function add0(num) {
      return num < 10 ? '0' + num : '' + num;
    };

    var hour = Math.floor(second / 3600);
    var min = Math.floor((second - hour * 3600) / 60);
    var sec = Math.floor(second - hour * 3600 - min * 60);
    var str = (hour > 0 ? [hour, min, sec] : [min, sec]).map(add0).join(':');

    if (isMinus) {
      return '-' + str;
    }

    return str;
  }
  function cumulativeOffset(element) {
    var top = 0;
    var left = 0;

    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while (element);

    return {
      top: top,
      left: left
    };
  }
  function getComputedStyle(element) {
    if (window.getComputedStyle) {
      return window.getComputedStyle(element);
    } else if (element.currentStyle) {
      // ie8
      return element.currentStyle;
    }

    return {};
  }
  function getElementViewLeft(element) {
    var rect = getBoundingClientRect(element);
    if (rect.left) return rect.left;
    var actualLeft = element.offsetLeft;
    var current = element.offsetParent;
    var elementScrollLeft = document.body.scrollLeft + document.documentElement.scrollLeft;

    if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
      while (current !== null) {
        actualLeft += current.offsetLeft;
        current = current.offsetParent;
      }
    } else {
      while (current !== null && current !== element) {
        actualLeft += current.offsetLeft;
        current = current.offsetParent;
      }
    }

    return actualLeft - elementScrollLeft;
  }
  var raf = function () {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };
  }();
  var caf = function () {
    return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCanelAnimationFrame || window.oCancelAnimationFrame || window.msCancelAnimationFrame || function (timer) {
      window.clearTimeout(timer);
    };
  }();
  function addEventListener(dom) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (document.addEventListener) {
      return dom.addEventListener.apply(dom, args);
    } else {
      // dom.attachEvent can not call apply
      return dom.attachEvent('on' + args[0], args[1]);
    }
  }
  function removeEventListener(dom) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    if (document.removeEventListener) {
      return dom.removeEventListener.apply(dom, args);
    } else {
      return dom.detachEvent('on' + args[0], args[1]);
    }
  }
  function classList(element) {
    var list = element.className.split(' ').filter(function (name) {
      return name.replace(' ', '') !== '';
    });

    function add(name) {
      list.push(name);
      save();
    }

    function remove(name) {
      var filterF;

      if (is('RegExp', name)) {
        filterF = function filterF(n) {
          return !n.match(name);
        };
      } else {
        filterF = function filterF(n) {
          return n !== name;
        };
      }

      list = list.filter(filterF);
      save();
    }

    function toggle(name) {
      var exist = contains(name);

      if (exist) {
        remove(name);
      } else {
        add(name);
      }
    }

    function contains(name) {
      return list.indexOf(name) >= 0;
    }

    function save() {
      list = uniqBy(list, function (_) {
        return _;
      });
      element.className = list.join(' ');
    }

    return {
      add: add,
      remove: remove,
      toggle: toggle,
      contains: contains
    };
  }
  function stringToDom(string) {
    var div = document.createElement('div');
    div.innerHTML = string;
    return div.firstChild;
  }
  function moment(d) {
    d = d || new Date();

    function format(f) {
      f = f || 'YYYY-MM-DD HH:mm:ss.SSS';
      var YYYY = d.getFullYear();
      var MM = leftPad_1(d.getMonth() + 1, 2, '0');
      var DD = leftPad_1(d.getDate(), 2, 0);
      var HH = leftPad_1(d.getHours(), 2, 0);
      var mm = leftPad_1(d.getMinutes(), 2, 0);
      var ss = leftPad_1(d.getSeconds(), 2, 0);
      var SSS = leftPad_1(d.getMilliseconds(), 3, 0);
      var fd = f.replace('YYYY', YYYY).replace('MM', MM).replace('DD', DD).replace('HH', HH).replace('mm', mm).replace('ss', ss).replace('SSS', SSS);
      return fd;
    }

    return {
      format: format
    };
  }
  /**
   * @see https://www.ietf.org/rfc/rfc3339.txt
   * @param {Date} d
   */

  function rfc3339nano(d) {
    d = d || new Date();
    var YYYY = d.getFullYear();
    var MM = leftPad_1(d.getMonth() + 1, 2, '0');
    var DD = leftPad_1(d.getDate(), 2, 0);
    var HH = leftPad_1(d.getHours(), 2, 0);
    var mm = leftPad_1(d.getMinutes(), 2, 0);
    var ss = leftPad_1(d.getSeconds(), 2, 0);
    var SSS = d.getMilliseconds() * 1e6;
    var timeZoneOffset = -d.getTimezoneOffset();
    var absTimeZoneOffset = Math.abs(d.getTimezoneOffset());
    var hourOffset = leftPad_1(Math.floor(absTimeZoneOffset / 60), 2, 0);
    var minuteOffset = leftPad_1(Math.floor(absTimeZoneOffset % 60), 2, 0);
    var timeZoneOffsetMinus = timeZoneOffset < 0 ? '-' : '+';
    var fullDate = "".concat(YYYY, "-").concat(MM, "-").concat(DD);
    var timeSecfrac = SSS === 0 ? '' : ".".concat(SSS);
    var partialTime = "".concat(HH, ":").concat(mm, ":").concat(ss).concat(timeSecfrac);
    var timeOffset = timeZoneOffset === 0 ? '' : "".concat(timeZoneOffsetMinus).concat(hourOffset, ":").concat(minuteOffset);
    var fullTime = "".concat(partialTime).concat(timeOffset);
    var dateTime = "".concat(fullDate, "T").concat(fullTime);
    return dateTime;
  }
  function genErrorId() {
    var hms = moment().format('HHmmss');
    var randomStr = randomString(3);
    return hms + randomStr;
  }
  function genPlayerUniqId() {
    var time = moment().format('MMDDHHmmss');
    var randomStr = randomString(5);
    return time + randomStr;
  }
  function urlStringify(obj) {
    var keys = objectKeys(obj);
    var pairs = keys.map(function (k) {
      var str = typeof obj[k] !== 'string' ? safeJSONStringify(obj[k]) : obj[k];
      return "".concat(k, "=").concat(encodeURIComponent(str));
    });
    return pairs.join('&');
  }
  function getBoundingClientRect(ele) {
    var init = {
      width: ele.offsetWidth,
      height: ele.offsetHeight
    };
    var rect = ele.getBoundingClientRect(); // {...rect} -> {}

    var rectCopy = {};
    objectKeys(rect).forEach(function (v) {
      rectCopy[v] = rect[v];
    });
    return _objectSpread({}, init, rectCopy);
  }
  function getTooltipString(text) {
    var str = "<div class=\"mudu-reset mudu-tooltip-text-wrap\">" + "<span class=\"mudu-reset mudu-tooltip-text\">".concat(text, "</span>") + "</div>";
    return str;
  }
  function safeJSONStringify(json) {
    var cache = [];
    return JSON.stringify(json, function (key, value) {
      if (_typeof(value) === 'object' && value !== null) {
        if (cache.indexOf(value) !== -1) {
          return;
        }

        cache.push(value);
      }

      return value;
    });
  }
  function randomString() {
    var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
    var upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var lowerChars = upperChars.toLowerCase();
    var digits = '0123456789';
    var chars = upperChars + lowerChars + digits;
    var rStr = '';

    for (var i = 0; i < len; i++) {
      rStr += chars[random(0, 62)];
    }

    return rStr;
  }
  function random(start, end) {
    start = +start || 0;
    end = typeof +end === 'number' && +end ? +end : 100;
    start = Math.floor(start);
    end = Math.floor(end);

    if (start === end) {
      return start;
    }

    var gap = Math.abs(start - end);

    if (start > end) {
      start = end;
    }

    return start + Math.floor(Math.random() * gap);
  }
  function getScrenAspect() {
    return {
      width: window.screen.width,
      height: window.screen.height
    };
  }
  function isCommonNumber(num) {
    if (!is('number', num)) {
      return false;
    }

    if (isNaN(num)) {
      return false;
    }

    if (num === Infinity || num === -Infinity) {
      return false;
    }

    return true;
  }

  var index = 0;
  /**
   * event-emitter class like nodejs events module
   *
   * @class EventEmitter
   */

  var EventEmitter =
  /*#__PURE__*/
  function () {
    function EventEmitter() {
      _classCallCheck(this, EventEmitter);

      this._listeners = {};
    }
    /**
     * Subscribe an event
     *
     * @param {string} evt The event you want to subscribe
     * @param {function} listener The event handler
     * @returns {string} an id that you can use it to off the event handler
     * @memberof EventEmitter
     */


    _createClass(EventEmitter, [{
      key: "on",
      value: function on(evt, listener) {
        var id = ++index;
        this._listeners[evt] = this._listeners[evt] || [];

        this._listeners[evt].push({
          id: id,
          listener: listener,
          once: false
        });

        return id;
      }
      /**
       * Subscribe an event once
       *
       * @param {string} evt The event you want to subscribe
       * @param {function} listener The event handler
       * @returns {string} an id that you can use it to off the event handler
       * @memberof EventEmitter
       */

    }, {
      key: "once",
      value: function once(evt, listener) {
        var id = ++index;
        this._listeners[evt] = this._listeners[evt] || [];

        this._listeners[evt].push({
          id: id,
          listener: listener,
          once: true
        });

        return id;
      }
      /**
       * Unsubscribe an event
       *
       * @param {string} evt The event you want to unsubscribe
       * @param {function} listener  The event listener or id which is returned by `on` or `once`
       * @memberof EventEmitter
       */

    }, {
      key: "off",
      value: function off(evt, listener) {
        this._listeners[evt] = this._listeners[evt] || [];

        for (var i = 0; i < this._listeners[evt].length; i++) {
          var handler = this._listeners[evt][i];

          if (handler.id === listener || handler.listener === listener) {
            this._listeners[evt].splice(i, 1);

            break;
          }
        }
      }
      /**
       * Trigger an event
       *
       * @param {string} evt The event you want to trigger
       * @param {arguments} args  Event args
       * @memberof EventEmitter
       */

    }, {
      key: "trigger",
      value: function trigger(evt) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        this._listeners[evt] = this._listeners[evt] || [];

        var newListener = _toConsumableArray(this._listeners[evt]);

        isDebugMode() && console.log("[event] ".concat(this.constructor.name, " ").concat(evt, " "), safeJSONStringify([].slice.call(arguments)));

        for (var i = this._listeners[evt].length - 1; i >= 0; i--) {
          var handler = this._listeners[evt][i];

          try {
            handler.listener.apply(handler, args);
          } catch (err) {
            console.error(err);
            throw err;
          }

          if (handler.once) {
            newListener.splice(i, 1);
          }
        }

        this._listeners[evt] = newListener;
        evt !== 'all' && this.trigger.apply(this, ['all', evt].concat(args));
      }
    }, {
      key: "clear",
      value: function clear() {
        this._listeners = {};
      }
    }]);

    return EventEmitter;
  }();

  var zhCN = {
    Pause: '暂停',
    Speed: '速度',
    Normal: '正常',
    Settings: '设置',
    'Full screen': '全屏',
    'Exit full screen': '退出全屏',
    'You can try': '你可以尝试',
    'Switch to Flash': '切换到Flash',
    'Switch to HTML5': '切换到HTML5',
    Reload: '重新加载',
    'Unknown Error': '未知错误',
    'Network Error': '网络错误',
    'Media Error': '编解码错误',
    Mute: '静音',
    Unmute: '取消静音',
    Quality: '画质',
    Live: '直播',
    Autoplay: '自动播放',
    Captions: '字幕',
    'Copy debug info': '复制排错日志',
    'Upload debug info': '上传排错日志',
    'Skip ahead to live broadcast': '直接跳到现场直播'
  };
  var zhTW = {
    Pause: '暫停',
    Speed: '速度',
    Normal: '正常',
    Settings: '設置',
    'Full screen': '全螢幕',
    'Exit full screen': '結束全螢幕',
    'You can try': '妳可以嘗試',
    'Switch to Flash': '切換到Flash',
    'Switch to HTML5': '切換到HTML5',
    Reload: '重新加載',
    'Unknown Error': '未知錯誤',
    'Network Error': '網路錯誤',
    'Media Error': '編解碼錯誤',
    Mute: '靜音',
    Unmute: '解除靜音',
    Quality: '畫質',
    Live: '直播',
    Autoplay: '自動播放',
    Captions: '字幕',
    'Copy debug info': '複製偵錯資訊',
    'Upload debug info': '上傳偵錯資訊',
    'Skip ahead to live broadcast': '直接跳到現場直播'
  };
  var en = {};

  for (var key in zhCN) {
    en[key] = key;
  }

  var i18n = {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    en: en
  };
  function chooseLanguage(language, localization) {
    if (language === 'auto') {
      language = getLanguage();
    }

    var majorLang = language.split('-')[0];
    var langs = objectKeys(localization);
    var lang = langs.filter(function (v) {
      return v === language;
    })[0]; // get exactly same lang: zh-CN -> zh-CN

    if (!lang) {
      lang = langs.filter(function (v) {
        return v.indexOf(majorLang) === 0;
      })[0]; // get major same lang: en-US -> en, en -> en, en -> en-US
    }

    return lang || 'en';
  }

  function getActive() {
    var activeItem;

    for (var i = 0; i < this._config.playlist.length; i++) {
      var item = this._config.playlist[i];

      if (item.active) {
        activeItem = item;
        break;
      }
    }

    var activeSource;

    for (var _i = 0; _i < activeItem.sources.length; _i++) {
      var sour = activeItem.sources[_i];

      if (sour.active) {
        activeSource = sour;
        break;
      }
    }

    var file = activeSource.file;
    var absoluteFile = getAbsoluteUrl(file);
    var fileType = getSourceType(absoluteFile);
    var type = activeSource.type || fileType;
    var mineType = activeSource.mineType || getMinetype(type);
    var isLive = activeItem.isLive;
    var image = activeItem.image;
    var title = activeItem.title;
    var highlights = activeItem.highlights;
    var playbackMessages = activeItem.playbackMessages;
    var isTimeShift = activeSource.isTimeShift;
    var reloadAfterPausing = typeof activeItem.reloadAfterPausing === 'undefined' ? !!activeSource.reloadAfterPausing : activeItem.reloadAfterPausing;
    var reloadAfterPausingTime = typeof activeItem.reloadAfterPausingTime === 'undefined' ? activeSource.reloadAfterPausingTime : activeItem.reloadAfterPausingTime; // console.log('getActive', activeItem, activeSource)

    return {
      file: file,
      absoluteFile: absoluteFile,
      mineType: mineType,
      type: type,
      isLive: isLive,
      image: image,
      title: title,
      highlights: highlights,
      playbackMessages: playbackMessages,
      item: activeItem,
      source: activeSource,
      isTimeShift: isTimeShift,
      reloadAfterPausing: reloadAfterPausing,
      reloadAfterPausingTime: reloadAfterPausingTime
    };
  }
  function setDefaultPlayItemSourceActive(itemIndex) {
    var list = this._config.playlist;
    var len = list.length;
    var sourceIndex = 0;
    var activeItem;

    if (is('number', itemIndex) && itemIndex < len) {
      activeItem = list[itemIndex];
    } else {
      list.forEach(function (item, idx) {
        if (item.defaultPlay) {
          activeItem = item;
          itemIndex = idx;
        }
      });

      if (!activeItem) {
        activeItem = list[0];
        itemIndex = 0;
      }
    }

    activeItem.sources.forEach(function (source, idx) {
      if (source.defaultPlay) {
        sourceIndex = idx;
      }
    });
    return setActive.call(this, itemIndex, sourceIndex);
  }
  function setActive(listIndex) {
    var sourceIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var playlist = this._config.playlist;
    var success = !!playlist[listIndex];

    if (!success) {
      return success;
    }

    for (var i = 0; i < playlist.length; i++) {
      playlist[i].active = i === listIndex;

      for (var j = 0; j < playlist[i].sources.length; j++) {
        playlist[i].sources[j] = Object.assign({}, playlist[i].sources[j], {
          active: j === sourceIndex
        });
      }
    }

    return success;
  }
  function getActiveSources() {
    var activeItem;

    for (var i = 0; i < this._config.playlist.length; i++) {
      var item = this._config.playlist[i];

      if (item.active) {
        activeItem = item;
        break;
      }
    }

    return activeItem.sources;
  }
  /**
   * 设置当前倍速
   */

  function setActiveRate() {
    var rateIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var playbackRates = this._config.playbackRates;
    var success = !!playbackRates[rateIndex];

    if (!success && rateIndex !== 'null') {
      return success;
    }

    for (var i = 0; i < playbackRates.length; i++) {
      playbackRates[i].active = false;
      playbackRates[i].active = i === rateIndex;
    }

    return success;
  }
  var getAbsoluteUrl = function getAbsoluteUrl(url) {
    var a = document.createElement('a');
    a.setAttribute('href', url);
    return a.href;
  };
  var getSourceType = function getSourceType(url) {
    var httpFileExtReg = /^https?:[^?]+(\.(\w+))\??(?![.\w/])/;
    var httpRes = url.match(httpFileExtReg);
    var otherReg = /^([a-zA-Z]+):.*/;
    var otherRes = url.match(otherReg);

    if (httpRes) {
      return httpRes[2];
    }

    if (otherRes) {
      return otherRes[1];
    }

    return '';
  };
  var getMinetype = function getMinetype(type) {
    var mineTypes = {
      aac: 'audio/mp4',
      mp4: 'video/mp4',
      f4v: 'video/mp4',
      m4v: 'video/mp4',
      mov: 'video/mp4',
      // 'm4a': 'audio/x-m4a', // converted to aac by source.js
      mp3: 'audio/mpeg',
      mpeg: 'audio/mpeg',
      ogv: 'video/ogg',
      ogg: 'video/ogg',
      oga: 'video/ogg',
      vorbis: 'video/ogg',
      webm: 'video/webm',
      // The following are not expected to work in Chrome
      f4a: 'video/aac',
      m3u8: 'application/vnd.apple.mpegurl',
      m3u: 'application/vnd.apple.mpegurl',
      hls: 'application/vnd.apple.mpegurl',
      flv: 'video/x-flv',
      rtmp: 'rtmp/flv',
      // other rtmp/mp4
      dash: 'application/dash+xml',
      mpd: 'application/dash+xml'
    };
    return mineTypes[type] || '';
  };

  var providers = [];
  var extraProviders = [];
  function registerProvider(name, Provider) {
    var registerExtra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var _providers = registerExtra ? _toConsumableArray(extraProviders) : _toConsumableArray(providers);

    if (_providers.filter(function (item) {
      return name === item.name;
    }).length > 0) {
      console.warn("provider [".concat(name, "] is existed, so it will not be register twice, you can change a name and retry"));
      return;
    }

    var isHTML5 = Provider.isHTML5();
    var isFlash = Provider.isFlash();
    var isPlaybackRateSupported = Provider.isPlaybackRateSupported();

    if (isHTML5 || isFlash) {
      _providers.push({
        name: name,
        html5: isHTML5,
        flash: isFlash,
        isPlaybackRateSupported: isPlaybackRateSupported,
        Provider: Provider
      });

      if (registerExtra) {
        setDefaultOptions({
          extraProvider: _defineProperty({}, name, Provider.defaultOptions)
        });
        extraProviders = _providers;
      } else {
        setDefaultOptions({
          provider: _defineProperty({}, name, Provider.defaultOptions)
        });
        providers = _providers;
      }
    } else {
      throw new TypeError('registerProvider(name, Provider): Provider should extends HTML5Provider or FlashProvider');
    }
  }
  function registerExtraProvider(name, Provider) {
    registerProvider(name, Provider, true);
  }
  function getProviders() {
    return providers;
  }
  function getExtraProviders() {
    return extraProviders;
  }
  function getProvider(name) {
    for (var i = 0; i < providers.length; i++) {
      var p = providers[i];

      if (p.name === name) {
        return p;
      }
    }
  }
  /**
   * 过滤register过的provider
   * @param {*} name provider 注册的name
   */

  function getExtraProvider(name) {
    var filterProviders = extraProviders.filter(function (item) {
      return item.name === name;
    });

    if (filterProviders.length === 1) {
      return filterProviders[0];
    }
  }
  function getSupportProviders() {
    return getProviders().filter(function (p) {
      return p.Provider.isSupported();
    });
  }
  function getSupportExtraProviders() {
    return getExtraProviders().filter(function (exP) {
      return exP.Provider.isSupported();
    });
  }
  function sortProviders(providers, order) {
    // const nameSorted = sortNameProviders(providers, order)
    // const hfSorted = sortH5FlashProviders(nameSorted, order)
    // return hfSorted
    var orderLen = order.length;
    var html5Idx = order.indexOf('html5');
    var flashIdx = order.indexOf('flash');
    var providersWithWieght = providers.map(function (p) {
      var nameIdx = order.indexOf(p.name);
      var nameWeight = 0;
      var typeWeight = 0;

      if (nameIdx >= 0) {
        nameWeight += orderLen - nameIdx;
      }

      if (html5Idx >= 0 && p.html5) {
        typeWeight += orderLen - html5Idx;
      }

      if (flashIdx >= 0 && p.flash) {
        typeWeight += orderLen - flashIdx;
      }

      var weight = Math.max(nameWeight, typeWeight);

      if (nameWeight > 0 && typeWeight > 0) {
        // make [html5, hlsjs] get [2.5, 2] rather than [2, 2]
        weight += 0.5;
      }

      return {
        p: p,
        name: p.name,
        w: weight
      };
    });
    providersWithWieght.sort(function (pw1, pw2) {
      return pw2.w - pw1.w;
    });
    return providersWithWieght.map(function (pw) {
      return pw.p;
    });
  } // 给html5和order排序
  function chooseProvider(_ref) {
    var type = _ref.type,
        mineType = _ref.mineType,
        url = _ref.url,
        isLive = _ref.isLive,
        isTimeShift = _ref.isTimeShift;
    var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    // vr provider 不作为外部可选的播放provider
    var filteredOrder = order.filter(function (item) {
      return item !== 'vr';
    });
    var supportedProviders = getSupportProviders();
    var canPlayProviders = supportedProviders.filter(function (p) {
      var Provider = p.Provider;
      var canPlay = Provider.canPlay({
        file: url,
        type: type,
        mimeType: mineType,
        isLive: isLive,
        isTimeShift: isTimeShift
      });
      return !!canPlay;
    });
    var sortedProviders = sortProviders(canPlayProviders, filteredOrder);
    return sortedProviders[0];
  }
  function selectExtraProviders(_ref2, playerConfig) {
    var type = _ref2.type,
        mineType = _ref2.mineType,
        url = _ref2.url,
        isLive = _ref2.isLive,
        isTimeShift = _ref2.isTimeShift;
    var supportedProviders = getSupportExtraProviders();
    var canPlayProviders = supportedProviders.filter(function (p) {
      var Provider = p.Provider;
      var canPlay = Provider.canPlay({
        file: url,
        type: type,
        mimeType: mineType,
        isLive: isLive,
        isTimeShift: isTimeShift
      });
      return !!canPlay;
    });
    return canPlayProviders;
  }

  var defaultOptions = {
    // behaviors
    mute: false,
    autoplay: false,
    repeat: false,
    playbackRatesLabel: '倍速',
    // 倍速默认文字
    playbackRates: [],
    // 倍速播放
    // apperance
    controls: true,
    aspectratio: '',
    height: 270,
    width: 480,
    displaytitle: true,
    displaydescription: true,
    stretching: 'contain',
    qualityLabels: '',
    // dash中不同带宽显示的文字: 如2500-HD, 1000-SD
    // preload
    preload: 'none',
    // playlist
    playlist: [],
    // skin
    skin: {
      name: 'default',
      url: "https://static.mudu.tv/mudu-player/0.36.3/mudu-player.css"
    },
    // logo
    logo: {
      file: '',
      hide: false,
      link: '',
      marginw: '3%',
      marginh: '6%',
      width: '15%',
      height: '10%',
      opacity: 1,
      position: 'top-right'
    },
    providerOrder: ['html5', 'hlsjs'],
    // plugin配置
    plugin: {},
    // provider配置
    provider: {
      flvjs: {
        'flv.js': {
          fixAudioTimestampGap: false
        }
      }
    },
    // 非流解析类provider配置
    extraProvider: {
      vr: {
        use: false
      }
    },
    // file的文件地址
    fileCdnPath: "https://static.mudu.tv/mudu-player/0.36.3/assets",
    videoAttributes: _objectSpread({
      'x5-video-player-type': 'h5-page',
      'webkit-playsinline': 'true',
      playsinline: '',
      'x-webkit-airplay': 'allow',
      'mtt-playsinline': true
    }, isX5Layer() ? {
      loop: true
    } : {}),
    contextMenus: [{
      key: 'version',
      text: 'Mudu-player v' + "0.36.3",
      link: 'http://mudu.tv/?source=mudu-player'
    }],
    errorLogUrl: '',
    perfLogUrl: '',
    renderError: null,
    language: 'auto',
    localization: i18n,
    // subtitle
    showSubtitle: false,
    myunSyncTextTrackLabel: 'ppt_sync',
    uniqId: '',
    // 播放器唯一id, 可以通过外部传入
    enableErrorRetry: false,
    errorMaxRetry: 10,
    errorMaxRetryTimeout: 15000,
    errorRetryDelay: 3000,
    recordRestrict: {
      enable360LoneWindowCloseStream: false
    },
    bufferDetectGap: 200
  };

  function mergeOptions(options1, options2) {
    // 直接复制值
    var options = _objectSpread({}, options1, options2); // merge playbackRates


    if (is('array', options2.playbackRates)) {
      options.playbackRates = options2.playbackRates;
      options.playbackRatesLabel = options2.playbackRatesLabel || options.playbackRatesLabel;
    } // merge playlist: 直接使用options2的playlist


    options.playlist = options2.playlist; // merge providerOrder

    options.providerOrder = (is('array', options2.providerOrder) ? options2.providerOrder : options1.providerOrder).slice(); // merge skin

    var skin2 = is('object', options2.skin) ? options2.skin : {};
    options.skin = _objectSpread({}, options1.skin, skin2); // merge logo

    var logo2 = is('object', options2.logo) ? options2.logo : {};
    options.logo = _objectSpread({}, options1.logo, logo2); // merge recordRestrict

    var rr = is('object', options2.recordRestrict) ? options2.recordRestrict : {};
    options.recordRestrict = _objectSpread({}, options1.recordRestrict, rr); // merge localization

    options.localization = _objectSpread({}, options1.localization);
    objectKeys(options2.localization || {}).forEach(function (lang) {
      if (is('object', options2.localization[lang])) {
        options.localization[lang] = _objectSpread({}, options.localization.en, options1.localization[lang] || {}, options2.localization[lang]);
      }
    }); // merge videoAttributes

    var va2 = is('object', options2.videoAttributes) ? options2.videoAttributes : {};
    options.videoAttributes = _objectSpread({}, options1.videoAttributes, va2); // mrege contextMenus

    var ctm2 = is('array', options2.contextMenus) ? options2.contextMenus : [];
    options.contextMenus = _toConsumableArray(options1.contextMenus).concat(_toConsumableArray(ctm2)); // mrege plugin

    if (is('object', options2.plugin)) {
      var plugin = options1.plugin || {};

      for (var k in options2.plugin) {
        var op1 = plugin[k] || {};
        var op2 = options2.plugin[k] || {};
        plugin[k] = _objectSpread({}, op1, op2);
      }

      options.plugin = plugin;
    } // merge provider


    if (is('object', options2.provider)) {
      var provider = options1.provider || {};

      for (var _k in options2.provider) {
        var _op = provider[_k] || {};

        var _op2 = options2.provider[_k] || {};

        provider[_k] = _objectSpread({}, _op, _op2);
      }

      options.provider = provider;
    }

    return options;
  } // 处理playerlist array


  function formatPlaylist(playlist) {
    // format playlist options
    if (is('array', playlist)) {
      var ret = [];
      playlist.forEach(function (playitem) {
        var item = {};
        copyDefinedAttr(item, playitem, ['isLive', 'image', 'description', 'title', 'mediaid', 'defaultPlay', 'reloadAfterPausing', 'reloadAfterPausingTime', // 高亮的点
        'highlights', 'playbackMessages']); // [{file: ''}]

        if (is('string', playitem.file) && playitem.file !== '') {
          item.sources = [{
            file: playitem.file,
            type: playitem.type,
            mineType: playitem.mineType
          }];
          copyDefinedAttr(item.sources[0], playitem, ['type']);
          ret.push(item); // [{sources: [{file: ''}]}]
        } else if (is('array', playitem.sources) && is('object', playitem.sources[0]) && is('string', playitem.sources[0].file) && playitem.sources[0].file !== '') {
          item.sources = [];
          playitem.sources.forEach(function (sour, index) {
            if (is('string', sour.file) && sour.file !== '') {
              var source = {
                file: sour.file,
                index: index
              };
              copyDefinedAttr(source, sour, ['type', 'mineType', 'label', 'isTimeShift', 'defaultPlay', 'reloadAfterPausing', 'reloadAfterPausingTime', 'path', 'path_name']);
              item.sources.push(source);
            }
          });
          ret.push(item);
        }
      });

      if (is('array', ret) && is('object', ret[0]) && is('array', ret[0].sources) && is('object', ret[0].sources[0]) && is('string', ret[0].sources[0].file) && ret[0].sources[0].file !== '') {
        ret = ret.map(function (playlistItem) {
          playlistItem.allSources = playlistItem.sources.map(function (source) {
            return _objectSpread({}, source);
          });
          var availableSources = playlistItem.sources.filter(function (source) {
            var file = source.file;
            var absoluteFile = getAbsoluteUrl(file);
            var fileType = getSourceType(absoluteFile);
            var type = source.type || fileType;
            var mineType = source.mineType || getMinetype(type);
            var isLive = playlistItem.isLive;
            var isTimeShift = playlistItem.isTimeShift;
            var provider = chooseProvider({
              type: type,
              mineType: mineType,
              url: file,
              isLive: isLive,
              isTimeShift: isTimeShift
            }, []);
            return !!provider;
          });

          if (availableSources.length !== 0) {
            playlistItem.sources = availableSources;
          }

          return playlistItem;
        });
        return ret;
      }
    }
  } // 处理playlist


  function formatOptions(options) {
    var exceptKeys = ['type', 'mineType', 'isLive', 'file', 'image', 'description', 'title', 'playlist'];
    var ret = {}; // copy some options

    for (var i in options) {
      if (exceptKeys.indexOf(i) < 0 && options !== undefined) {
        ret[i] = options[i];
      }
    } // format playlist


    if (is('array', options.playlist)) {
      ret.playlist = formatPlaylist(options.playlist);
    } else if (is('string', options.file) && options.file) {
      var listItem = {};
      copyDefinedAttr(listItem, options, ['isLive', 'image', 'description']);
      var sourceItem = {
        file: options.file,
        type: options.type,
        mineType: options.mineType,
        label: 'default',
        isTimeShift: !!options.isTimeShift || false,
        reloadAfterPausing: !!options.reloadAfterPausing,
        reloadAfterPausingTime: options.reloadAfterPausingTime
      };
      listItem.sources = [sourceItem];
      ret.playlist = [listItem];
    }

    return ret;
  }

  function copyDefinedAttr(target, source, attributes) {
    attributes.forEach(function (attr) {
      if (!is('undefined', source[attr])) {
        target[attr] = source[attr];
      }
    });
  }

  function getDefaultOptions() {
    return defaultOptions;
  }

  function setDefaultOptions(options) {
    defaultOptions = mergeOptions(defaultOptions, formatOptions(options));
  }

  var play = 'mudu-icon-play';
  var pause = 'mudu-icon-pause';
  var volumeUp = 'mudu-icon-volume-up';
  var volumeDown = 'mudu-icon-volume-down';
  var volumeOff = 'mudu-icon-volume-off';
  var full = 'mudu-icon-fullscreen';
  var fullOff = 'mudu-icon-fullscreen-off';
  var setting = 'mudu-icon-setting';
  var loading = 'mudu-icon-load';
  var check = 'mudu-icon-check';
  var error = 'mudu-icon-error';
  var iconReg = /mudu-icon-[\w-]+/;

  var aspect = 'mudu-aspect';
  var mask = 'mudu-mask';
  var videoWrap = 'mudu-video-wrap';
  var video = 'mudu-video';
  var hideVideo = 'mudu-hide-video';
  var logoLink = 'mudu-logo-link';
  var logo = 'mudu-logo';
  var videoTitle = 'mudu-video-title';
  var danmaku = 'mudu-video-danmaku';
  var subtitle$1 = 'mudu-subtitle';
  var subtitleItem = 'mudu-subtitle-item';
  var bezel = 'mudu-bezel';
  var controllerWrap = 'mudu-controller-wrap';
  var controllerMask = 'mudu-controller-mask';
  var controllerBlank = 'mudu-controller-blank';
  var bigPlayBtn = 'mudu-big-play-btn';
  var controller = 'mudu-controller';
  var icons = 'mudu-icons';
  var iconsLeft = 'mudu-icons-left';
  var icon = 'mudu-icon';
  var switchText = 'mudu-switch-text';
  var switchSpeed = 'mudu-switch-speed';
  var switchQuality = 'mudu-switch-quality';
  var switchPath = 'mudu-switch-path';
  var volume = 'mudu-volume';
  var volumeBarWrap = 'mudu-volume-bar-wrap';
  var volumeBar = 'mudu-volume-bar';
  var volumeBarInner = 'mudu-volume-bar-inner';
  var thumb = 'mudu-thumb';
  var time = 'mudu-time';
  var ptime = 'mudu-ptime';
  var dtime = 'mudu-dtime';
  var barWrap = 'mudu-bar-wrap';
  var barPreview = 'mudu-bar-preview';
  var barPopup = 'mudu-bar-popup';
  var barPopupText = 'mudu-bar-popup-text';
  var barImg = 'mudu-bar-img';
  var barTextWrap = 'mudu-bar-text-wrap';
  var barText = 'mudu-bar-text';
  var barTextTime = 'mudu-bar-text-time';
  var barTextText = 'mudu-bar-text-text';
  var barTime = 'mudu-bar-time';
  var barTimeWrap = 'mudu-bar-time-wrap';
  var bar = 'mudu-bar';
  var loaded = 'mudu-loaded';
  var played = 'mudu-played';
  var highlight = 'mudu-highlight';
  var dot = 'mudu-dot';
  var panel = 'mudu-panel';
  var liveBadge = 'mudu-live-badge';
  var liveDot = 'mudu-live-dot';
  var iconsRight = 'mudu-icons-right';
  var bezelTrans = 'mudu-bezel-transition';
  var hidden = 'hidden';
  var flash = 'mudu-flash';
  var flashTip = 'mudu-flash-tip';
  var flashTipInner = 'mudu-flash-tip-inner';
  var errorIcon = 'mudu-error-icon';
  var errorText = 'mudu-error-text';
  var errorWrap = 'mudu-error-wrap';
  var errorInner = 'mudu-error-inner';
  var recordRestrict360 = 'mudu-restrict-360'; // background

  var background = 'mudu-background'; // popup

  var menuitem = 'mudu-menuitem';
  var menuitemLabel = 'mudu-menuitem-label';
  var contextMenuPanel = 'mudu-contextmenu-panel';
  var panelMenu = 'mudu-panel-menu';
  var menuitemContent = 'mudu-menuitem-label';
  var playRatePanel = 'mudu-play-back-rate-panel';
  var qualityWrap = 'mudu-quality-wrap';
  var pathWrap = 'mudu-path-wrap';
  var qualityMenu = 'mudu-quality-menu';
  var qualityMenuItem = 'mudu-quality-menu-item';
  var qualityItemName = 'mudu-quality-item-name';
  var pathMulti = 'mudu-path-multi';
  var qualityMenuLabel = 'mudu-quality-menu-label';
  var qualityMenuItemWrap = 'mudu-quality-menu-item-wrap'; // notice

  var notice = 'mudu-notice'; // container

  var live = 'mudu-live';
  var playback = 'mudu-playback';
  var x5Layer = 'mudu-x5-layer';
  var base = 'mudu';
  var fullscreen = 'mudu-fullscreen';
  var aspectMode = 'mudu-aspect-mode';
  var normalMode = 'mudu-normal-mode';
  var hideController = 'mudu-hide-controller';
  var hideTime = 'mudu-hide-time';
  var stateIdle = 'mudu-state-idle';
  var stateError = 'mudu-state-error';
  var stretch = 'mudu-stretch';
  var providerFlash = 'mudu-provider-flash';
  var providerHtml5 = 'mudu-provider-html5';
  var providerReady = 'mudu-provider-ready';
  var skin = 'mudu-skin';
  var mobile = 'mudu-mobile';
  var flashDisabled = 'mudu-flash-disabled';
  var hideEverything = 'mudu-hide-everything';
  var hideSetting = 'mudu-hide-setting';
  var flagDragging = 'mudu-flag-dragging';
  var flagSmallPlayer = 'mudu-flag-small-player';
  var durationValid = 'mudu-duration-valid';
  var timeShift = 'mudu-time-shift';
  var playbackRate = 'mudu-play-back-rate';
  var hidePlaybackRate = 'mudu-play-back-rate-hide';
  var showPlaybackRate = 'mudu-play-back-rate-show';
  var vrMode = 'mudu-player-vr-mode'; // 表示当前播放的是时移视频，并且在观看直播，而不是时移回看

  var timeShiftLive = 'mudu-time-shift-live'; // container reg

  var stateReg = /mudu-state-\w+/;
  var stretchReg = /mudu-stretch-\w+/;
  var providerReg = /mudu-provider-\w+/;
  var playrateReg = /mudu-play-back-rate-\w+/; // icon

  var fakefullscreenIcon = 'mudu-fakefullscreen-icon';
  var bezelIcon = 'mudu-bezel-icon';
  var loadingIcon = 'mudu-loading-icon';
  var captionIcon = 'mudu-caption-icon';
  var settingIcon = 'mudu-setting-icon';
  var fullscreenIcon = 'mudu-fullscreen-icon';
  var playIcon = 'mudu-play-icon';
  var volumeIcon = 'mudu-volume-icon'; // extra class

  var hide = 'mudu-hide';
  var active = 'mudu-active';
  var reset = 'mudu-reset';

  var loaders = {}; // url: {loader, isStyle}

  var STATUS = {
    NEW: 0,
    LOADING: 1,
    ERROR: 2,
    COMPLETE: 3
  };

  var ScriptLoader =
  /*#__PURE__*/
  function (_EventEmitter) {
    _inherits(ScriptLoader, _EventEmitter);

    function ScriptLoader(url) {
      var _this2;

      var isStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _classCallCheck(this, ScriptLoader);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ScriptLoader).call(this));
      _this2.url = url;
      _this2.isStyle = isStyle;
      _this2.status = STATUS.NEW;
      return _this2;
    }

    _createClass(ScriptLoader, [{
      key: "getElement",
      value: function getElement() {
        if (this.isStyle) {
          var link = document.createElement('link');
          link.type = 'text/css';
          link.rel = 'stylesheet';
          link.href = this.url;
          return link;
        } else {
          var scriptTag = document.createElement('script');
          scriptTag.src = this.url;
          return scriptTag;
        }
      }
    }, {
      key: "getStatus",
      value: function getStatus() {
        return this.status;
      }
    }, {
      key: "load",
      value: function load() {
        var _this3 = this;

        if (this.status !== STATUS.NEW) {
          Promise.reject(new Error('loader.load can only call once'));
        }

        var sameLoader = loaders[this.url];

        if (sameLoader && sameLoader.isStyle === this.isStyle) {
          var status = sameLoader.loader.getStatus();

          if (status === STATUS.COMPLETE) {
            setTimeout(function () {
              _this3.trigger('done');
            }, 0);
            return Promise.resolve();
          }
        }

        var head = document.getElementsByTagName('head')[0] || document.documentElement;
        var ele = this.getElement();

        var _this = this;

        return new Promise(function (resolve, reject) {
          // `done`防止onload和onreadystatechange都被调用(ie9)
          var done = false;

          ele.onload = ele.onreadystatechange = function (evt) {
            if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
              ele.onload = ele.onreadystatechange = null;
            }

            done = true; // 在script中的js执行完后的事件循环中resolve, 保证脚本可用

            setTimeout(function () {
              _this.trigger('done');

              _this.status = STATUS.COMPLETE;
              resolve();
            }, 0);
          };

          ele.onerror = function (evt) {
            _this.trigger('error');

            reject(evt);
          };

          head.insertBefore(ele, head.firstChild);
          _this.status = STATUS.LOADING;
          loaders[_this.url] = {
            isStyle: _this.isStyle,
            loader: _this
          };
        });
      }
    }]);

    return ScriptLoader;
  }(EventEmitter);

  var INTERNAL_OPTION_MERGED = 'internal_option_merged';
  var INTERNAL_DOM_INITED = 'internal_dom_inited';
  var INTERNAL_MODEL_INITED = 'internal_model_inited';
  var INTERNAL_PLUGIN_INITED = 'internal_plugin_inited';
  var INTERNAL_PROVIDER_INITED = 'internal_provider_inited';
  var INTERNAL_PROVIDER_REMOVED = 'internal_provider_removed';
  var INTERNAL_PROVIDER_INIT = 'internal_plugin_init';
  var INTERNAL_STATUS_FORMATED = 'internal_status_formated';
  var INTERNAL_KEY_DOWN = 'internal_key_down';
  var INTERNAL_STYLE_LOADED = 'internal_style_loaded';
  var OUTER_CONTEXT_MENU_CLICK = 'contextMenuClick';
  var OUTER_PLAY = 'play';
  var OUTER_PAUSE = 'pause';
  var OUTER_CONTROLS = 'controls';
  var OUTER_CONTROLS_VISIBLE = 'controlsVisible';
  var OUTER_FULLSCREEN = 'fullscreen';
  var OUTER_COMPLETE = 'complete';
  var OUTER_PLAYLIST_COMPLETE = 'playlistComplete';
  var OUTER_PLAYLIST = 'playlist';
  var OUTER_PLAYLIST_ITEM = 'playlistItem';
  var OUTER_SWITCH_QUALITY = 'switchQuality';
  var OUTER_TIME = 'time';
  var OUTER_DURATION = 'duration';
  var OUTER_RESIZE = 'resize';
  var OUTER_BUFFER = 'buffer';
  var OUTER_IDLE = 'idle';
  var OUTER_BEFORE_PLAY = 'beforePlay';
  var OUTER_MUTE = 'mute';
  var OUTER_VOLUME = 'volume';
  var OUTER_CAN_SEEK = 'canSeek';
  var OUTER_SEEK = 'seek';
  var OUTER_SEEKED = 'seeked';
  var OUTER_ERROR = 'error';
  var OUTER_TEXT_TRACK_CHANGE = 'textTrackChange';
  var OUTER_TEXT_TRACK_ADD = 'textTrackAdd';
  var OUTER_TEXT_TRACK_CUE_CHANGE = 'textTrackCueChange';
  var OUTER_LIVE_END_DETECT = 'liveEndDetect';
  var PROVIDER_ENDED = 'ended';
  var PROVIDER_BUFFER_CHANGE = 'bufferchange';
  var PROVIDER_TIME_UPDATE = 'timeupdate';
  var PROVIDER_DURATION = 'duration';
  var PROVIDER_STAGE_CLICK = 'stageclick';
  var PROVIDER_STAGE_DOUBLE_CLICK = 'stagedoubleclick';
  var PROVIDER_PLAY = 'play';
  var PROVIDER_PAUSE = 'pause';
  var PROVIDER_MUTE = 'mute';
  var PROVIDER_VOLUME = 'volume';
  var PROVIDER_SEEKED = 'seeked';
  var PROVIDER_SEEK = 'seek';
  var PROVIDER_ERROR = 'error';
  var PROVIDER_LOADEDDATA = 'loadeddata';
  var PROVIDER_WAITING = 'waiting';
  var PROVIDER_TEXTTRACKADD = 'texttrackadd';
  var PROVIDER_TEXTTRACKCHANGE = 'texttrackchange';
  var PROVIDER_CUECHANGE = 'cuechange';

  function initDom() {
    var _this = this;

    var container = this._container;
    var dom = this.dom;
    classList(container).add(hideEverything); // load skin style

    var skin$$1 = this._config.skin;
    var styleLoader = new ScriptLoader(skin$$1.url, true);
    styleLoader.load().then(function () {
      classList(container).remove(hideEverything);

      _this.trigger(INTERNAL_STYLE_LOADED);
    }); // const skinname = this._config.skin.name

    var domString = getDomString(this._status.localization, this._config.fileCdnPath);
    container.innerHTML = domString;
    classList(container).add(reset);
    classList(container).add(base);
    classList(container).add(hideSetting);
    classList(container).add("".concat(skin, "-").concat(skin$$1.name));
    isMobile() && classList(container).add(mobile);
    dom.container = container;
    dom.aspect = container.querySelector(".".concat(aspect));
    dom.fullscreen = container.querySelector(".".concat(fullscreenIcon));
    dom.caption = container.querySelector(".".concat(captionIcon));
    dom.video = container.querySelector('video');
    dom.videoWrap = container.querySelector(".".concat(videoWrap));
    dom.controllerWrap = container.querySelector(".".concat(controllerWrap));
    dom.controller = container.querySelector(".".concat(controller));
    dom.controllerMask = container.querySelector(".".concat(controllerMask));
    dom.controllerBlank = container.querySelector(".".concat(controllerBlank));
    dom.controllerRightIcons = container.querySelector(".".concat(iconsRight));
    dom.leftPlayBtn = container.querySelector(".".concat(playIcon));
    dom.volumeWrap = container.querySelector(".".concat(volume));
    dom.volumeButton = container.querySelector(".".concat(volumeIcon));
    dom.volumeBar = container.querySelector(".".concat(volumeBarInner));
    dom.volumeBarWrap = container.querySelector(".".concat(volumeBar));
    dom.volumeBarWrapWrap = container.querySelector(".".concat(volumeBarWrap));
    dom.playedBar = container.querySelector(".".concat(played));
    dom.loadedBar = container.querySelector(".".concat(loaded));
    dom.playedBarWrap = container.querySelector(".".concat(barWrap));
    dom.barPopup = container.querySelector(".".concat(barPopup));
    dom.barImg = container.querySelector(".".concat(barImg));
    dom.barTime = dom.playedBarTime = container.querySelector(".".concat(barTime));
    dom.barText = container.querySelector(".".concat(barText));
    dom.barTextTime = container.querySelector(".".concat(barTextTime));
    dom.barTextText = container.querySelector(".".concat(barTextText));
    dom.ptime = container.querySelector(".".concat(ptime));
    dom.dtime = container.querySelector(".".concat(dtime));
    dom.logoWrap = container.querySelector(".".concat(logo));
    dom.logoImg = container.querySelector(".".concat(logo, " img"));
    dom.logoLink = container.querySelector(".".concat(logoLink));
    dom.bezel = container.querySelector(".".concat(bezelIcon));
    dom.background = container.querySelector(".".concat(background));
    dom.title = container.querySelector(".".concat(videoTitle));
    dom.settingBtn = container.querySelector(".".concat(settingIcon));
    dom.errorWrap = container.querySelector(".".concat(errorWrap));
    dom.errorText = container.querySelector(".".concat(errorText));
    dom.highlight = container.querySelector(".".concat(highlight));
    dom.flashTip = container.querySelector(".".concat(flashTip));
    dom.flash = container.querySelector(".".concat(flash));
    dom.notice = container.querySelector(".".concat(notice));
    dom.switchQuality = container.querySelector(".".concat(switchQuality));
    dom.switchPath = container.querySelector(".".concat(switchPath));
    dom.bigPlayBtn = container.querySelector(".".concat(bigPlayBtn));
    dom.recordRestrict360 = container.querySelector(".".concat(recordRestrict360));
    dom.liveBadge = container.querySelector(".".concat(liveBadge));
    dom.playbackRate = container.querySelector(".".concat(playbackRate));
    this.trigger(INTERNAL_DOM_INITED);
  }
  function destroyDom() {
    this._container.innerHTML = '';
    classList(this._container).remove(/mudu-.*/);
    classList(this._container).remove('mudu');
  }

  function getDomString(lang, fileCdnPath) {
    /* prettier-ignore */
    var dom = "<style>" + ".mudu.".concat(hideEverything, " {background: #000;}") + ".mudu.".concat(hideEverything, " div {display: none !important;}") + ".mudu.".concat(hideEverything, " span {display: none !important;}") + ".mudu.".concat(hideEverything, " button {display: none !important;}") + "@font-face{font-family:'mudu-icons';src:url(\"".concat(fileCdnPath, "/fonts/mudu-icons.eot?yyls80\");src:url(\"").concat(fileCdnPath, "/fonts/mudu-icons.eot?yyls80#iefix\") format(\"embedded-opentype\"),url(\"").concat(fileCdnPath, "/fonts/mudu-icons.ttf?yyls80\") format(\"truetype\"),url(\"").concat(fileCdnPath, "/fonts/mudu-icons.woff?yyls80\") format(\"woff\"),url(\"").concat(fileCdnPath, "/fonts/mudu-icons.svg?yyls80#mudu-icons\") format(\"svg\");font-weight:normal;font-style:normal}") + "</style>" + "<div class=\"".concat(reset, " ").concat(aspect, "\"></div>") + "<div class=\"".concat(reset, " ").concat(mask, "\"></div>") + "<div class=\"".concat(reset, " ").concat(videoWrap, "\">") + "<div class=\"".concat(reset, " ").concat(flash, "\"></div>") + "<div class=\"".concat(reset, " ").concat(background, "\"></div>") + "<div class=\"".concat(reset, " ").concat(bezel, "\">") + "<span class=\"".concat(reset, " ").concat(bezelIcon, "\"></span>") + "<span class=\"".concat(reset, " ").concat(loadingIcon, " ").concat(loading, "\"></span>") + "</div>" + "</div>" + "<div class=\"".concat(reset, " ").concat(logo, "\">") + "<a class=\"".concat(reset, " ").concat(logoLink, "\" target=\"_blank\"><img style=\"display: none;\" /></a>") + "</div>" + "<div class=\"".concat(reset, " ").concat(danmaku, "\"></div>") + "<div class=\"".concat(reset, " ").concat(errorWrap, "\">") + "<div class=\"".concat(reset, " ").concat(errorInner, "\">") + "<div class=\"".concat(reset, " ").concat(errorIcon, "\"><span class=\"").concat(reset, " ").concat(error, "\"></span></div>") + "<div class=\"".concat(reset, " ").concat(errorText, "\">There is some error: </div>") + "</div>" + "</div>" + "<div class=\"".concat(reset, " ").concat(controllerWrap, "\">") + "<div class=\"".concat(reset, " ").concat(controllerBlank, "\"></div>") + "<div class=\"".concat(reset, " ").concat(videoTitle, "\"></div>") + "<div class=\"".concat(reset, " ").concat(bigPlayBtn, "\">") + "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(play, "\"></button>") + "</div>" + "<div class=\"".concat(subtitle$1, "\">") + "</div>" + "<div class=\"".concat(reset, " ").concat(controllerMask, "\"></div>") + "<div class=\"".concat(reset, " ").concat(controller, "\">") + // icons left
    "<div class=\"".concat(reset, " ").concat(icons, " ").concat(iconsLeft, "\">") + // `<button type="button" class="${cssClass.reset} ${cssClass}-icon ${cssClass}-prev-icon"><-</button>` +
    "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(playIcon, "\">") + "</button>" + // `<button type="button" class="${cssClass.reset} ${cssClass}-icon ${cssClass}-next-icon">-></button>` +
    "<div class=\"".concat(reset, " ").concat(volume, "\">") + "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(volumeIcon, "\" mudu-tooltip placement=\"top\" tooltip-title=\"").concat(lang['Mute'], "\">") + "</button>" + "<div class=\"".concat(reset, " ").concat(volumeBarWrap, "\">") + "<div class=\"".concat(reset, " ").concat(volumeBar, "\">") + "<div class=\"".concat(reset, " ").concat(volumeBarInner, "\">") + "<span class=\"".concat(reset, " ").concat(thumb, "\" style=\"background: #b7daff;\">") + "</span>" + "</div>" + "</div>" + "</div>" + "</div>" + "<span class=\"".concat(reset, " ").concat(liveBadge, "\" mudu-tooltip placement=\"top\" tooltip-title=\"").concat(lang['Skip ahead to live broadcast'], "\">") + "<span class=\"".concat(reset, " ").concat(liveDot, "\"></span>") + "Live" + "</span>" + "<span class=\"".concat(reset, " ").concat(time, "\">") + "<span class=\"".concat(reset, " ").concat(ptime, "\"></span>") + " / " + "<span class=\"".concat(reset, " ").concat(dtime, "\"></span>") + "</span>" + "</div>" + // icons right
    "<div class=\"".concat(reset, " ").concat(icons, " ").concat(iconsRight, "\">") + "<span role=\"button\" class=\"".concat(reset, " ").concat(switchText, " ").concat(switchPath, "\"></span>") + "<span role=\"button\" class=\"".concat(reset, " ").concat(switchText, " ").concat(switchQuality, "\"></span>") + "<span role=\"button\" class=\"".concat(reset, " ").concat(switchText, " ").concat(playbackRate, " ").concat(switchSpeed, "\"></span>") + "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(captionIcon, "\"></button>") + "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(settingIcon, " ").concat(setting, "\"></button>") + "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(fullscreenIcon, "\" mudu-tooltip placement=\"top\" tooltip-title=\"").concat(lang['Full screen'], "\"></button>") + "</div>" + "<div class=\"".concat(reset, " ").concat(barWrap, "\">") + "<div class=\"".concat(reset, " ").concat(barPopup, " ").concat(hidden, "\">") + "<div class=\"".concat(reset, " ").concat(barPreview, "\">") + "<div class=\"".concat(reset, " ").concat(barImg, "\"></div>") + "<div class=\"".concat(reset, " ").concat(barTimeWrap, "\">") + "<div class=\"".concat(reset, " ").concat(barTime, "\"></div>") + "</div>" + "</div>" + "<div class=\"".concat(reset, " ").concat(barTextWrap, "\">") + "<div class=\"".concat(reset, " ").concat(barText, "\">") + "<span class=\"".concat(reset, " ").concat(barTextTime, "\"></span>") + "<span class=\"".concat(reset, " ").concat(barTextText, "\"></span>") + "</div>" + "</div>" + "</div>" + "<div class=\"".concat(reset, " ").concat(bar, "\">") + "<div class=\"".concat(reset, " ").concat(loaded, "\"></div>") + "<div class=\"".concat(reset, " ").concat(played, "\" style=\"background: #f00;\">") + "<span class=\"".concat(reset, " ").concat(thumb, "\" style=\"background: #f00;\"></span>") + "</div>" + "<div class=\"".concat(reset, " ").concat(highlight, "\"></div>") + "</div>" + "</div>" + "</div>" + "</div>" + "<div class=\"".concat(reset, " ").concat(flashTip, "\">") + "<div class=\"".concat(reset, " ").concat(flashTipInner, "\"><a href=\"http://www.adobe.com/go/getflash\" target=\"_blank\">\u68C0\u6D4B\u5230\u60A8\u8FD8\u672A\u5B89\u88C5flash, \u8BF7\u70B9\u51FB\u8FD9\u91CC\u5B89\u88C5</a></div>") + "</div>" + "<div class=\"".concat(reset, " ").concat(notice, " ").concat(hide, "\"></div>") + "<div class=\"".concat(reset, " ").concat(recordRestrict360, " ").concat(hide, "\"></div>");
    return dom;
  }

  function Delegator(proto, target) {
    if (!(this instanceof Delegator)) return new Delegator(proto, target);
    this.proto = proto;
    this.target = target;
  }

  Delegator.prototype.method = function (name) {
    var proto = this.proto;
    var target = this.target;

    proto[name] = function () {
      if (isDebugMode()) {
        console.log("[delegates]: (".concat(proto.constructor.name, " | ").concat(target.constructor.name, ").").concat(name, " --"), safeJSONStringify([].slice.call(arguments)));
      } // for log


      target.TAG === 'model' && this.trigger('delegate-model', {
        fn: name,
        args: [].slice.call(arguments)
      });
      return target[name].apply(target, arguments);
    };

    return this;
  };

  var Model =
  /*#__PURE__*/
  function () {
    function Model(player) {
      _classCallCheck(this, Model);

      this.player = player;
      this.lang = player._status.localization;
      this.m_player_events = [];
      this.m_dom_events = [];
      this.m_provider_events = [];
      this.m_removed = false;
      this.TAG = 'model';
    }
    /**
     * get provider instance
     * @returns @link{Provider}
     */


    _createClass(Model, [{
      key: "provider",
      value: function provider() {
        return this.player._provider && this.player._provider.instance;
      }
      /**
       * 清除model时会调用该方法
       */

    }, {
      key: "remove",
      value: function remove() {
        var _this = this;

        this.m_removed = true;
        this.m_player_events.forEach(function (v) {
          return _this.player.off(v.evt, v.fn);
        });
        this.m_dom_events.forEach(function (v) {
          return removeEventListener(v.ele, v.evt, v.fn);
        });
        this.m_provider_events.forEach(function (v) {
          if (_this.provider()) {
            _this.provider().off(v.evt, v.fn);
          }
        });
      }
    }, {
      key: "onPlayer",
      value: function onPlayer(evt, fn) {
        this.player.on(evt, fn);
        this.m_player_events.push({
          evt: evt,
          fn: fn
        });
      }
    }, {
      key: "oncePlayer",
      value: function oncePlayer(evt, fn) {
        this.player.once(evt, fn);
        this.m_player_events.push({
          evt: evt,
          fn: fn
        });
      }
    }, {
      key: "onDom",
      value: function onDom(ele, evt, fn) {
        addEventListener(ele, evt, fn);

        if (ele === this.player.dom.container) {
          this.m_dom_events.push({
            ele: ele,
            evt: evt,
            fn: fn
          });
        }
      }
    }, {
      key: "onProvider",
      value: function onProvider(evt, fn) {
        if (this.provider()) {
          this.provider().on(evt, fn);
          this.m_provider_events.push({
            evt: evt,
            fn: fn
          });
        }
      }
    }, {
      key: "onceProvider",
      value: function onceProvider(evt, fn) {
        if (this.provider()) {
          this.provider().once(evt, fn);
          this.m_provider_events.push({
            evt: evt,
            fn: fn
          });
        }
      }
    }]);

    return Model;
  }();

  var fn = function () {
    var val;
    var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], // New WebKit
    ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // Old WebKit (Safari 5.1)
    ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
    var i = 0;
    var l = fnMap.length;
    var ret = {};

    for (; i < l; i++) {
      val = fnMap[i];

      if (val && val[1] in document) {
        for (i = 0; i < val.length; i++) {
          ret[fnMap[0][i]] = val[i];
        }

        return ret;
      }
    }

    return false;
  }();

  function requestFullscreen(ele) {
    ele[fn.requestFullscreen]();
  }
  function exitFullscreen() {
    document[fn.exitFullscreen]();
  }
  function isSupported() {
    return Boolean(document[fn.fullscreenEnabled]);
  }
  function onChange(cb) {
    addEventListener(document, fn.fullscreenchange, cb);
  }
  function offChange(cb) {
    removeEventListener(document, fn.fullscreenchange, cb);
  }
  function getElement() {
    return document[fn.fullscreenElement];
  }

  var defaultConfig = {
    trigger: 'hover',
    placement: 'top',
    container: document.body,
    distance: 10,
    content: '',
    getMaxHeight: function getMaxHeight() {
      return 'none';
    },
    "class": 'mudu-tooltip'
  };
  var hideLeft = '-20000px';
  var events = new EventEmitter();
  var tooltips = [];

  function init() {
    addEventListener(document, 'mouseover', function (e) {
      var ele = e.target || e.srcElement;

      if (isTooltipTrigger(ele)) {
        events.trigger('mouseover', e, ele);
      }
    });
    addEventListener(document, 'mouseout', function (e) {
      var ele = e.target || e.srcElement;

      if (isTooltipTrigger(ele)) {
        events.trigger('mouseout', e, ele);
      }
    });
    addEventListener(document, 'click', function (e) {
      var ele = e.target || e.srcElement;

      if (isAnyShow()) {
        hideAll();
        return;
      }

      if (isTooltipTrigger(ele)) {
        events.trigger('click', e, ele);
      }
    });
  }

  function isAnyShow() {
    return tooltips.filter(function (t) {
      return t.isShow();
    }).length > 0;
  }

  function isAnyClassShow(className) {
    return tooltips.filter(function (t) {
      return t.isShow() && t.getConfig()["class"] === className;
    }).length > 0;
  }

  function hideAll() {
    tooltips.forEach(function (t) {
      return t.hide();
    });
  }

  function isTooltipTrigger(ele) {
    return ele && ele.getAttribute('mudu-tooltip') === '';
  }

  function tooltip$1(ele) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    ele = typeof ele === 'string' && ele ? document.querySelector(ele) : ele;
    config = _objectSpread({}, defaultConfig, config);
    ele && ele.setAttribute('mudu-tooltip', '');
    var tooltipEnable = true;
    var tooltipDom = createTooltipDom();
    updateContent(config.content);
    var mouseover = events.on('mouseover', function (_, target) {
      if (target !== ele) {
        return;
      }

      if (config.trigger !== 'hover') {
        return;
      }

      tooltipEnable && show();
    });
    var mouseout = events.on('mouseout', function (_, target) {
      if (target !== ele) {
        return;
      }

      if (config.trigger !== 'hover') {
        return;
      }

      hide();
    });
    var click = events.on('click', function (_, target) {
      if (target !== ele) {
        return;
      }

      if (config.trigger !== 'click') {
        return;
      }

      tooltipEnable && show();
    });

    var getConfig = function getConfig() {
      return _objectSpread({}, config);
    };

    var ret = {
      hide: hide,
      isShow: isShow,
      destroy: destroy,
      getTooltipContainer: getTooltipContainer,
      updateContent: updateContent,
      show: show,
      getConfig: getConfig,
      disable: disable,
      enable: enable
    };
    tooltips.push(ret);
    return ret;

    function disable() {
      tooltipEnable = false;
      hide();
    }

    function enable() {
      tooltipEnable = true;
    }

    function createTooltipDom() {
      var div = document.createElement('div');
      config.container.appendChild(div);
      div.setAttribute('class', 'mudu-reset ' + config["class"]);
      addEventListener(div, 'click', function (e) {
        e.stopPropagation && e.stopPropagation();
        e.cancelBubble = true;
      });
      div.style.cssText = "position: absolute; top: 0; left: ".concat(hideLeft, "; opacity: 0; visibility: hidden;");
      return div;
    }

    function isShow() {
      return tooltipDom && tooltipDom.style.left !== hideLeft;
    }

    function destroy() {
      var idx = tooltips.indexOf(ret);

      if (idx < 0) {
        return;
      }

      events.off('mouseover', mouseover);
      events.off('mouseout', mouseout);
      events.off('click', click);
      tooltipDom.parentElement.removeChild(tooltipDom);
      ele && ele.removeAttribute('mudu-tooltip');
      tooltips.splice(idx, 1);
    }

    function updateContent(ele) {
      if (typeof ele === 'string') {
        tooltipDom.innerHTML = ele;
      }

      if (_typeof(ele) === 'object') {
        tooltipDom.innerHTML = '';
        tooltipDom.appendChild(ele);
      }
    }

    function show() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          left = _ref.left,
          top = _ref.top;

      updateMaxHeight();

      if (left === undefined && top === undefined) {
        if (config.placement === 'top') {
          var containerRect = getBoundingClientRect(config.container);
          var tooltipRect = getBoundingClientRect(tooltipDom);
          var eleRect = getBoundingClientRect(ele);
          var distance = config.distance;
          left = eleRect.left + eleRect.width / 2 - tooltipRect.width / 2 - containerRect.left;
          top = eleRect.top - tooltipRect.height - distance - containerRect.top;

          if (left + tooltipRect.width > containerRect.right) {
            // 右侧防止溢出
            left = containerRect.right - tooltipRect.width;
          }

          if (left < 0) {
            // 左侧防止溢出
            left = containerRect.left;
          }
        }
      }

      tooltipDom.style.left = left + 'px';
      tooltipDom.style.top = top + 'px';
      tooltipDom.style.visibility = 'visible';
      tooltipDom.style.opacity = 1;
    }

    function updateMaxHeight() {
      var containerRect = getBoundingClientRect(config.container);
      var maxHeight = config.getMaxHeight(containerRect);
      tooltipDom.style.maxHeight = cssLength(maxHeight);
    }

    function getTooltipContainer() {
      return tooltipDom;
    }

    function hide() {
      if (tooltipDom) {
        tooltipDom.style.left = hideLeft;
        tooltipDom.style.opacity = 0;
        tooltipDom.style.visibility = 'hidden';
      }
    }
  }

  tooltip$1.isAnyShow = isAnyShow;
  tooltip$1.hideAll = hideAll;
  tooltip$1.isAnyClassShow = isAnyClassShow;
  init();

  var Fullsreen =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Fullsreen, _Model);

    function Fullsreen(player) {
      var _this;

      _classCallCheck(this, Fullsreen);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Fullsreen).call(this, player));
      _this.isFullscreen = false;

      _this.subEvents();

      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getFullscreen').method('setFullscreen');
      classList(_this.player.dom.fullscreen).add(full);
      _this.fullTip = tooltip$1(_this.player.dom.fullscreen, {
        content: getTooltipString(_this.lang['Full screen']),
        container: _this.player.dom.container
      });
      return _this;
    }

    _createClass(Fullsreen, [{
      key: "subEvents",
      value: function subEvents() {
        var _this2 = this;

        this.onDom(this.player.dom.fullscreen, 'click', function () {
          _this2.setFullscreen(!_this2.isFullscreen);
        });
        this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
          _this2.onProvider(PROVIDER_STAGE_DOUBLE_CLICK, function () {
            _this2.setFullscreen(!_this2.isFullscreen);
          });
        });

        this.handleFullscreenChange = function (e) {
          var fullEle = getElement(); // 硬件全屏分:
          // 1. 纯硬件全屏: 全屏元素为硬件元素即为null, 且isFullscreen状态不会变更
          // 2. 微信硬件全屏: 全屏是video全屏
          // 非硬件全屏: 全屏的时候是wrap全屏
          // 硬件全屏不做全屏处理，全部交给系统去做

          if (isMobile() && (!fullEle && !_this2.isFullscreen || fullEle && fullEle.nodeName === 'VIDEO')) {
            return;
          } // 全屏元素不是当前元素
          // 分情况
          // 1. 有全屏元素且相等且非全屏状态(开启全屏) + 无全屏元素且全屏状态(退出全屏)，则进行操作
          // 2. 其余都不操作


          if (fullEle && fullEle === _this2.player.dom.container && !_this2.isFullscreen || !fullEle && _this2.isFullscreen) {
            _this2.isFullscreen = fullEle === _this2.player.dom.container;

            _this2.onAfterFullScreen();
          }
        };

        isSupported() && onChange(this.handleFullscreenChange);

        if (!isMobile()) {
          this.onDom(this.player.dom.videoWrap, 'dblclick', function () {
            if (_this2.player._provider && _this2.player._provider.flash) {
              return;
            }

            _this2.player.getControls() && _this2.toggle();
          });
        }
      }
    }, {
      key: "onAfterFullScreen",
      value: function onAfterFullScreen() {
        var dom = this.player.dom;
        this.player.trigger(OUTER_FULLSCREEN, {
          type: OUTER_FULLSCREEN,
          fullscreen: this.isFullscreen
        });
        classList(dom.container).toggle(fullscreen);
        classList(dom.fullscreen).remove(iconReg);
        classList(dom.fullscreen).add(this.isFullscreen ? fullOff : full);
        this.fullTip.updateContent(getTooltipString(this.isFullscreen ? this.lang['Exit full screen'] : this.lang['Full screen']));
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.setFullscreen(!this.getFullscreen());
      }
    }, {
      key: "getFullscreen",
      value: function getFullscreen() {
        return this.isFullscreen;
      }
    }, {
      key: "remove",
      value: function remove() {
        isSupported() && offChange(this.handleFullscreenChange);

        _get(_getPrototypeOf(Fullsreen.prototype), "remove", this).call(this);
      }
    }, {
      key: "setFullscreen",
      value: function setFullscreen() {
        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var container = this.player.dom.container;
        var isFullscreen$$1 = this.isFullscreen;
        var videoElem = this.player.dom.container.querySelector(".".concat(video)); // VR使用中

        var vrDom = this.player._config.extraProvider['vr'].use && this.player.dom.videoWrap.querySelector('canvas');
        var vrProvider = this.player._extraProviders.vr;
        var isVRInUse = vrProvider && vrDom;

        if (isVRInUse || isSupported()) {
          if (status) {
            !isFullscreen$$1 && requestFullscreen(container);
          } else {
            isFullscreen$$1 && exitFullscreen();
          }
        } else {
          if (isMobile() && videoElem.webkitSupportsFullscreen) {
            if (status) {
              videoElem.webkitEnterFullScreen();
            } else {
              videoElem.webkitExitFullScreen();
            }
          } else {
            this.isFullscreen = status;
            this.onAfterFullScreen();
          }
        }
      }
    }]);

    return Fullsreen;
  }(Model);

  var getOverrideError = function getOverrideError() {
    return new Error('method should be override');
  };

  var Provider =
  /*#__PURE__*/
  function (_EventEmitter) {
    _inherits(Provider, _EventEmitter);

    function Provider(player, option) {
      var _this;

      _classCallCheck(this, Provider);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this));
      _this.player = player;
      _this.option = option;
      _this.p_player_events = [];
      _this.p_dom_events = [];
      _this.p_self_events = [];
      _this.TAG = 'Provider';
      return _this;
    }

    _createClass(Provider, [{
      key: "loadFiles",
      value: function loadFiles() {
        return Promise.resolve();
      }
    }, {
      key: "getMediaElement",
      value: function getMediaElement() {}
    }, {
      key: "createMediaElement",
      value: function createMediaElement() {}
    }, {
      key: "setup",
      value: function setup() {
        return Promise.reject(getOverrideError());
      }
    }, {
      key: "remove",
      value: function remove() {
        var _this2 = this;

        this.p_player_events.forEach(function (v) {
          return _this2.player.off(v.evt, v.fn);
        });
        this.p_dom_events.forEach(function (v) {
          return removeEventListener(v.ele, v.evt, v.fn);
        });
        this.p_self_events.forEach(function (v) {
          return _this2.off(v.evt, v.fn);
        });
      }
      /**
       * 获取音量 Get volume
       * @returns {number} the volume
       * @memberof Provider
       */

    }, {
      key: "getVolume",
      value: function getVolume() {}
      /**
       * 设置音量 Set volume
       * @param {number} volume range: 0 ~ 1
       * @memberof Provider
       */

    }, {
      key: "setVolume",
      value: function setVolume() {}
    }, {
      key: "getMute",
      value: function getMute() {}
    }, {
      key: "setMute",
      value: function setMute() {}
    }, {
      key: "getWidth",
      value: function getWidth() {
        return -1;
      }
    }, {
      key: "getHeight",
      value: function getHeight() {
        return -1;
      }
    }, {
      key: "getMetrics",
      value: function getMetrics() {
        return {};
      }
    }, {
      key: "getBuffer",
      value: function getBuffer() {
        return [];
      }
      /**
       * 获取视频播放节点 Get video played position
       * @returns {number} the player's played position
       * @memberof Provider
       */

    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {}
      /**
       * 获取视频长度 Get video duration
       * @returns {number} video duration in millisecond
       * @memberof Provider
       */

    }, {
      key: "getDuration",
      value: function getDuration() {}
      /**
       * 设置视频拉伸方式 Set the video stretching style
       * @param {string} style
       * @memberof Provider
       */

    }, {
      key: "setStretching",
      value: function setStretching() {}
      /**
       * 获取视频拉伸方式 Get the video stretching style
       * @returns {string} video stretching style
       * @memberof Provider
       */

    }, {
      key: "getStretching",
      value: function getStretching() {}
      /**
       * 获取视频的metadata Get video metadata
       * @returns {object}
       * @memberof Provider
       */

    }, {
      key: "getMetadata",
      value: function getMetadata() {}
      /**
       * 播放视频 Play the video
       * @memberof Provider
       */

    }, {
      key: "play",
      value: function play() {}
      /**
       * 暂停播放 Pause the video
       * @memberof Provider
       */

    }, {
      key: "pause",
      value: function pause() {}
      /**
       * 跳转进度 Set played position
       * @param {number} time position in millisecond
       */

    }, {
      key: "seek",
      value: function seek() {}
      /**
       * 获取播放速率
       */

    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {}
      /**
       * 设置播放速率
       */

    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate() {}
      /**
       * 获取字幕轨道
       *
       * @return
       *
       * [
       *  {
       *    language
       *    active
       *    kind
       *    cues: []
       *    activeCues: []
       *  }
       * ]
       */

    }, {
      key: "getTextTracks",
      value: function getTextTracks() {
        return [];
      }
      /**
       * 设置是否开启该轨道
       * @param {*} enable
       */

    }, {
      key: "setTextTrackActive",
      value: function setTextTrackActive(enable) {} // event: cuechange, data: textTrack

    }, {
      key: "onPlayer",
      value: function onPlayer(evt, fn) {
        this.player.on(evt, fn);
        this.p_player_events.push({
          evt: evt,
          fn: fn
        });
      }
    }, {
      key: "oncePlayer",
      value: function oncePlayer(evt, fn) {
        this.player.once(evt, fn);
        this.p_player_events.push({
          evt: evt,
          fn: fn
        });
      }
    }, {
      key: "onDom",
      value: function onDom(ele, evt, fn) {
        var needRemove = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        addEventListener(ele, evt, fn);
        needRemove && this.p_dom_events.push({
          ele: ele,
          evt: evt,
          fn: fn
        });
      }
    }, {
      key: "onSelf",
      value: function onSelf(evt, fn) {
        this.on(evt, fn);
        this.p_self_events.push({
          evt: evt,
          fn: fn
        });
      }
    }, {
      key: "onceSelf",
      value: function onceSelf(evt, fn) {
        this.once(evt, fn);
        this.p_self_events.push({
          evt: evt,
          fn: fn
        });
      }
    }]);

    return Provider;
  }(EventEmitter);

  Provider.defaultOptions = {};
  Provider.canPlay = noop;
  Provider.isSupported = noop;
  Provider.isPlaybackRateSupported = noop;
  Provider.isFlash = noop;
  Provider.isHTML5 = noop;

  var FLASH_MIME_TYPE = 'application/x-shockwave-flash';
  var objIdArr = [];
  var flashV = flashVersion();
  var isIE$1 = isMSIE();
  var webkit = getWebkitVersion();
  function embedSWF(swfUrlStr, replaceElemIdStr, widthStr, heightStr, swfVersionStr, xiSwfUrlStr, flashvarsObj, parObj, attObj, callbackFn) {
    var id = replaceElemIdStr;
    var callbackObj = {
      success: false,
      id: id
    };

    if (!(webkit && webkit < 312) && swfUrlStr && replaceElemIdStr && widthStr && heightStr && swfVersionStr) {
      setVisibility(id, false);

      var onLoad = function onLoad() {
        widthStr += '';
        heightStr += '';
        var att = {};

        if (attObj && _typeof(attObj) === 'object') {
          for (var i in attObj) {
            att[i] = attObj[i];
          }
        }

        att.data = swfUrlStr;
        att.width = widthStr;
        att.height = heightStr;
        var par = {};

        if (parObj && _typeof(parObj) === 'object') {
          for (var j in parObj) {
            par[j] = parObj[j];
          }
        }

        if (flashvarsObj && _typeof(flashvarsObj) === 'object') {
          for (var k in flashvarsObj) {
            if (flashvarsObj.hasOwnProperty(k)) {
              var key = k;
              var value = flashvarsObj[k];

              if (typeof par.flashvars !== 'undefined') {
                par.flashvars += '&' + key + '=' + value;
              } else {
                par.flashvars = key + '=' + value;
              }
            }
          }
        } // flash 版本满足


        if (hasPlayerVersion(swfVersionStr)) {
          var obj = createSWF(att, par, replaceElemIdStr);

          if (att.id === id) {
            setVisibility(id, true);
          }

          callbackObj.success = true;
          callbackObj.ref = obj;
          callbackObj.id = obj.id;
        } else {
          setVisibility(id, true);
        }

        if (callbackFn) {
          callbackFn(callbackObj);
        }
      };

      onLoad(); // TODO 监听DomContentLoaded事件
    } else if (callbackFn) {
      callbackFn(callbackObj);
    }
  }

  function setVisibility(id, isVisible) {
    var v = isVisible ? 'visible' : 'hidden';
    var el = document.getElementById(id);
    el.style.visibility = v;
  }
  /* Flash Player and SWF content version matching
    */


  function hasPlayerVersion(rv) {
    rv = parseFloat(rv);
    return flashV >= rv;
  }
  /* Cross-browser dynamic SWF creaion
    */


  function createSWF(attObj, parObj, id) {
    var r;
    var el = document.getElementById(id);

    if (webkit && webkit < 312) {
      return r;
    }

    if (el) {
      var o = isIE$1 ? document.createElement('div') : document.createElement('object');
      var attr;
      var attrLower;
      var param;

      if (typeof attObj.id === 'undefined') {
        // if no 'id' is defined for the object element, it will inherit the 'id' from the fallback content
        attObj.id = id;
      } // Add params


      for (param in parObj) {
        // filter out prototype additions from other potential libraries and IE specific param element
        if (parObj.hasOwnProperty(param) && param.toLowerCase() !== 'movie') {
          createObjParam(o, param, parObj[param]);
        }
      } // Create IE object, complete with param nodes


      if (isIE$1) {
        o = createIeObject(attObj.data, o.innerHTML);
      } // Add attributes to object


      for (attr in attObj) {
        if (attObj.hasOwnProperty(attr)) {
          // filter out prototype additions from other potential libraries
          attrLower = attr.toLowerCase(); // 'class' is an ECMA4 reserved keyword

          if (attrLower === 'styleclass') {
            o.setAttribute('class', attObj[attr]);
          } else if (attrLower !== 'classid' && attrLower !== 'data') {
            o.setAttribute(attr, attObj[attr]);
          }
        }
      }

      if (isIE$1) {
        objIdArr[objIdArr.length] = attObj.id; // stored to fix object 'leaks' on unload (dynamic publishing only)
      } else {
        o.setAttribute('type', FLASH_MIME_TYPE);
        o.setAttribute('data', attObj.data);
      }

      el.parentNode.replaceChild(o, el);
      r = o;
    }

    return r;
  }

  function createIeObject(url, paramStr) {
    var div = document.createElement('div');
    div.innerHTML = "<object classid='clsid:D27CDB6E-AE6D-11cf-96B8-444553540000'><param name='movie' value='" + url + "'>" + paramStr + '</object>';
    return div.firstChild;
  }

  function createObjParam(el, pName, pValue) {
    var p = document.createElement('param');
    p.setAttribute('name', pName);
    p.setAttribute('value', pValue);
    el.appendChild(p);
  }

  var Timer =
  /*#__PURE__*/
  function (_EventEmitter) {
    _inherits(Timer, _EventEmitter);

    function Timer(options) {
      var _this;

      _classCallCheck(this, Timer);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Timer).call(this));
      _this.options = options || {};
      _this.gap = +_this.options.gap || 1000;
      _this.isRaf = !!_this.options.isRaf;
      _this.task = null;
      _this.dotTime = new Date().getTime();
      return _this;
    }

    _createClass(Timer, [{
      key: "start",
      value: function start() {
        this.trigger('start', {
          options: this.options
        });
        this.stop();

        this._startTimer();
      }
      /**
       * 手动tick 计算passed time并触发tick事件，然后重置dot time
       */

    }, {
      key: "tick",
      value: function tick() {
        var duration = this._passedTime();

        if (!this.task) {
          return;
        }

        this._clearTimer();

        if (duration > 0) {
          this.trigger('tick', {
            options: this.options,
            duration: duration,
            isStop: false
          });
        }

        this._startTimer();
      }
    }, {
      key: "stop",
      value: function stop() {
        var duration = this._passedTime();

        if (!this.task) {
          return;
        }

        this._clearTimer();

        if (duration > 0) {
          this.trigger('tick', {
            options: this.options,
            duration: duration,
            isStop: true
          });
        }

        this.trigger('stop', {
          options: this.options
        });
      }
    }, {
      key: "_internalF",
      value: function _internalF() {
        var duration = this._passedTime();

        if (duration > 0) {
          this.trigger('tick', {
            options: this.options,
            duration: duration,
            isStop: false
          });
        }

        this._startTimer();
      }
    }, {
      key: "_clearTimer",
      value: function _clearTimer() {
        if (this.isRaf) {
          caf(this.task);
        } else {
          clearTimeout(this.task);
        }

        this.task = null;
      }
    }, {
      key: "_startTimer",
      value: function _startTimer() {
        var _this2 = this;

        if (this.isRaf) {
          this.task = raf(function () {
            return _this2._internalF();
          });
        } else {
          // console.log('settimeout', this.gap)
          this.task = setTimeout(function () {
            return _this2._internalF();
          }, this.gap);
        }
      }
    }, {
      key: "_passedTime",
      value: function _passedTime() {
        var now = new Date().getTime();
        var passedTime = now - this.dotTime;
        this.dotTime = now;
        return passedTime;
      }
    }]);

    return Timer;
  }(EventEmitter);

  function Cache() {
    var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'muduPlayer';

    if (!(this instanceof Cache)) {
      return new Cache(storeKey);
    }

    this.storeKey = storeKey;
  }

  Cache.prototype.get = function (name) {
    var data = this._getData();

    return data[name];
  };

  Cache.prototype.set = function (name, value) {
    var data = this._getData();

    data[name] = value;

    this._setData(data);
  };

  Cache.prototype._getData = function () {
    var data = localStorage.getItem(this.storeKey);

    try {
      data = JSON.parse(data);
    } catch (err) {
      data = {};
    }

    return data || {};
  };

  Cache.prototype._setData = function (data) {
    localStorage.setItem(this.storeKey, safeJSONStringify(data));
  };

  var FlashUtil =
  /*#__PURE__*/
  function (_EventEmitter) {
    _inherits(FlashUtil, _EventEmitter);

    function FlashUtil() {
      _classCallCheck(this, FlashUtil);

      return _possibleConstructorReturn(this, _getPrototypeOf(FlashUtil).apply(this, arguments));
    }

    _createClass(FlashUtil, [{
      key: "onError",
      value: function onError() {
        this.trigger.apply(this, ['onError'].concat(Array.prototype.slice.call(arguments))); // console.log('flash onError', ...arguments)
      }
    }, {
      key: "onEvent",
      value: function onEvent() {
        this.trigger.apply(this, ['onEvent'].concat(Array.prototype.slice.call(arguments))); // console.log('flash onEvent', [].slice.call(arguments))
      }
    }, {
      key: "onReady",
      value: function onReady() {
        // console.log('flash onReady', [].slice.call(arguments))
        this.trigger.apply(this, ['onReady'].concat(Array.prototype.slice.call(arguments)));
      }
    }]);

    return FlashUtil;
  }(EventEmitter); // muduPlayer.flashUtil.onError & muduPlayer.flashUtil.onEvent to subscribe ActionScript calling.


  var flashUtil = new FlashUtil();

  var Flash =
  /*#__PURE__*/
  function (_Provider) {
    _inherits(Flash, _Provider);

    function Flash(player, option) {
      var _this;

      _classCallCheck(this, Flash);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Flash).call(this, player, _objectSpread({}, Flash.defaultOptions, option)));
      _this.object = null;
      _this._prevPos = null;
      _this.flashUtilListener = [];
      _this._commandQueue = [];
      _this.currentTimer = null;
      _this.commandQueueTimer = null;
      _this.lastVolume = Cache().get('volume');
      window.muduPlayer = window.muduPlayer || {};
      window.muduPlayer.flashUtil = window.muduPlayer.flashUtil || flashUtil;

      _this.renderCustomTip();

      _this.initCommandQueueTimer();

      _this.removed = false; // this.onPlayer(events.INTERNAL_PROVIDER_REMOVED, () => {
      //   console('flash provider removed')
      //   this.remove()
      // })

      return _this;
    }

    _createClass(Flash, [{
      key: "loadFiles",
      value: function loadFiles() {
        if (this.removed) {
          return Promise.reject(new TypeError('flash provider removed'));
        }

        return _get(_getPrototypeOf(Flash.prototype), "loadFiles", this).call(this);
      }
    }, {
      key: "getMediaElement",
      value: function getMediaElement() {
        return this.player.dom.videoWrap.querySelector('object');
      }
    }, {
      key: "createMediaElement",
      value: function createMediaElement() {
        var _this2 = this;

        this.id = this.player._config.containerId + '-flash';
        this.player.dom.flash.id = this.id;
        var flashVars = {
          autoplay: false,
          preload: this.player._config.preload,
          hls_seekmode: 'ACCURATE',
          debug: !true,
          connectTimeout: this.option.connectTimeout || 3
        };
        var attributes = {
          id: this.id,
          name: this.id,
          "class": video,
          // 需要直接加上style，否则safari上会加载多次swf导致播放失败
          style: 'position: absolute; display: block; left: 0; right: 0; top: 0; bottom: 0; pointer-events:auto;'
        };
        var params = {
          wmode: 'opaque',
          allowScriptAccess: 'always',
          bgcolor: '#000000'
        };
        embedSWF(this.player._config.fileCdnPath + '/mudu-player.swf', this.id, '100%', '100%', '10.3', '', flashVars, params, attributes, function (data) {
          if (data.success === false) {
            classList(_this2.player.dom.container).add(flashDisabled);
          }
        });
        return this.getMediaElement();
      }
    }, {
      key: "remove",
      value: function remove() {
        _get(_getPrototypeOf(Flash.prototype), "remove", this).call(this);

        this.removed = true;
        this.currentTimer && this.currentTimer.stop();
        this.commandQueueTimer && this.commandQueueTimer.stop();
        this.flashUtilListener.forEach(function (listener) {
          return flashUtil.off(listener.event, listener.id);
        });
        this.triggerFlash('mudu_stop');
        this.object = null;
      }
    }, {
      key: "setup",
      value: function setup(_ref) {
        var _this3 = this;

        var type = _ref.type,
            absoluteFile = _ref.absoluteFile,
            isLive = _ref.isLive;

        if (this.removed) {
          console.log('setup: plash provider removed');
          return;
        }

        var handleOnReady = function handleOnReady() {
          _this3.player._status.flashReady = true;
          _this3.object = _this3.getMediaElement();
          _this3.id = _this3.player._config.containerId + '-flash';
          var safariCache = '';
          var ts = new Date().getTime();

          if (absoluteFile.indexOf('?') >= 0) {
            safariCache = "&safari".concat(ts, "=").concat(ts);
          } else {
            safariCache = "?safari".concat(ts, "=").concat(ts);
          }

          if (type === 'rtmp') {
            var parts = rtmpStreamToParts(absoluteFile);

            _this3.triggerFlash('mudu_setProperty', 'rtmpConnection', parts.connection);

            _this3.triggerFlash('mudu_setProperty', 'rtmpStream', parts.stream);
          } else if (_this3.player._config.preload === 'auto') {
            if (isSafari() && isLive) {
              _this3.triggerFlash('mudu_src', absoluteFile + safariCache);
            } else {
              _this3.triggerFlash('mudu_src', absoluteFile);
            }
          } else {
            _this3.oncePlayer('beforePlay', function () {
              if (isSafari() && isLive) {
                _this3.triggerFlash('mudu_src', absoluteFile + safariCache);
              } else {
                _this3.triggerFlash('mudu_src', absoluteFile);
              }
            });
          }

          _this3._subEvents();

          _this3._updateCurrentTime();
        };

        if (this.player._status.flashReady) {
          handleOnReady();
          return Promise.resolve();
        } else {
          var promise = new Promise(function (resolve, reject) {
            var isReady = false;
            var id = flashUtil.on('onReady', function (id) {
              if (id === _this3.id && _this3.object === null) {
                isReady = true;
                handleOnReady();
                resolve();
              }
            });

            _this3.flashUtilListener.push({
              event: 'onReady',
              id: id
            });

            isFF() && setTimeout(function () {
              if (!isReady) {
                classList(_this3.player.dom.container).add(flashDisabled);
                reject(new Error(Flash.Error.NotAllowedError));
              }
            }, 5000);
          });
          return promise;
        }
      }
    }, {
      key: "initCommandQueueTimer",
      value: function initCommandQueueTimer() {
        var _this4 = this;

        this.commandQueueTimer = new Timer({
          gap: 200
        });
        this.commandQueueTimer.on('tick', function (_ref2) {
          var isStop = _ref2.isStop;

          if (isStop) {
            return;
          }

          if (_this4._commandQueue.length === 0) {
            _this4.commandQueueTimer.stop();
          } else if (_this4._apiAvailable()) {
            _this4._commandQueue.forEach(function (v) {
              if (_this4.object[v.fn]) {
                var _this4$object;

                (_this4$object = _this4.object)[v.fn].apply(_this4$object, _toConsumableArray(v.args));
              }
            });

            _this4._commandQueue = [];
          }
        });
      }
    }, {
      key: "renderCustomTip",
      value: function renderCustomTip() {
        var tip = this.option.renderTip();
        var flashTip$$1 = this.player.dom.flashTip;

        var clearTip = function clearTip() {
          flashTip$$1.innerHTML = '';
        };

        if (typeof tip === 'string') {
          clearTip();
          flashTip$$1.innerHTML = tip;
        } // if tip is HTMLElement


        if (_typeof(tip) === 'object') {
          clearTip();
          flashTip$$1.appendChild(tip);
        }
      } // 因为有时候会出现this.object.fn is not a function see #19, 所以使用一个队列

    }, {
      key: "triggerFlash",
      value: function triggerFlash(fnName) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        if (this.object && this.object[fnName]) {
          var _this$object;

          return (_this$object = this.object)[fnName].apply(_this$object, args);
        } else {
          this._commandQueue.push({
            fn: fnName,
            args: args
          });

          this.commandQueueTimer.start();
        }
      }
    }, {
      key: "_subEvents",
      value: function _subEvents() {
        var _this5 = this;

        var id = flashUtil.on('onEvent', function (id, evt) {
          if (id !== _this5.id || _this5.object === null) {
            return;
          } // console.log('flash event', id, evt)


          _this5.trigger(evt);

          switch (evt) {
            case 'playing':
              _this5.trigger('play');

              break;

            case 'durationchange':
              _this5.trigger('duration');

              break;

            case 'volumechange':
              var volume$$1 = _this5.getVolume();

              _this5.trigger('volume', {
                type: 'volume',
                volume: volume$$1
              });

              break;
          }
        });
        var id2 = flashUtil.on('onError', function (id) {
          for (var _len2 = arguments.length, others = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            others[_key2 - 1] = arguments[_key2];
          }

          if (id !== _this5.id || _this5.object === null) {
            return;
          }

          _this5.trigger(PROVIDER_ERROR, {
            message: others.join(),
            data: others,
            fatal: true
          });
        });
        this.flashUtilListener.push({
          event: 'onEvent',
          id: id
        });
        this.flashUtilListener.push({
          event: 'onError',
          id2: id2
        });
      }
    }, {
      key: "_updateCurrentTime",
      value: function _updateCurrentTime() {
        var _this6 = this;

        this.currentTimer = new Timer({
          gap: 500,
          name: 'flash update time'
        });
        this.currentTimer.on('tick', function () {
          if (_this6.object) {
            var pos = _this6.getPosition();

            if (pos !== _this6._prevPos) {
              _this6.trigger('timeupdate');
            }

            _this6._prevPos = pos;
          }
        });
        this.currentTimer.start();
      }
    }, {
      key: "getWidth",
      value: function getWidth() {
        return this._get('videoWidth', -1);
      }
    }, {
      key: "getHeight",
      value: function getHeight() {
        return this._get('videoHeight', -1);
      }
    }, {
      key: "getMetrics",
      value: function getMetrics() {
        if (this._apiAvailable()) {
          return {
            videoHeight: this.getHeight(),
            videoWidth: this.getWidth(),
            fps: this.getFPS(),
            bps: this.getBPS()
          };
        }

        return {};
      }
    }, {
      key: "getFPS",
      value: function getFPS() {
        return this._get('currentFPS', -1);
      }
    }, {
      key: "getBPS",
      value: function getBPS() {
        return this._get('currentBPS', -1);
      }
    }, {
      key: "getBuffer",
      value: function getBuffer() {
        if (this._apiAvailable()) {
          var buffered = this._get('buffered', []);

          if (buffered.length >= 1) {
            var ret = buffered.map(function (part) {
              return {
                start: part[0],
                end: part[1]
              };
            });
            return ret;
          }
        }

        return [];
      }
    }, {
      key: "getVolume",
      value: function getVolume() {
        if (this._apiAvailable()) {
          return this._get('volume');
        }

        return 1;
      }
    }, {
      key: "setVolume",
      value: function setVolume(volume$$1) {
        if (!this.object) {
          return;
        }

        var muted = this.getMute();

        if (is('number', volume$$1)) {
          if (volume$$1 < 0) {
            volume$$1 = 0;
          }

          if (volume$$1 > 1) {
            volume$$1 = 1;
          } // this.object.mudu_setProperty('volume', volume)


          this.triggerFlash('mudu_setProperty', 'volume', volume$$1);

          if (muted && volume$$1 > 0) {
            this.setMute(false);
          }

          if (!muted && volume$$1 === 0) {
            this.setMute(true);
          }
        }
      }
    }, {
      key: "setMute",
      value: function setMute() {
        var mute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (this._apiAvailable()) {
          if (!mute && this.getVolume() === 0) {
            this.setVolume(0.5);
          }

          this.object.mudu_setProperty('muted', !!mute);
          this.trigger('mute', {
            type: 'mute',
            mute: !!mute
          });
        }
      }
    }, {
      key: "getMute",
      value: function getMute() {
        if (this._apiAvailable()) {
          return this._get('muted');
        }

        return false;
      }
    }, {
      key: "setStretching",
      value: function setStretching(stretching) {
        if (!this._apiAvailable()) return;

        switch (stretching) {
          case 'none':
          case 'contain':
          case 'fill':
          case 'cover':
          case 'scale-down':
            this.object.mudu_setProperty('stretching', stretching);
            break;

          default:
            this.object.mudu_setProperty('stretching', 'contain');
        }
      }
    }, {
      key: "getStretching",
      value: function getStretching() {
        if (this._apiAvailable()) {
          return this._get('stretching');
        }

        return 'contain';
      }
    }, {
      key: "getPosition",
      value: function getPosition() {
        if (this._apiAvailable()) {
          return this._get('currentTime') || 0;
        }
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        if (this._apiAvailable()) {
          return this._get('duration');
        }
      }
    }, {
      key: "setStretch",
      value: function setStretch() {}
    }, {
      key: "getMetadata",
      value: function getMetadata() {}
    }, {
      key: "play",
      value: function play() {
        if (this.object) {
          if (this._get) {
            var ended = this._get('ended');

            if (ended) {
              this.object.mudu_play();
              this.seek(0);
            } else {
              this.object.mudu_play();
            }
          } else {
            this.triggerFlash('mudu_play');
          }
        }

        return Promise.resolve();
      }
    }, {
      key: "pause",
      value: function pause() {
        if (this.object) {
          this.triggerFlash('mudu_pause');
        }

        return Promise.resolve();
      }
    }, {
      key: "seek",
      value: function seek(time$$1) {
        if (this._apiAvailable()) {
          var prePosition = this._get('currentTime');

          this.object.mudu_setProperty('currentTime', time$$1);
          this.trigger('seek', {
            type: 'seek',
            position: prePosition,
            offset: time$$1
          });
        }
      }
    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {
        return 1;
      }
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate() {}
    }, {
      key: "_apiAvailable",
      value: function _apiAvailable() {
        return this.object && this.object.mudu_getProperty;
      }
    }, {
      key: "_get",
      value: function _get$$1(prop, defaultValue) {
        try {
          return this.object.mudu_getProperty(prop);
        } catch (err) {
          if (is('undefined', defaultValue)) {
            throw err;
          } else {
            return defaultValue;
          }
        }
      }
    }]);

    return Flash;
  }(Provider);

  Flash.types = ['flv', 'rtmp', 'hls', 'm3u8', 'mp4'];

  Flash.canPlay = function (_ref3) {
    var type = _ref3.type;
    return Flash.types.indexOf(type) >= 0;
  };

  Flash.canPlayMineType = noop;

  Flash.isSupported = function () {
    return !isMobile();
  };

  Flash.isPlaybackRateSupported = function () {
    return false;
  };

  Flash.isFlash = function (_) {
    return true;
  };

  Flash.isHTML5 = function (_) {
    return false;
  };

  Flash.version = "5.0.2-15";
  Flash.defaultOptions = {
    renderTip: noop
  };
  Flash.Error = {
    NotAllowedError: 'Media element cannot be created, probably flash is not allowed'
  };

  function initProvider() {
    var _this = this;

    try {
      destroyProvider.call(this);
    } catch (err) {
      console.error('destroy provider', err);
    } // removeMediaDom.call(this)


    console.log('initProvider');

    var _getActive$call = getActive.call(this),
        file = _getActive$call.file,
        type = _getActive$call.type,
        mineType = _getActive$call.mineType,
        isLive = _getActive$call.isLive,
        absoluteFile = _getActive$call.absoluteFile,
        image = _getActive$call.image,
        isTimeShift = _getActive$call.isTimeShift,
        reloadAfterPausing = _getActive$call.reloadAfterPausing,
        reloadAfterPausingTime = _getActive$call.reloadAfterPausingTime;

    var provider = chooseProvider({
      type: type,
      mineType: mineType,
      url: file,
      isLive: isLive,
      isTimeShift: isTimeShift
    }, this._config.providerOrder);

    if (!provider) {
      var err = 'File type not supported';
      this.trigger(OUTER_ERROR, {
        message: err,
        fatal: true,
        errorId: genErrorId()
      });
      return Promise.reject(new TypeError(err));
    }

    var instance = new provider.Provider(this, this._config.provider[provider.name]);
    this._provider = _objectSpread({}, provider, {
      instance: instance
    });
    var self = this;
    return instance.loadFiles().then(function appendMediaElement() {
      if (instance.removed) {
        return;
      }

      var prevMediaElement = instance.getMediaElement();

      if (!prevMediaElement) {
        var mediaElement = instance.createMediaElement();

        if (!mediaElement) {
          throw new Error(Flash.Error.NotAllowedError);
        }

        self.dom.videoWrap.insertBefore(mediaElement, self.dom.background);
      }
    }).then(function setupProvider() {
      if (instance.removed) {
        return;
      }

      console.log('instance setup');
      return instance.setup({
        isLive: isLive,
        file: file,
        image: image,
        absoluteFile: absoluteFile,
        type: type,
        mineType: mineType
      });
    }).then(function () {
      console.log('provider setup 成功  ');

      _this.trigger(INTERNAL_PROVIDER_INITED, {
        isLive: isLive,
        file: file,
        absoluteFile: absoluteFile,
        type: type,
        mineType: mineType,
        image: image,
        isTimeShift: isTimeShift,
        reloadAfterPausing: reloadAfterPausing,
        reloadAfterPausingTime: reloadAfterPausingTime
      });
    })["catch"](function (err) {
      console.error('provider setup 错误', err);

      _this.trigger(OUTER_ERROR, {
        error: err,
        message: err.message,
        column: err.columnNumber,
        fileName: err.fileName,
        lineNumber: err.lineNumber,
        name: err.name,
        stack: err.stack,
        errorId: genErrorId()
      });

      throw err;
    });
  }
  function destroyProvider() {
    console.log('destroyProvider');
    var instance = this._provider && this._provider.instance;

    if (instance) {
      this._provider = null;
      instance.remove();
      this.trigger(INTERNAL_PROVIDER_REMOVED);
    }
  }
  /**
   * 增加额外的provider：非视频流播放方式Provider。(目前只有使用vrProvider时使用这种方式)
   * @param {string} providerName 已注册的provider name
   */

  function initExtraProvider() {
    var _this2 = this;

    try {
      destroyExtraProvider.call(this);
    } catch (err) {
      console.error('destroy extra provider', err);
    } // removeMediaDom.call(this)


    console.log('add extra provider');

    var _getActive$call2 = getActive.call(this),
        file = _getActive$call2.file,
        type = _getActive$call2.type,
        mineType = _getActive$call2.mineType,
        isLive = _getActive$call2.isLive,
        absoluteFile = _getActive$call2.absoluteFile,
        image = _getActive$call2.image,
        isTimeShift = _getActive$call2.isTimeShift;

    var supportedProviders = selectExtraProviders({
      type: type,
      mineType: mineType,
      url: file,
      isLive: isLive,
      isTimeShift: isTimeShift
    }, this._config);
    Promise.all(supportedProviders.map(function (provider) {
      if (!provider) {
        var err = "".concat(provider.name, " cannot support file type");

        _this2.trigger(OUTER_ERROR, {
          message: err,
          fatal: true,
          errorId: genErrorId()
        });

        Promise.reject(new TypeError(err));
      }

      if (!_this2._config.extraProvider[provider.name].use) {
        return;
      }

      var instance = new provider.Provider(_this2, _this2._config.extraProvider[provider.name]);
      _this2._extraProviders[provider.name] = _objectSpread({}, provider, {
        instance: instance
      });
      var self = _this2;
      return instance.loadFiles().then(function appendMediaElement() {
        var prevMediaElement = instance.getMediaElement();

        if (!prevMediaElement) {
          var mediaElement = instance.createMediaElement();

          if (!mediaElement) {
            throw new Error(Flash.Error.NotAllowedError);
          }

          self.dom.videoWrap.insertBefore(mediaElement, self.dom.background);
        }
      }).then(function setupProvider() {
        console.log('instance setup');
        return instance.setup({
          isLive: isLive,
          file: file,
          image: image,
          absoluteFile: absoluteFile,
          type: type,
          mineType: mineType
        });
      }).then(function () {
        console.log('extra provider setup 成功  ');
      })["catch"](function (err) {
        console.error('extra provider setup 错误', err);

        _this2.trigger(OUTER_ERROR, {
          error: err,
          message: err.message,
          column: err.columnNumber,
          fileName: err.fileName,
          lineNumber: err.lineNumber,
          name: err.name,
          stack: err.stack,
          errorId: genErrorId()
        });

        throw err;
      });
    }));
  }
  function destroyExtraProvider() {
    var _this3 = this;

    console.log('destroyExtraProvider');
    var extraProvidersArr = Object.values(this._extraProviders);

    if (extraProvidersArr.length > 0) {
      extraProvidersArr.forEach(function (provider, index) {
        if (provider.instance) {
          provider.instance.remove();
          provider.removed = true;
          delete _this3._extraProviders[provider.name];
        }
      });
    }
  }

  var Video =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Video, _Model);

    function Video(player) {
      var _this;

      _classCallCheck(this, Video);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Video).call(this, player));
      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('play').method('pause').method('toggle').method('getState').method('getPlaybackRate').method('setPlaybackRate');

      _this.subEvents();

      _this.setPlayBtnIcon(play);

      _this.initPlayButton();

      _this._lastPausedTimeStamp = 0;
      return _this;
    }

    _createClass(Video, [{
      key: "changeStateClass",
      value: function changeStateClass() {
        var state = this.getState();
        classList(this.player.dom.container).remove(stateReg);
        classList(this.player.dom.container).add("mudu-state-".concat(state));
      }
    }, {
      key: "subEvents",
      value: function subEvents() {
        var _this2 = this;

        this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
          _this2.subProvider();

          classList(_this2.player.dom.container).add(stateIdle);
        });
        this.onPlayer(INTERNAL_PROVIDER_INIT, function () {
          classList(_this2.player.dom.container).remove(stateReg);
        });
        this.onPlayer(INTERNAL_PROVIDER_REMOVED, function () {
          _this2.player.timer.loading.stop();

          classList(_this2.player.dom.container).remove(stateReg);
          classList(_this2.player.dom.container).remove(providerReg);

          _this2._triggerStateEvt(OUTER_IDLE, 'idle');

          _this2.setPlayBtnIcon(play);

          _this2.changeStateClass();
        });
        this.onPlayer('internal_buffer', function (status) {
          if (status) {
            if (_this2._isErrorState()) {
              return;
            }

            _this2._triggerStateEvt('buffer', 'buffering');

            _this2.changeStateClass();
          } else {
            // TODO: 检查video状态, 处理idle, pause, playing
            _this2._triggerStateEvt('play', 'playing');

            _this2.changeStateClass();
          }
        });
        this.onPlayer(INTERNAL_KEY_DOWN, this._onInternalKeyDown.bind(this));
      }
    }, {
      key: "subProvider",
      value: function subProvider() {
        var _this3 = this;

        this.onProvider(PROVIDER_PLAY, function () {
          _this3.player.timer.loading.start();

          var prevState = _this3.getState();

          if (_this3.getState() === 'playing') return;

          _this3._triggerStateEvt(OUTER_PLAY, 'playing');

          _this3.setPlayBtnIcon(pause);

          prevState !== 'buffering' && prevState !== 'playing' && _this3.player.model.bezel["switch"](play);

          _this3.changeStateClass();
        });
        this.onProvider(PROVIDER_PAUSE, function () {
          _this3._lastPausedTimeStamp = Date.now();

          _this3.player.timer.loading.stop();

          _this3._triggerStateEvt(PROVIDER_PAUSE, 'paused');

          _this3.setPlayBtnIcon(play);

          _this3.player.model.bezel["switch"](pause);

          !_this3._isErrorState() && _this3.changeStateClass();
        });
        this.onProvider(PROVIDER_ENDED, function () {
          _this3.player.timer.loading.stop();

          _this3._triggerStateEvt(OUTER_IDLE);

          _this3.changeStateClass();
        });
        this.onProvider(PROVIDER_SEEKED, function () {
          _this3.player.trigger(OUTER_SEEKED);
        });
        this.onProvider(PROVIDER_SEEK, function (data) {
          _this3.player.trigger(OUTER_SEEK, data);
        });
        this.onProvider(PROVIDER_STAGE_CLICK, function () {
          var tooltipVisible = tooltip$1.isAnyClassShow('mudu-popup');

          if (tooltipVisible) {
            tooltip$1.hideAll();
          } else {
            _this3.player.getControls() && _this3.player.toggle();
          }
        });
      }
    }, {
      key: "_triggerStateEvt",
      value: function _triggerStateEvt(type, newState) {
        newState = newState || type;
        var oldState = this.player._status.state;
        this.player._status.state = newState;
        this.player.trigger(type, {
          type: type,
          oldState: oldState,
          newState: newState
        });
      }
    }, {
      key: "_isErrorState",
      value: function _isErrorState() {
        return classList(this.player.dom.container).contains(stateError);
      }
    }, {
      key: "initPlayButton",
      value: function initPlayButton() {
        var _this4 = this;

        this.onDom(this.player.dom.leftPlayBtn, 'click', function () {
          _this4.player.toggle();
        });
        this.onDom(this.player.dom.bigPlayBtn, 'click', function () {
          _this4.player.toggle();
        });

        if (!isMobile()) {
          this.onDom(this.player.dom.videoWrap, 'click', function (e) {
            if (_this4.player._provider && _this4.player._provider.flash) {
              return;
            }

            var tooltipVisible = tooltip$1.isAnyClassShow('mudu-popup');
            !tooltipVisible && _this4.player.getControls() && _this4.player.toggle();
          });
        }
      }
    }, {
      key: "setPlayBtnIcon",
      value: function setPlayBtnIcon(icon$$1) {
        var ele = this.player.dom.leftPlayBtn;
        classList(ele).remove(iconReg);
        classList(ele).add(icon$$1);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        console.log(getActive.call(this.player));
        var state = this.player._status.state;

        if (state === 'paused' || state === 'idle') {
          return this.play();
        } else {
          return this.pause();
        }
      }
    }, {
      key: "play",
      value: function play$$1() {
        var _this5 = this;

        var state = this.player._status.state;
        var activeSource = getActive.call(this.player);
        var reloadAfterPausing = activeSource.reloadAfterPausing,
            reloadAfterPausingTime = activeSource.reloadAfterPausingTime;

        if (reloadAfterPausing && this._lastPausedTimeStamp && state === 'paused') {
          var now = Date.now();
          reloadAfterPausingTime = is('undefined', reloadAfterPausingTime) ? 3000 : reloadAfterPausingTime;
          var shouldReplay = now - this._lastPausedTimeStamp > reloadAfterPausingTime;

          if (shouldReplay) {
            this.player.replay();
            return;
          }
        }

        if (this.provider()) {
          this.player.trigger(OUTER_BEFORE_PLAY, {
            type: OUTER_BEFORE_PLAY
          });
          return this.provider().play();
        } else {
          return initProvider.call(this.player).then(function () {
            initExtraProvider.call(_this5.player);

            try {
              _this5.play();
            } catch (err) {
              console.warn(err);
            }
          });
        }
      }
    }, {
      key: "pause",
      value: function pause$$1() {
        if (this.provider()) {
          return this.provider().pause();
        }

        return Promise.resolve();
      }
    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {
        if (this.provider()) {
          return this.provider().getPlaybackRate();
        }

        return 1;
      }
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(rate) {
        if (this.provider()) {
          return this.provider().setPlaybackRate(rate);
        }
      }
    }, {
      key: "getState",
      value: function getState() {
        return this.player._status.state;
      }
    }, {
      key: "_onInternalKeyDown",
      value: function _onInternalKeyDown(keyCode) {
        keyCode === 32 && this.toggle();
      }
    }]);

    return Video;
  }(Model);

  var dom = {
    nameMap: {
      dragStart: isMobile() ? 'touchstart' : 'mousedown',
      dragMove: isMobile() ? 'touchmove' : 'mousemove',
      dragEnd: isMobile() ? 'touchend' : 'mouseup'
    }
  };

  var Progress =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Progress, _Model);

    function Progress(player) {
      var _this;

      _classCallCheck(this, Progress);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Progress).call(this, player));
      _this.player.dom.ptime.innerHTML = '00:00';
      _this.prevDragX = null;
      _this._latest10tsLength = [];
      _this._lastDuration = 0;

      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInited.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(INTERNAL_PROVIDER_REMOVED, _this._onProviderRemoved.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(INTERNAL_KEY_DOWN, _this._onInternalKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.initPlayedBar();

      _this.initTimeShiftSeek(); // this.liveBadgeTip = tooltip(player.dom.liveBadge, {
      //   content: getTooltipString(this.lang['Skip ahead to live broadcast']),
      //   container: this.player.dom.container
      // })
      // 产品说这个提示暂时不需要 先注释


      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('seek').method('getPosition').method('getDuration').method('getBuffer');
      return _this;
    }

    _createClass(Progress, [{
      key: "setBarWidth",
      value: function setBarWidth(percentage) {
        this.player.dom.playedBar.style.width = cssLength(percentage);
      }
    }, {
      key: "getBarWidth",
      value: function getBarWidth() {
        return parseFloat(this.player.dom.playedBar.style.width) / 100;
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        if (!this.provider()) {
          return 1;
        }

        return this.provider().getDuration();
      }
    }, {
      key: "getPosition",
      value: function getPosition() {
        if (!this.provider()) {
          return 0;
        }

        return this.provider().getPosition();
      }
    }, {
      key: "getBufferPercentage",
      value: function getBufferPercentage() {
        if (!this.provider()) {
          return 0;
        }

        var buffer = this.getBuffer();
        var last = buffer.pop();
        var lastEnd = last && last.end || 0;
        var dura = this.getDuration();
        var per = lastEnd / dura || 0;
        return per;
      }
    }, {
      key: "getBuffer",
      value: function getBuffer() {
        if (!this.provider()) return [];
        return this.provider().getBuffer();
      }
    }, {
      key: "seek",
      value: function seek(time$$1) {
        if (!this.provider()) {
          return;
        }

        this.provider().seek(time$$1);
        var duration = this.getDuration();
        time$$1 = Math.max(time$$1, 0);

        if (duration) {
          time$$1 = Math.min(time$$1, duration);
        }

        this.setBarWidth(this.getPlayedBarPercentage(time$$1));
        this.player.dom.ptime.innerHTML = secondToTime(time$$1);
      }
    }, {
      key: "computeDragDirec",
      value: function computeDragDirec(offset) {
        if (this.prevDragX === null) {
          this.prevDragX = offset;
          return '';
        }

        var direc = offset > this.prevDragX ? 'right' : 'left';
        this.prevDragX = offset;
        return direc;
      }
    }, {
      key: "initPlayedBar",
      value: function initPlayedBar() {
        var _this2 = this;

        var thumbMove = function thumbMove(e) {
          classList(_this2.player.dom.container).add(flagDragging);
          var offsetPx = (e.clientX || e.changedTouches[0].clientX) - getElementViewLeft(_this2.player.dom.playedBarWrap);

          _this2.player.model.progressPopup.dragMove(offsetPx, _this2.computeDragDirec(offsetPx));

          _this2.player.model.progressPopup.show();

          var percentage = offsetPx / _this2.player.dom.playedBarWrap.clientWidth;
          percentage = Math.max(percentage, 0);
          percentage = Math.min(percentage, 1);

          _this2.setBarWidth(percentage);

          _this2.player.dom.ptime.innerHTML = secondToTime(percentage * _this2.getDuration());
        };

        var thumbUp = function thumbUp(e) {
          _this2.prevDragX = null;

          _this2.player.model.progressPopup.hide();

          _this2.player.model.progressPopup.dragEnd();

          _this2.player._status.dragging = false;

          _this2.player.model.controls.setAutoHide();

          removeEventListener(document, dom.nameMap.dragEnd, thumbUp);
          removeEventListener(document, dom.nameMap.dragMove, thumbMove);

          var percentage = ((e.clientX || e.changedTouches[0].clientX) - getElementViewLeft(_this2.player.dom.playedBarWrap)) / _this2.player.dom.playedBarWrap.clientWidth;

          percentage = Math.max(percentage, 0);
          percentage = Math.min(percentage, 1);

          _this2.setBarWidth(percentage);

          _this2.seekByPercentage(percentage);
        };

        addEventListener(this.player.dom.playedBarWrap, dom.nameMap.dragStart, function () {
          _this2.player._status.dragging = true;
          addEventListener(document, dom.nameMap.dragMove, thumbMove);
          addEventListener(document, dom.nameMap.dragEnd, thumbUp);
        });
      }
    }, {
      key: "initTimeShiftSeek",
      value: function initTimeShiftSeek() {
        var _this3 = this;

        var badge = this.player.dom.liveBadge;
        badge.addEventListener('click', function () {
          _this3.seekTimeShiftLive();
        });
      }
    }, {
      key: "_onProviderInited",
      value: function _onProviderInited(opts) {
        var isLive = opts.isLive,
            isTimeShift = opts.isTimeShift;
        this.onProvider(PROVIDER_BUFFER_CHANGE, this._onBufferChange.bind(this));
        this.onProvider(PROVIDER_DURATION, this._onDuration.bind(this));
        this.onProvider(PROVIDER_TIME_UPDATE, this._onTimeUpdate.bind(this));
        this.onProvider(PROVIDER_TIME_UPDATE, this._onBufferChange.bind(this)); // flash not trigger buffer change , so use timeupdate event to update buffer bar width

        this.onceProvider(PROVIDER_LOADEDDATA, this._onLoadedData.bind(this));
        classList(this.player.dom.container).add(hideTime);

        if (isLive) {
          classList(this.player.dom.container).add(live);
          classList(this.player.dom.container).remove(playback);
        } else {
          classList(this.player.dom.container).remove(live);
          classList(this.player.dom.container).add(playback);
        }

        if (isTimeShift) {
          classList(this.player.dom.container).add(timeShift);
        } else {
          classList(this.player.dom.container).remove(timeShift);
          classList(this.player.dom.container).remove(timeShiftLive);
        }

        this._latest10tsLength = [];
      }
    }, {
      key: "_onProviderRemoved",
      value: function _onProviderRemoved() {
        classList(this.player.dom.container).add(hideTime);
      }
    }, {
      key: "_onBufferChange",
      value: function _onBufferChange() {
        var loadedBar = this.player.dom.loadedBar; // const percentage = this.getBufferPercentage()

        var time$$1 = this.getBufferPercentage() * this.getDuration();
        var percentage = this.getPlayedBarPercentage(time$$1);
        loadedBar.style.width = cssLength(percentage);
      }
    }, {
      key: "_onDuration",
      value: function _onDuration() {
        var dtime$$1 = this.player.dom.dtime;
        var duration = this.getDuration() || 0; // 设置duration显示

        if (isCommonNumber(duration) && duration > 0) {
          dtime$$1.innerHTML = secondToTime(duration);
          this.player.trigger(OUTER_DURATION, {
            type: OUTER_DURATION,
            duration: duration
          });
          classList(this.player.dom.container).remove(hideTime);
          classList(this.player.dom.container).add(durationValid);
        } // 时移时记录ts时间


        var minTsDuration = 1; // 当duration变化小于1时，不判断为ts时间变化

        var durationChangeLength = duration - this._lastDuration;

        if (this._lastDuration !== 0) {
          if (durationChangeLength >= minTsDuration) {
            var latest10tsLength = this._latest10tsLength;
            latest10tsLength.unshift(durationChangeLength);

            if (latest10tsLength.length > 10) {
              latest10tsLength.pop();
            }
          }
        }

        this._lastDuration = duration;

        this._updateTimeShiftLiveBadge();
      }
    }, {
      key: "_onTimeUpdate",
      value: function _onTimeUpdate() {
        var _this$player$dom = this.player.dom,
            playedBar = _this$player$dom.playedBar,
            ptime$$1 = _this$player$dom.ptime;
        var position = this.getPosition(); // const percentage = position / (this.getDuration() || Infinity)

        if (!this.player._status.dragging) {
          // playedBar.style.width = cssLength(percentage)
          this.setBarWidth(this.getPlayedBarPercentage(position));
        }

        ptime$$1.innerHTML = secondToTime(this.getPosition());
        this.player.trigger(OUTER_TIME, {
          type: OUTER_TIME,
          position: position
        });

        this._updateTimeShiftLiveBadge();
      }
    }, {
      key: "_onLoadedData",
      value: function _onLoadedData() {
        var _this4 = this;

        var dura = this.getDuration();

        if (isCommonNumber(dura) && dura > 0) {
          this.player.trigger(OUTER_CAN_SEEK);
        } else {
          this.onceProvider(PROVIDER_DURATION, function () {
            _this4.player.trigger(OUTER_CAN_SEEK);
          });
        }
      }
    }, {
      key: "_onInternalKeyDown",
      value: function _onInternalKeyDown(keyCode) {
        var isLive = this._isLive();

        if (isLive) return;

        switch (keyCode) {
          case 37:
            this.seek(this.getPosition() - 5);
            break;

          case 39:
            this.seek(this.getPosition() + 5);
            break;
        }
      }
    }, {
      key: "_isLive",
      value: function _isLive() {
        return classList(this.player.dom.container).contains(live);
      }
    }, {
      key: "_updateTimeShiftLiveBadge",
      value: function _updateTimeShiftLiveBadge() {
        var isTimeShiftLive = this.isTimeShiftLive();
        var con = this.player.dom.container;

        if (isTimeShiftLive) {
          classList(con).add(timeShiftLive); // this.liveBadgeTip.disable()
        } else {
          classList(con).remove(timeShiftLive); // this.liveBadgeTip.enable()
        }
      }
    }, {
      key: "seekTimeShiftLive",
      value: function seekTimeShiftLive() {
        // 当用户在时移回看时，如果想要切到最新的直播就调用这个函数，函数跳到第二新的ts(像上取10的整数)/30s处(取更大值)播放，并表示live
        if (!this.isTimeShift()) return;
        var dura = this.getDuration();
        var latest10tsLength = this._latest10tsLength;

        if (latest10tsLength.length < 3) {
          var time$$1 = dura - 20;

          if (time$$1 > 0) {
            this.seek(time$$1);
          }
        } else {
          var _time = dura - latest10tsLength[0] - latest10tsLength[1];

          this.seek(_time);
        }
      }
    }, {
      key: "getPositionByPercentage",
      value: function getPositionByPercentage(percentage) {
        var dura = this.getDuration();

        if (this.isTimeShift()) {
          var gap = this.getTimeShiftGap();
          return (gap - dura) * (1 - percentage);
        } else {
          if (!dura) {
            return 0;
          }

          return percentage * dura;
        }
      }
    }, {
      key: "seekByPercentage",
      value: function seekByPercentage(percentage) {
        var time$$1;
        var dura = this.getDuration();

        if (this.isTimeShift()) {
          var gap = this.getTimeShiftGap();
          time$$1 = (dura - gap) * percentage;
        } else {
          time$$1 = percentage * dura;
        }

        this.seek(time$$1);
      }
    }, {
      key: "isTimeShiftLive",
      value: function isTimeShiftLive() {
        var dura = this.getDuration();
        var time$$1 = this.getPosition();
        var latest10tsLength = this._latest10tsLength; // console.log('is time shift live', dura, time, latest10tsLength)

        if (latest10tsLength.length < 3) {
          // 如果ts记录小于3个，那么不足以判断，直接判断time和duration的差值是否小于30
          return dura - time$$1 < 30;
        } else {
          // 如果ts记录大于3个，那么判断time和duration的差值是否大于最新的3个ts
          var ts2dura = latest10tsLength[0] + latest10tsLength[1] + latest10tsLength[2];
          return dura - time$$1 < ts2dura;
        }
      }
    }, {
      key: "isTimeShift",
      value: function isTimeShift() {
        var dura = this.getDuration();
        var hasValidDuration = isCommonNumber(dura) && dura > 0;
        var hasClass = classList(this.player.dom.container).contains(timeShift);
        return hasValidDuration && hasClass;
      }
    }, {
      key: "getTimeShiftGap",
      value: function getTimeShiftGap() {
        var latest10tsLength = this._latest10tsLength;
        var dura = this.getDuration();
        var time$$1 = this.getPosition();

        if (latest10tsLength.length < 3) {
          var ret = dura - time$$1;

          if (ret < 30) {
            return 30 - ret;
          }

          return 30;
        } else {
          var ts2dura = latest10tsLength[0] + latest10tsLength[1] + latest10tsLength[2];
          return ts2dura;
        }
      }
    }, {
      key: "getPlayedBarPercentage",
      value: function getPlayedBarPercentage(time$$1) {
        var dura = this.getDuration();

        if (this.isTimeShift()) {
          var gap = this.getTimeShiftGap();
          var per = time$$1 / (dura - gap);

          if (per > 1) {
            return 1;
          } // console.log(time, gap, dura, per)


          return per;
        } else {
          return time$$1 / dura;
        }
      }
    }]);

    return Progress;
  }(Model);

  var Controls =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Controls, _Model);

    function Controls(player) {
      var _this;

      _classCallCheck(this, Controls);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Controls).call(this, player));
      _this.autoHideTimer = null;
      _this._controlsVisible = !!player._config.controls;
      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('setControls').method('getControls');

      _this.setControls(!!player._config.controls);

      _this.setMobileToggle();

      _this.setPcToggle();

      return _this;
    }

    _createClass(Controls, [{
      key: "setPcToggle",
      value: function setPcToggle() {
        var _this2 = this;

        if (isMobile()) {
          return;
        }

        var fautoHide = function fautoHide() {
          _this2.show();

          _this2.setAutoHide();
        };

        var handlePlay = function handlePlay(_ref) {
          var oldState = _ref.oldState;
          oldState !== 'buffering' && oldState !== 'playing' && fautoHide();
        };

        this.onDom(this.player.dom.container, 'mousemove', fautoHide);
        this.onDom(this.player.dom.container, 'click', fautoHide);
        this.onPlayer(OUTER_PLAY, handlePlay);
        this.onPlayer(OUTER_PAUSE, fautoHide);
      }
    }, {
      key: "setMobileToggle",
      value: function setMobileToggle() {
        var _this3 = this;

        if (!isMobile()) {
          return;
        }

        var ftoggle = function ftoggle(e) {
          e.stopPropagation();

          _this3.toggle();
        }; // use touchend instead of click:  in ios11, you cannot listen click event above a video element: https://github.com/videojs/video.js/issues/642


        this.onDom(this.player.dom.videoWrap, 'click', ftoggle);
        this.onPlayer(OUTER_PLAY, function () {
          _this3.setAutoHide();
        });
      }
    }, {
      key: "setAutoHide",
      value: function setAutoHide() {
        var _this4 = this;

        clearTimeout(this.autoHideTimer);
        this.autoHideTimer = setTimeout(function () {
          if (!tooltip$1.isAnyClassShow('mudu-popup') && !_this4.player._status.dragging) {
            _this4.hide();
          }
        }, 3000);
      }
    }, {
      key: "show",
      value: function show() {
        classList(this.player.dom.container).remove(hideController);

        this._triggerControlsVisible(this.getControls());
      }
    }, {
      key: "hide",
      value: function hide$$1() {
        var state = this.player.model.video.getState();

        if (state === 'paused' || state === 'idle') {
          return;
        }

        classList(this.player.dom.container).add(hideController);

        this._triggerControlsVisible(false);
      }
    }, {
      key: "isShow",
      value: function isShow() {
        return !classList(this.player.dom.container).contains(hideController);
      }
    }, {
      key: "_triggerControlsVisible",
      value: function _triggerControlsVisible(visible) {
        if (visible === this._controlsVisible) return;
        this._controlsVisible = visible;
        this.player.trigger(OUTER_CONTROLS_VISIBLE, {
          type: OUTER_CONTROLS_VISIBLE,
          visible: this._controlsVisible
        });
      }
    }, {
      key: "toggle",
      value: function toggle() {
        var isShow = this.isShow();
        isShow ? this.hide() : this.show();
        this.setAutoHide();
      }
    }, {
      key: "setControls",
      value: function setControls() {
        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this._showControls = !!status;
        var display = this._showControls ? 'block' : 'none';
        this.player.dom.controllerWrap.style.display = display;
        this.player.trigger(OUTER_CONTROLS, {
          type: OUTER_CONTROLS,
          controls: this._showControls
        });

        this._triggerControlsVisible(this._showControls && this.isShow());
      }
    }, {
      key: "getControls",
      value: function getControls() {
        return this._showControls;
      }
    }, {
      key: "remove",
      value: function remove() {
        _get(_getPrototypeOf(Controls.prototype), "remove", this).call(this);

        clearTimeout(this.autoHideTimer);
      }
    }]);

    return Controls;
  }(Model);

  var Volume =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Volume, _Model);

    function Volume(player) {
      var _this;

      _classCallCheck(this, Volume);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Volume).call(this, player));
      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getMute').method('setMute').method('getVolume').method('setVolume');

      _this.initVolumeButton();

      _this.subEvents();

      _this.volumeTip = tooltip$1(_this.player.dom.volumeButton, {
        content: '',
        container: _this.player.dom.container
      });

      if (isMobile()) {
        _this.player.dom.volumeWrap.style.display = 'none';
      }

      return _this;
    }

    _createClass(Volume, [{
      key: "subEvents",
      value: function subEvents() {
        var _this2 = this;

        this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
          _this2.subProviderEvents();

          var volume = Cache().get('volume') || 1;
          var mute = Cache().get('mute') || false;

          if (isMobile()) {
            _this2.setVolume(1);
          } else {
            _this2.setVolume(volume);

            _this2.setMute(mute);
          }
        });
        this.onPlayer(INTERNAL_KEY_DOWN, this._onInternalKeyDown.bind(this));
      }
    }, {
      key: "updateTipText",
      value: function updateTipText() {
        var mute = this.getMute() ? this.lang['Unmute'] : this.lang['Mute'];
        var str = getTooltipString(mute);
        this.volumeTip.updateContent(str);
      }
    }, {
      key: "subProviderEvents",
      value: function subProviderEvents() {
        var _this3 = this;

        this.onProvider(PROVIDER_MUTE, function (data) {
          _this3.player.trigger(OUTER_MUTE, data);

          _this3.switchVolumeIcon();

          _this3.setBarWidth(cssLength(_this3.getVolume()));

          _this3.cacheVolume();

          _this3.updateTipText();
        });
        this.onProvider(PROVIDER_VOLUME, function (data) {
          _this3.player.trigger(OUTER_VOLUME, data);

          _this3.switchVolumeIcon();

          _this3.setBarWidth(cssLength(_this3.getVolume()));

          _this3.cacheVolume();
        });
      }
    }, {
      key: "cacheVolume",
      value: function cacheVolume() {
        Cache().set('volume', this.getVolume());
        Cache().set('mute', this.getMute());
      }
    }, {
      key: "initVolumeButton",
      value: function initVolumeButton() {
        var _this4 = this;

        this.setBarWidth('100%');
        this.switchVolumeIcon();

        var volumeMove = function volumeMove(event) {
          var e = event || window.event;
          var scaleRate = _this4.player._status.containerFontSize / 16;
          var vWidth = 45 * scaleRate;
          var percentage = ((e.clientX || e.changedTouches[0].clientX) - getElementViewLeft(_this4.player.dom.volumeBarWrap)) / vWidth;

          _this4.setVolume(percentage);
        };

        var volumeUp$$1 = function volumeUp$$1() {
          removeEventListener(document, dom.nameMap.dragEnd, volumeUp$$1);
          removeEventListener(document, dom.nameMap.dragMove, volumeMove);
        };

        addEventListener(this.player.dom.volumeBarWrapWrap, 'click', function (event) {
          var scaleRate = _this4.player._status.containerFontSize / 16;
          var vWidth = 45 * scaleRate;
          var e = event || window.event;
          var percentage = ((e.clientX || e.changedTouches[0].clientX) - getElementViewLeft(_this4.player.dom.volumeBarWrap)) / vWidth;

          _this4.player.setVolume(percentage);
        });
        addEventListener(this.player.dom.volumeBarWrapWrap, dom.nameMap.dragStart, function () {
          addEventListener(document, dom.nameMap.dragMove, volumeMove);
          addEventListener(document, dom.nameMap.dragEnd, volumeUp$$1);
        });
        addEventListener(this.player.dom.volumeButton, 'click', function () {
          _this4.setMute(!_this4.getMute());

          raf(function () {
            _this4.updateTipText();

            _this4.volumeTip.show();
          });
        });
      }
    }, {
      key: "getMute",
      value: function getMute() {
        if (!this.provider()) {
          return false;
        }

        return this.provider().getMute();
      }
    }, {
      key: "setMute",
      value: function setMute() {
        var muted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (!this.provider()) {
          return;
        }

        if (!muted && this.getVolume() === 0) {
          this.setVolume(0.5);
        }

        return this.provider().setMute(muted);
      }
    }, {
      key: "getVolume",
      value: function getVolume() {
        if (!this.provider()) {
          return 1;
        }

        return this.provider().getVolume();
      }
    }, {
      key: "setVolume",
      value: function setVolume(volume) {
        if (!this.provider()) {
          return;
        }

        this.provider().setVolume(volume);
      }
    }, {
      key: "setBarWidth",
      value: function setBarWidth(width) {
        this.player.dom.volumeBar.style.width = width;
      }
    }, {
      key: "switchVolumeIcon",
      value: function switchVolumeIcon(icon) {
        var iconWrap = this.player.dom.volumeButton;
        classList(iconWrap).remove(iconReg);

        if (icon) {
          classList(iconWrap).add(icon);
          return;
        }

        if (this.getVolume() >= 0.95) {
          classList(iconWrap).add(volumeUp);
        } else if (this.getVolume() > 0) {
          classList(iconWrap).add(volumeDown);
        } else {
          classList(iconWrap).add(volumeOff);
        }
      }
    }, {
      key: "_onInternalKeyDown",
      value: function _onInternalKeyDown(keyCode) {
        switch (keyCode) {
          case 38:
            this.setVolume(this.getVolume() + 0.1);
            break;

          case 40:
            this.setVolume(this.getVolume() - 0.1);
            break;
        }
      }
    }]);

    return Volume;
  }(Model);

  var Playlist =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Playlist, _Model);

    function Playlist(player) {
      var _this;

      _classCallCheck(this, Playlist);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Playlist).call(this, player));
      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getPlaylist').method('getPlaylistItem').method('getPlaylistIndex').method('load').method('reload').method('next').method('prev').method('replay').method('setQuality').method('switchQuality').method('switchListItem').method('setRepeat').method('getRepeat');

      _this._subEvent();

      _this._retryStartTime = new Date();
      _this._retryTimes = 0;
      _this._retryTimer = null;

      if (player._config.enableErrorRetry) {
        _this.onPlayer('delegate-model', _this._onDelegateModel.bind(_assertThisInitialized(_assertThisInitialized(_this)))); // 监听外部调用的onError事件，用来重置重试次数和重试时间


        _this.onPlayer(OUTER_ERROR, _this._onOuterError.bind(_assertThisInitialized(_assertThisInitialized(_this))));
      }

      return _this;
    }

    _createClass(Playlist, [{
      key: "_onDelegateModel",
      value: function _onDelegateModel(data) {
        var fn = data.fn;

        switch (fn) {
          case 'load':
          case 'reload':
          case 'next':
          case 'prev':
          case 'replay':
          case 'setQuality':
          case 'switchQuality':
          case 'switchListItem':
            this._retryStartTime = new Date();
            this._retryTimes = 0;
            clearTimeout(this._retryTimer);
        }
      }
    }, {
      key: "_onOuterError",
      value: function _onOuterError(error) {
        var _this2 = this;

        var fatal = error.fatal;
        var _this$player$_config = this.player._config,
            errorMaxRetry = _this$player$_config.errorMaxRetry,
            errorMaxRetryTimeout = _this$player$_config.errorMaxRetryTimeout,
            errorRetryDelay = _this$player$_config.errorRetryDelay;
        var now = new Date();

        if (fatal) {
          if (errorMaxRetry > this._retryTimes || now.getTime() < this._retryStartTime.getTime() + errorMaxRetryTimeout) {
            clearTimeout(this._retryTimer);
            this._retryTimer = setTimeout(function () {
              if (!_this2.m_removed) {
                _this2._retryTimes++;

                _this2.replay();
              }
            }, errorRetryDelay);
          }
        }
      }
    }, {
      key: "_subEvent",
      value: function _subEvent() {
        var _this3 = this;

        var player = this.player;
        this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
          if (!player._provider) {
            return;
          }

          var isHTML5 = player._provider.html5;
          var container = player.dom.container;
          classList(container).remove(providerReg);
          classList(container).add(providerReady);

          if (isHTML5) {
            classList(container).add(providerHtml5);
          } else {
            classList(container).add(providerFlash);
          }

          _this3.onProvider(PROVIDER_ENDED, function () {
            player.trigger(OUTER_COMPLETE);
            var isPlaylistComplete = _this3.getPlaylistIndex() === _this3.getPlaylist().length - 1;

            if (isPlaylistComplete) {
              if (player._config.repeat) {
                _this3.reload();
              } else {
                player.trigger(OUTER_PLAYLIST_COMPLETE);
              }
            } else {
              _this3.next();
            }
          });
        });
      }
    }, {
      key: "load",
      value: function load(playlist) {
        var play = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var pl = formatPlaylist(playlist);

        if (pl) {
          this.player._config.playlist = pl;
          this.player.trigger(OUTER_PLAYLIST, {
            type: OUTER_PLAYLIST,
            playlist: pl
          });
          return this.reload(play);
        } else {
          return Promise.reject(new Error('muduPlayer().load(`playlist`): the format of `playlist` is illegel'));
        }
      }
    }, {
      key: "reload",
      value: function reload() {
        var _this4 = this;

        var play = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        setDefaultPlayItemSourceActive.call(this.player);
        return initProvider.call(this.player).then(function () {
          initExtraProvider.call(_this4.player);

          try {
            if (play) {
              return _this4.player.play();
            }
          } catch (err) {
            console.warn(err);
          }
        });
      }
    }, {
      key: "replay",
      value: function replay() {
        var _this5 = this;

        return initProvider.call(this.player).then(function () {
          initExtraProvider.call(_this5.player);

          try {
            return _this5.player.play();
          } catch (err) {
            console.warn(err);
          }
        });
      }
    }, {
      key: "switchListItem",
      value: function switchListItem(itemIndex, sourceIndex) {
        var _this6 = this;

        if (!is('number', itemIndex)) {
          return Promise.resolve(false);
        }

        var item = this.player._config.playlist[itemIndex];

        if (!item) {
          return Promise.resolve(false);
        }

        if (is('number', sourceIndex) & !item.sources[sourceIndex]) {
          return Promise.resolve(false);
        }

        if (is('number', sourceIndex)) {
          setActive.call(this.player, itemIndex, sourceIndex);
        } else {
          setDefaultPlayItemSourceActive.call(this.player, itemIndex);
        }

        this.player.trigger(OUTER_PLAYLIST_ITEM, {
          type: OUTER_PLAYLIST_ITEM,
          index: itemIndex,
          item: this.getPlaylistItem(itemIndex)
        });
        return initProvider.call(this.player).then(function () {
          return _this6.player.play();
        }).then(function () {
          return true;
        });
      }
    }, {
      key: "next",
      value: function next() {
        var idx = this.getPlaylistIndex() + 1;
        return this.switchListItem(idx);
      }
    }, {
      key: "prev",
      value: function prev() {
        var idx = this.getPlaylistIndex() - 1;
        return this.switchListItem(idx);
      }
    }, {
      key: "getPlaylist",
      value: function getPlaylist() {
        return this.player._config.playlist;
      }
    }, {
      key: "getPlaylistItem",
      value: function getPlaylistItem() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return this.player._config.playlist[index];
      }
    }, {
      key: "getPlaylistIndex",
      value: function getPlaylistIndex() {
        for (var i = 0; i < this.player._config.playlist.length; i++) {
          var item = this.player._config.playlist[i];

          if (item.active) {
            return i;
          }
        }

        return -1;
      }
    }, {
      key: "setQualityActive",
      value: function setQualityActive(qindex) {
        var listIndex = this.getPlaylistIndex();
        return setActive.call(this.player, listIndex, qindex);
      }
    }, {
      key: "getQuality",
      value: function getQuality(qindex) {
        var listIndex = this.getPlaylistIndex();
        var playlist = this.player._config.playlist;

        for (var i = 0; i < playlist[listIndex].sources.length; i++) {
          if (qindex === i) {
            return playlist[listIndex].sources[i];
          }
        }
      }
    }, {
      key: "setQuality",
      value: function setQuality(qindex) {
        console.warn('player.setQuality will be removed after v1.0.0, please use player.switchQuality instead');
        return this.switchQuality(qindex);
      }
    }, {
      key: "switchQuality",
      value: function switchQuality$$1(qindex) {
        var quality = this.getQuality(qindex);

        if (quality) {
          this.setQualityActive(qindex);
          this.player.trigger(OUTER_SWITCH_QUALITY, {
            index: qindex,
            item: quality
          });
          return this.replay();
        }

        return Promise.resolve();
      }
    }, {
      key: "setRepeat",
      value: function setRepeat(repeat) {
        this.player._config.repeat = !!repeat;
      }
    }, {
      key: "getRepeat",
      value: function getRepeat() {
        return this.player._config.repeat;
      }
    }, {
      key: "remove",
      value: function remove() {
        _get(_getPrototypeOf(Playlist.prototype), "remove", this).call(this);

        clearTimeout(this._retryTimer);
      }
    }]);

    return Playlist;
  }(Model);

  var keyEventName = isFF() ? 'keyup' : 'keydown'; // to prevent space key on full/volume/play btn trigger a click event

  var HotKeys =
  /*#__PURE__*/
  function (_Model) {
    _inherits(HotKeys, _Model);

    function HotKeys(player) {
      var _this;

      _classCallCheck(this, HotKeys);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(HotKeys).call(this, player));

      _this.subEvent();

      return _this;
    }

    _createClass(HotKeys, [{
      key: "subEvent",
      value: function subEvent() {
        var player = this.player;

        this.onKeyUp = function (e) {
          if (player._status.focus) {
            var ele = document.activeElement;
            var tag = ele.tagName.toUpperCase();
            var editable = ele.getAttribute('contenteditable');

            if (tag !== 'INPUT' && tag !== 'TEXTAREA' && editable !== '' && editable !== 'true') {
              var event = e || window.event;

              switch (event.keyCode) {
                case 32:
                case 37:
                case 39:
                case 38:
                case 40:
                  event.preventDefault();
                  player.trigger(INTERNAL_KEY_DOWN, event.keyCode, event);
              }
            }
          }
        };

        addEventListener(document, keyEventName, this.onKeyUp);
      }
    }, {
      key: "remove",
      value: function remove() {
        removeEventListener(document, keyEventName, this.onKeyUp);
      }
    }]);

    return HotKeys;
  }(Model);

  var Resize =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Resize, _Model);

    function Resize(player) {
      var _this;

      _classCallCheck(this, Resize);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Resize).call(this, player));
      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getWidth').method('getHeight').method('resize').method('getRect');

      _this.setWidth();

      _this.setHeight();

      if (!_this.setAspect()) {
        _this.setHeight();
      }

      return _this;
    }

    _createClass(Resize, [{
      key: "getWidth",
      value: function getWidth() {
        return this.getRect().width;
      }
    }, {
      key: "getHeight",
      value: function getHeight() {
        return this.getRect().height;
      }
    }, {
      key: "getRect",
      value: function getRect() {
        return getBoundingClientRect(this.player.dom.container);
      }
    }, {
      key: "resize",
      value: function resize(width, height) {
        width = this.setWidth(width);
        height = this.setHeight(height);
        this.removeAspect();
        this.player.trigger(OUTER_RESIZE, {
          type: OUTER_RESIZE,
          width: width,
          height: height
        });
      }
    }, {
      key: "setWidth",
      value: function setWidth(width) {
        var cssWidth = width = width || this.player._config.width;
        this.player.dom.container.style.width = cssLength(cssWidth);
        return width;
      }
    }, {
      key: "setHeight",
      value: function setHeight(height) {
        var cssHeight = height = height || this.player._config.height;
        this.player.dom.container.style.height = cssLength(cssHeight);
        return height;
      }
    }, {
      key: "setAspect",
      value: function setAspect() {
        var aspectratio = this.player._config.aspectratio;
        var aspects = (aspectratio + '').split(':').map(function (v) {
          return +v;
        }).filter(function (v) {
          return !!v && v > 0;
        });

        if (aspects.length === 2) {
          var percentage = aspects[1] / aspects[0] * 100 + '%';
          this.player.dom.aspect.style.paddingTop = percentage;
          classList(this.player.dom.container).add(aspectMode);
          this.setHeight('auto');
          return true;
        } else {
          classList(this.player.dom.container).add(normalMode);
        }

        return false;
      }
    }, {
      key: "removeAspect",
      value: function removeAspect() {
        this.player.dom.aspect.style.paddingTop = 0;
        classList(this.player.dom.container).remove(aspectMode);
      }
    }]);

    return Resize;
  }(Model);

  var Stretch =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Stretch, _Model);

    function Stretch(player) {
      var _this;

      _classCallCheck(this, Stretch);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Stretch).call(this, player));

      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInited.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      return _this;
    }

    _createClass(Stretch, [{
      key: "_onProviderInited",
      value: function _onProviderInited() {
        var stretching = this.player._config.stretching;

        if (this.provider()) {
          this.provider().setStretching(stretching);
        }
      }
    }]);

    return Stretch;
  }(Model);

  var Logo =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Logo, _Model);

    function Logo(player) {
      var _this;

      _classCallCheck(this, Logo);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Logo).call(this, player));
      _this._onImgLoad = _this._onImgLoad.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this._onStyleLoaded = _this._onStyleLoaded.bind(_assertThisInitialized(_assertThisInitialized(_this)));

      _this.setLogoStyle();

      _this.oncePlayer(INTERNAL_STYLE_LOADED, _this._onStyleLoaded);

      return _this;
    }

    _createClass(Logo, [{
      key: "_onStyleLoaded",
      value: function _onStyleLoaded() {
        this.setLogoVisible();
      }
    }, {
      key: "_onImgLoad",
      value: function _onImgLoad() {
        var _this$player$dom = this.player.dom,
            logoWrap = _this$player$dom.logoWrap,
            logoImg = _this$player$dom.logoImg;
        var imgRect = getBoundingClientRect(logoImg);
        var containerRect = getBoundingClientRect(logoWrap);
        var containerAspectRatio = containerRect.width / containerRect.height;
        var imgNaturalAspectRatio = imgRect.width / imgRect.height;

        if (containerAspectRatio > imgNaturalAspectRatio) {
          logoImg.style.height = '100%';
        } else {
          logoImg.style.width = '100%';
        }

        logoImg.style.opacity = this.player._config.logo.opacity + '';
      }
    }, {
      key: "setLogoVisible",
      value: function setLogoVisible() {
        var logo = this.player._config.logo;
        var logoImg = this.player.dom.logoImg;
        addEventListener(logoImg, 'load', this._onImgLoad);
        logoImg.style.display = 'inline-block';
        logoImg.src = logo.file;
      }
    }, {
      key: "setLogoStyle",
      value: function setLogoStyle() {
        var logo = this.player._config.logo;
        var _this$player$dom2 = this.player.dom,
            logoWrap = _this$player$dom2.logoWrap,
            logoImg = _this$player$dom2.logoImg,
            logoLink = _this$player$dom2.logoLink;

        if (!logo.file) {
          return;
        }

        this.resetPosition();
        logoWrap.style.width = cssLength(logo.width);
        logoWrap.style.height = cssLength(logo.height);

        if (logo.position !== 'control-bar') {
          var direcs = logo.position.split('-');
          direcs.forEach(function (direc) {
            if (direc === 'top' || direc === 'bottom') {
              logoWrap.style[direc] = cssLength(logo.marginh);
            }

            if (direc === 'left' || direc === 'right') {
              logoWrap.style[direc] = cssLength(logo.marginw);
            }
          });
          direcs.forEach(function (v) {
            logoImg.style[v] = '0';
          });
        }

        logoLink.href = logo.link ? logo.link : 'javascript:void(0);';
        logoLink.target = logo.link ? '_blank' : '_self';
        logoLink.style.cursor = logo.link ? 'pointer' : 'default';
      }
    }, {
      key: "resetPosition",
      value: function resetPosition() {
        var dom = this.player.dom.logoWrap;
        dom.style.cssText = 'position: absolute;';
      }
    }, {
      key: "remove",
      value: function remove() {
        removeEventListener(this.player.dom.logoImg, 'load', this._onImgLoad);

        _get(_getPrototypeOf(Logo.prototype), "remove", this).call(this);
      }
    }]);

    return Logo;
  }(Model);

  var Focus =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Focus, _Model);

    function Focus(player) {
      var _this;

      _classCallCheck(this, Focus);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Focus).call(this, player));

      _this.init();

      return _this;
    }

    _createClass(Focus, [{
      key: "init",
      value: function init() {
        var player = this.player;

        this.setTrue = function () {
          player._status.focus = true;
        };

        this.setFalse = function () {
          player._status.focus = false;
        };

        addEventListener(document, 'click', this.setFalse, true);
        addEventListener(player.dom.container, 'click', this.setTrue, true);
      }
    }, {
      key: "remove",
      value: function remove() {
        removeEventListener(document, 'click', this.setFalse, true);
        removeEventListener(this.player.dom.container, 'click', this.setTrue, true);
      }
    }]);

    return Focus;
  }(Model);

  var Bezel =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Bezel, _Model);

    function Bezel(player) {
      var _this;

      _classCallCheck(this, Bezel);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Bezel).call(this, player));
      var bezel$$1 = _this.player.dom.bezel;

      _this.onDom(bezel$$1, 'animationend', function () {
        classList(bezel$$1).remove(bezelTrans);
      });

      return _this;
    }

    _createClass(Bezel, [{
      key: "switch",
      value: function _switch(icon$$1) {
        var bezel$$1 = this.player.dom.bezel;
        classList(bezel$$1).remove(iconReg);
        classList(bezel$$1).add(icon$$1);
        classList(bezel$$1).add(bezelTrans);
      }
    }]);

    return Bezel;
  }(Model);

  var Background =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Background, _Model);

    function Background(player) {
      var _this;

      _classCallCheck(this, Background);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Background).call(this, player));

      _this.subEvents();

      return _this;
    }

    _createClass(Background, [{
      key: "subEvents",
      value: function subEvents() {
        var _this2 = this;

        this.onPlayer(INTERNAL_PROVIDER_INITED, function (_ref) {
          var image = _ref.image;
          var bg = _this2.player.dom.background;
          var container = _this2.player.dom.container;
          classList(container).remove(stretchReg);
          classList(container).add(stretch + '-' + _this2.player._config.stretching);

          if (image) {
            bg.style.backgroundImage = "url(".concat(image, ")");
          } else {
            bg.style.backgroundImage = 'none';
          }
        });
      }
    }]);

    return Background;
  }(Model);

  var Dom =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Dom, _Model);

    function Dom(player) {
      var _this;

      _classCallCheck(this, Dom);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Dom).call(this, player));
      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('appendRightControllerButton');
      return _this;
    }

    _createClass(Dom, [{
      key: "appendRightControllerButton",
      value: function appendRightControllerButton(btn) {
        if (btn instanceof window.HTMLElement) {
          this.player.dom.controllerRightIcons.appendChild(btn);
        }
      }
    }]);

    return Dom;
  }(Model);

  var Title =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Title, _Model);

    function Title(player) {
      var _this;

      _classCallCheck(this, Title);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Title).call(this, player));

      _this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
        var _getActive$call = getActive.call(player),
            title = _getActive$call.title;

        if (!title) {
          player.dom.title.style.display = 'none';
        } else {
          player.dom.title.innerHTML = title;
        }
      });

      return _this;
    }

    return Title;
  }(Model);

  var ContextMenu =
  /*#__PURE__*/
  function (_Model) {
    _inherits(ContextMenu, _Model);

    function ContextMenu(player) {
      var _this2;

      _classCallCheck(this, ContextMenu);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ContextMenu).call(this, player));
      _this2.dom = null;

      _this2.createDom();

      _this2.tip = tooltip$1('', {
        container: player.dom.container,
        content: _this2.dom,
        "class": 'mudu-popup',
        getMaxHeight: function getMaxHeight(_ref) {
          var height = _ref.height;
          return height;
        }
      });

      _this2._subEvents();

      return _this2;
    }

    _createClass(ContextMenu, [{
      key: "generateDom",
      value: function generateDom() {
        this.createDom();
      }
    }, {
      key: "_subEvents",
      value: function _subEvents() {
        var _this3 = this;

        this.handleContextMenu = function (e) {
          if (_this3.tip.isShow()) {
            _this3.tip.hide();

            return;
          }

          var style = _this3.getStyle(e);

          if (style) {
            tooltip$1.hideAll();

            _this3.tip.show(style);

            e.preventDefault && e.preventDefault();
          }
        };

        this.onDom(this.player.dom.container, 'contextmenu', this.handleContextMenu);
      }
    }, {
      key: "getStyle",
      value: function getStyle(e) {
        var containerRect = getBoundingClientRect(this.player.dom.container);
        var panelRect = getBoundingClientRect(this.player.dom.container.querySelector(".".concat(panel)));

        if (containerRect.width < panelRect.width || containerRect.height < panelRect.height) {
          return;
        }

        var eLeft = e.clientX;
        var eTop = e.clientY;
        var maxTop = containerRect.height - panelRect.height;
        var maxLeft = containerRect.width - panelRect.width;
        var left = eLeft - containerRect.left;
        var top = eTop - containerRect.top;
        top = top > maxTop ? maxTop : top;
        left = left > maxLeft ? maxLeft : left;
        return {
          left: left,
          top: top
        };
      }
    }, {
      key: "createDom",
      value: function createDom() {
        var ctxMenus = this.player._config.contextMenus;
        var noop$$1 = 'javascript:void(0)';
        var menus = ctxMenus.map(function (v) {
          var item = "<a class=\"".concat(reset, " ").concat(menuitem, "\" href=\"").concat(v.link ? v.link : noop$$1, "\" target=\"_blank\" menuKey=\"").concat(v.key, "\" menuText=\"").concat(v.text, "\">") + "<div class=\"".concat(reset, " ").concat(menuitemLabel, "\">").concat(v.text, "</div>") + "</a>";
          return item;
        });
        var str = "<div class=\"".concat(reset, " ").concat(panel, " ").concat(contextMenuPanel, "\">") + "<div class=\"".concat(reset, " ").concat(panelMenu, "\">").concat(menus.join(''), "</div>") + "</div>";
        var dom = stringToDom(str);
        var items = dom.querySelectorAll(".".concat(menuitem));

        var _this = this;

        for (var i = 0; i < items.length; i++) {
          items[i].onclick = function () {
            var key = this.getAttribute('menuKey');
            var text = this.getAttribute('menuText');

            _this.tip.hide();

            _this.player.trigger(OUTER_CONTEXT_MENU_CLICK, {
              key: key,
              text: text,
              type: OUTER_CONTEXT_MENU_CLICK
            });
          };
        }

        this.dom = dom;
      }
    }]);

    return ContextMenu;
  }(Model);

  var ProgressPopup =
  /*#__PURE__*/
  function (_Model) {
    _inherits(ProgressPopup, _Model);

    function ProgressPopup(player) {
      var _this;

      _classCallCheck(this, ProgressPopup);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressPopup).call(this, player));
      _this.highlights = [];
      _this.autoHideTimer = null;

      _this.subEvents();

      return _this;
    }

    _createClass(ProgressPopup, [{
      key: "subEvents",
      value: function subEvents() {
        var _this2 = this;

        this.onPlayer(OUTER_DURATION, function () {
          _this2.setHightLights();
        });
        this.onPlayer(INTERNAL_PROVIDER_REMOVED, function () {
          _this2.clearHightLights();
        });
        this.onDom(this.player.dom.playedBarWrap, 'mousemove', function (e) {
          _this2.show();

          _this2.handleMouseMove(e);

          isMobile() && _this2.setAutohide();
        });

        if (!isMobile()) {
          this.onDom(this.player.dom.playedBarWrap, 'mouseenter', function (e) {
            _this2.show();
          });
          this.onDom(this.player.dom.playedBarWrap, 'mouseleave', function (e) {
            _this2.hide();
          });
          this.onDom(this.player.dom.playedBarWrap, 'mouseover', function (e) {
            _this2.handleDotEnter(e);
          });
          this.onDom(this.player.dom.playedBarWrap, 'mouseout', function (e) {
            _this2.handleDotLeave(e);
          });
        }
      }
    }, {
      key: "setAutohide",
      value: function setAutohide() {
        var _this3 = this;

        clearTimeout(this.autoHideTimer);
        this.autoHideTimer = setTimeout(function () {
          _this3.hide();
        }, 300);
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(e) {
        var px = cumulativeOffset(this.player.dom.playedBarWrap).left;
        var tx = (e.clientX || e.chhegdTouches[0].clientX) - px;

        if (tx < 0 || tx > this.player.dom.playedBarWrap.offsetWidth) {
          return;
        }

        this.move(tx);
      }
    }, {
      key: "handleDotEnter",
      value: function handleDotEnter(e) {
        var ele = e.target || e.srcElement; // ie8: e.target undefined

        if (ele && classList(ele).contains(dot)) {
          var text = ele.getAttribute('text');
          this.setDotActive(ele, true);
          this.setPopText(text);
          this.setPopTextVisible(true);
          this.handleMouseMove(e);
        }
      }
    }, {
      key: "handleDotLeave",
      value: function handleDotLeave(e) {
        var ele = e.target || e.srcElement;

        if (ele && classList(ele).contains(dot)) {
          this.setDotActive(ele, false);
          this.setPopText('');
          this.setPopTextVisible(false);
          this.handleMouseMove(e);
        }
      }
    }, {
      key: "setPopText",
      value: function setPopText(text) {
        this.player.dom.barTextText.innerHTML = text;
      }
    }, {
      key: "setPopTextVisible",
      value: function setPopTextVisible(visible) {
        var cl = classList(this.player.dom.barPopup);
        visible ? cl.add(barPopupText) : cl.remove(barPopupText);
      }
    }, {
      key: "isPopTextVisible",
      value: function isPopTextVisible() {
        return classList(this.player.dom.barPopup).contains(barPopupText);
      }
    }, {
      key: "setDotActive",
      value: function setDotActive(dot$$1, active$$1) {
        var cl = classList(dot$$1);
        active$$1 ? cl.add(active) : cl.remove(active);
      }
    }, {
      key: "show",
      value: function show() {
        classList(this.player.dom.barPopup).remove('hidden');
      }
    }, {
      key: "hide",
      value: function hide$$1() {
        classList(this.player.dom.barPopup).add('hidden');
      }
    }, {
      key: "move",
      value: function move(offsetPx) {
        var dura = this.player.model.progress.getDuration();
        var barWidth = this.player.dom.playedBarWrap.offsetWidth;

        if (offsetPx < 0) {
          offsetPx = 0;
        }

        if (offsetPx > barWidth) {
          offsetPx = barWidth;
        }

        var percentage = offsetPx / barWidth;
        var time$$1 = this.player.model.progress.getPositionByPercentage(percentage); // set content

        var timeStr = secondToTime(time$$1); // 当鼠标在控制条上时，显示现在的视频位置

        this.player.dom.barTime.innerHTML = timeStr;
        this.player.dom.barTextTime.innerHTML = timeStr; // classList(this.player.dom.barPopup).remove(cssClass.barPopupReg)

        this.setPosition(false, this.isPopTextVisible(), offsetPx, barWidth);
      }
      /**
       * call from model/controls
       * @param {*} offsetPx
       */

    }, {
      key: "dragMove",
      value: function dragMove(offsetPx, direc) {
        var _this4 = this;

        var dot$$1 = this.getDotFromDrag(offsetPx, direc);
        var dotIdx = this.highlights.indexOf(dot$$1);
        var dotEles = this.player.dom.highlight.querySelectorAll(".".concat(dot));
        var dotEle = dotEles[dotIdx];
        [].slice.call(dotEles).forEach(function (v) {
          return _this4.setDotActive(v, v === dotEle);
        });

        if (dotEle) {
          this.setPopText(dot$$1.text);
          this.setPopTextVisible(true);
        } else {
          this.setPopText('');
          this.setPopTextVisible(false);
        }

        this.move(offsetPx);
      }
    }, {
      key: "dragEnd",
      value: function dragEnd() {
        var _this5 = this;

        var dotEles = this.player.dom.highlight.querySelectorAll(".".concat(dot));
        [].slice.call(dotEles).forEach(function (v) {
          return _this5.setDotActive(v, false);
        });
      }
    }, {
      key: "getDotFromDrag",
      value: function getDotFromDrag(offsetPx, direc) {
        var barWidth = this.player.dom.playedBarWrap.offsetWidth;
        var dotWidth = 6;
        var dura = this.player.model.progress.getDuration();
        var pos = offsetPx / barWidth * dura;
        var posRadius = dotWidth / 2 / barWidth * dura;
        var radiusLights = this.highlights.filter(function (v) {
          return v.time > pos - posRadius && v.time < pos + posRadius;
        });

        if (radiusLights.length <= 1) {
          return radiusLights[0];
        }

        if (direc === 'left') {
          return radiusLights[0];
        }

        if (direc === 'right') {
          return radiusLights.pop();
        }

        return radiusLights[0];
      }
    }, {
      key: "setPosition",
      value: function setPosition(hasImg, hasText, offsetPx, barWidth) {
        var width;
        var popWidth = 168 * this.player._status.containerFontSize / 16;

        if (!hasImg && !hasText) {
          width = this.player.dom.barTime.offsetWidth;
        } else if (!hasImg && hasText) {
          width = this.player.dom.barText.offsetWidth;
        } else {
          width = popWidth;
        }

        var minLeft = -(popWidth - width) / 2;
        var maxLeft = barWidth - (popWidth / 2 + width / 2);
        var left = offsetPx - popWidth / 2;

        if (left < minLeft) {
          left = minLeft;
        }

        if (left > maxLeft) {
          left = maxLeft;
        }

        this.player.dom.barPopup.style.left = "".concat(left, "px");
      }
    }, {
      key: "setHightLights",
      value: function setHightLights() {
        var _getActive$call = getActive.call(this.player),
            highlights = _getActive$call.highlights;

        var hightDom = this.player.dom.highlight;
        var dura = this.player.model.progress.getDuration();
        this.highlights = is('array', highlights) ? highlights : [];
        this.highlights = this.highlights.slice().sort(function (dot1, dot2) {
          return dot1.time >= dot2.time;
        });
        var dots = this.highlights.map(function (d) {
          var left = d.time / dura;
          return "<div class=\"".concat(reset, " ").concat(dot, "\" text=\"").concat(d.text, "\" style=\"left: ").concat(cssLength(left), "\"></div>");
        });
        hightDom.innerHTML = dots.join('');
      }
    }, {
      key: "clearHightLights",
      value: function clearHightLights() {
        this.player.dom.highlight.innerHTML = '';
        this.highlights = [];
      }
    }]);

    return ProgressPopup;
  }(Model);

  var Error$1 =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Error, _Model);

    function Error(player) {
      var _this;

      _classCallCheck(this, Error);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Error).call(this, player));
      _this._tryDom = _this.geneTryDom();
      _this.renderError = is('function', _this.player._config.renderError) ? _this.player._config.renderError : _this.defaultRenderError.bind(_assertThisInitialized(_assertThisInitialized(_this)));

      _this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
        _this.onProvider(PROVIDER_ERROR, function (data) {
          data.message = "provider_".concat(_this.player._provider.name, "_").concat(data.message);
          data.errorId = genErrorId();

          _this.player.trigger(OUTER_ERROR, data);
        });
      });

      _this.onPlayer(OUTER_ERROR, function (data) {
        var error$$1 = {
          errorId: data.errorId,
          message: _this.filterErrorMsg(data.message),
          detail: data.message
        };

        if (data.fatal) {
          var errorDom = _this.renderError(error$$1);

          if (!errorDom || !is('string', errorDom) && !(errorDom instanceof HTMLElement)) {
            errorDom = _this.defaultRenderError(error$$1);
          }

          if (is('string', errorDom)) {
            _this.player.dom.errorWrap.innerHTML = errorDom;
          } else {
            _this.player.dom.errorWrap.innerHTML = '';

            _this.player.dom.errorWrap.appendChild(errorDom);
          }

          classList(_this.player.dom.container).add(stateError);
        }
      });

      return _this;
    }

    _createClass(Error, [{
      key: "geneTryDom",
      value: function geneTryDom() {
        var _this2 = this;

        var a = "<a href=\"javascript:void(0)\" action=\"reload\" style=\"color: blue;\">".concat(this.lang['Reload'], "</a>");
        var str = "<div>".concat(this.lang['You can try'], " ").concat(a, "</div>");
        var dom = stringToDom(str);

        dom.onclick = function (e) {
          e = e || window.event;
          var ele = e.target || e.srcElement;

          if (ele.getAttribute('action') === 'reload') {
            _this2.player.replay();
          }
        };

        return dom;
      }
    }, {
      key: "defaultRenderError",
      value: function defaultRenderError(_ref) {
        var message = _ref.message,
            detail = _ref.detail,
            errorId = _ref.errorId;
        var errorInner$$1 = "<div class=\"".concat(reset, " ").concat(errorInner, "\">") + "<div class=\"".concat(reset, " ").concat(errorIcon, "\"><span class=\"").concat(reset, " ").concat(error, "\"></span></div>") + "<div class=\"".concat(reset, " ").concat(errorText, "\">") + "<div>".concat(message, "(").concat(errorId, ")</div>") + "</div>" + "</div>";
        var errorInnerDom = stringToDom(errorInner$$1);
        errorInnerDom.querySelector(".".concat(errorText)).appendChild(this._tryDom);
        return errorInnerDom;
      }
    }, {
      key: "filterErrorMsg",
      value: function filterErrorMsg(msg) {
        if (!msg) {
          return this.lang['Unknown Error'];
        }

        var lmsg = msg.toLowerCase();

        var ht = function ht(sub) {
          return lmsg.indexOf(sub) >= 0;
        };

        if (ht('network')) {
          return this.lang['Network Error'];
        }

        if (ht('media') || ht('parse') || ht('demux') || ht('remux') || ht('decode')) {
          return this.lang['Media Error'];
        }

        return msg;
      }
    }, {
      key: "hideError",
      value: function hideError() {
        classList(this.player.dom.container).remove(stateError);
      }
    }]);

    return Error;
  }(Model);

  var Notice =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Notice, _Model);

    function Notice(player) {
      var _this;

      _classCallCheck(this, Notice);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Notice).call(this, player));
      _this.nt = _this.player.dom.notice;
      _this._t = null;
      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('notice');
      return _this;
    }

    _createClass(Notice, [{
      key: "notice",
      value: function notice$$1(text) {
        var time$$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
        this.setContent(text);

        if (time$$1 > 0) {
          this.autoHide(time$$1);
        }
      }
    }, {
      key: "hide",
      value: function hide$$1() {
        this.setVisible(false);
      }
    }, {
      key: "show",
      value: function show() {
        this.setVisible(true);
      }
    }, {
      key: "autoHide",
      value: function autoHide(time$$1) {
        var _this2 = this;

        this.show();

        if (this._t) {
          clearTimeout(this._t);
          this._t = null;
        }

        setTimeout(function () {
          return _this2.hide();
        }, time$$1);
      }
    }, {
      key: "setContent",
      value: function setContent(text) {
        this.nt.innerHTML = text;
      }
    }, {
      key: "setVisible",
      value: function setVisible(visible) {
        visible ? classList(this.nt).remove(hide) : classList(this.nt).add(hide);
      }
    }, {
      key: "remove",
      value: function remove() {
        _get(_getPrototypeOf(Notice.prototype), "remove", this).call(this);

        this._t && clearTimeout(this._t);
      }
    }]);

    return Notice;
  }(Model);

  var QualitySwitch =
  /*#__PURE__*/
  function (_Model) {
    _inherits(QualitySwitch, _Model);

    function QualitySwitch(player) {
      var _this;

      _classCallCheck(this, QualitySwitch);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(QualitySwitch).call(this, player));
      _this.isMobile = isMobile();

      _this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
        _this.onProviderInited(player);
      });

      return _this;
    }

    _createClass(QualitySwitch, [{
      key: "onProviderInited",
      value: function onProviderInited() {
        var sources = getActiveSources.call(this.player);
        var activeSource = this.getActiveSource(sources);
        var pathList = this.getPathListBySources(sources);
        this.init();

        if (sources.length > 1) {
          if (this.isMobile) {
            this.initMobile(pathList, sources, activeSource);
          } else {
            this.initQuality(sources, activeSource);
            pathList.length > 0 && this.initPath(sources, activeSource);
          }
        }
      }
    }, {
      key: "init",
      value: function init() {
        if (this.mobilePopup) {
          this.mobilePopup.destroy();
        }

        if (this.qsPopup) {
          this.qsPopup.destroy();
        }

        if (this.psPopup) {
          this.psPopup.destroy();
        }

        this.player.dom.switchPath.innerHTML = '';
        this.player.dom.switchQuality.innerHTML = '';
      }
    }, {
      key: "initMobile",
      value: function initMobile(pathList, sources, activeSource) {
        var _this$player$dom = this.player.dom,
            container = _this$player$dom.container,
            switchQuality$$1 = _this$player$dom.switchQuality;
        var activePathSources = this.getSourcesByPath(activeSource.path, sources);
        var dom = this.createMobileMenuitem(activePathSources, pathList, activeSource.path);
        this.mobilePopup = this.createTooltip(container, switchQuality$$1, dom);
        dom.addEventListener('click', this.mobilePopup.hide);
        this.addEventClick(dom.querySelectorAll('[type="path"]'), this.switchPath);
        this.addEventClick(dom.querySelectorAll('[type="quality"]'), this.switchQuality);

        if (activeSource) {
          this.player.dom.switchQuality.innerHTML = activeSource.label;
        }
      }
    }, {
      key: "initQuality",
      value: function initQuality(sources, activeSource) {
        var _this$player$dom2 = this.player.dom,
            container = _this$player$dom2.container,
            switchQuality$$1 = _this$player$dom2.switchQuality;
        var activePathSources = this.getSourcesByPath(activeSource.path, sources);
        var dom = this.createQualityMenuitem(activePathSources);
        this.addEventClick(dom.querySelectorAll('[type="quality"]'), this.switchQuality);
        this.qsPopup = this.createTooltip(container, switchQuality$$1, dom);

        if (activeSource) {
          this.player.dom.switchQuality.innerHTML = activeSource.label;
        }
      }
    }, {
      key: "initPath",
      value: function initPath(sources, activeSource) {
        var _this$player$dom3 = this.player.dom,
            container = _this$player$dom3.container,
            switchPath$$1 = _this$player$dom3.switchPath;
        var pathList = this.getPathListBySources(sources);
        var dom = this.createPathMenuitem(activeSource.path, pathList);
        this.addEventClick(dom.querySelectorAll('[type="path"]'), this.switchPath);
        this.psPopup = this.createTooltip(container, switchPath$$1, dom);

        if (activeSource) {
          this.player.dom.switchPath.innerHTML = activeSource.path_name;
        }
      }
    }, {
      key: "addEventClick",
      value: function addEventClick(dom, callback) {
        var _this2 = this;

        dom.forEach(function (menuitem$$1) {
          menuitem$$1.onclick = function () {
            return callback.call(_this2, menuitem$$1);
          };
        });
      }
    }, {
      key: "getActiveSource",
      value: function getActiveSource(sources) {
        return sources.filter(function (source) {
          return source.active;
        })[0];
      }
    }, {
      key: "switchQuality",
      value: function switchQuality$$1(menuitem$$1) {
        var index = Number(menuitem$$1.getAttribute('value'));
        this.player.switchQuality(index);
        this.isMobile ? this.mobilePopup.hide() : this.qsPopup.hide();
      }
    }, {
      key: "switchPath",
      value: function switchPath$$1(menuitem$$1) {
        var sources = getActiveSources.call(this.player);
        var path = menuitem$$1.getAttribute('value');
        var source = sources.find(function (source) {
          return source.path === path;
        }); // 使用此线路的第一个源地址

        this.player.switchQuality(Number(source.index));
        this.isMobile ? this.mobilePopup.hide() : this.psPopup.hide();
      }
    }, {
      key: "getSourcesByPath",
      value: function getSourcesByPath(path, sources) {
        return sources.filter(function (source) {
          return source.path === path;
        });
      }
    }, {
      key: "getPathListBySources",
      value: function getPathListBySources(sources) {
        var sourceList = sources.filter(function (item) {
          return item.path && item.path_name;
        });
        var list = [];
        sourceList.forEach(function (source) {
          var isRepeat = list.findIndex(function (item) {
            return item.path === source.path;
          }) > -1;

          if (!isRepeat) {
            list.push({
              path: source.path,
              path_name: source.path_name
            });
          }
        });
        return list;
      }
    }, {
      key: "createMobileMenuitem",
      value: function createMobileMenuitem(activeSources, pathList, activePath) {
        var pathMenu = pathList.map(function (path) {
          return "<div class=\"".concat(qualityMenuItem, " ").concat(activePath === path.path ? active : '', "\" type=\"path\" value=\"").concat(path.path, "\">\n         <span class=\"").concat(qualityItemName, "\">").concat(path.path_name, "</span>\n       </div>");
        }).join('');
        var qualityMenu$$1 = activeSources.map(function (source) {
          return "<div class=\"".concat(qualityMenuItem, " ").concat(source.active ? active : '', "\" type=\"quality\" value=\"").concat(source.index, "\">\n         <span class=\"").concat(qualityItemName, "\">").concat(source.label, "</span>\n       </div>");
        }).join('');
        var str = "<div class=\"".concat(qualityWrap, "\">\n                   <div class=\"").concat(qualityMenu, "\">\n                     <div>\n                       <div class=\"").concat(qualityMenuLabel, "\"><span>\u9009\u62E9\uFF1A</span></div>\n                       <div class=\"").concat(qualityMenuItemWrap, "\">").concat(qualityMenu$$1, "</div>\n                     </div>\n                     <div style=\"display: ").concat(pathList.length !== 0 ? 'flex' : 'none', "\">\n                       <div class=\"").concat(qualityMenuLabel, "\"><span>\u7EBF\u8DEF\uFF1A</span></div>\n                       <div class=\"").concat(qualityMenuItemWrap, "\">").concat(pathMenu, "</div>\n                     </div>\n                   </div>\n                 </div>");
        return stringToDom(str);
      }
    }, {
      key: "createQualityMenuitem",
      value: function createQualityMenuitem(activeSources) {
        var str = activeSources.map(function (source) {
          return "<div class=\"".concat(qualityMenuItem, " ").concat(source.active ? active : '', "\" type=\"quality\" value=\"").concat(source.index, "\">\n         <span class=\"").concat(qualityItemName, "\">").concat(source.label, "</span>\n       </div>");
        }).join('');
        return stringToDom("<div class=\"".concat(qualityWrap, "\"><div class=\"").concat(qualityMenu, "\">").concat(str, "</div></div>"));
      }
    }, {
      key: "createPathMenuitem",
      value: function createPathMenuitem(activePath, pathList) {
        var isTwoColumns = pathList.length > 4 && !this.mobile;
        var str = pathList.map(function (path) {
          return "<div title=\"".concat(path.path_name, "\" class=\"").concat(qualityMenuItem, " ").concat(activePath === path.path ? active : '', "\" type=\"path\" value=\"").concat(path.path, "\">\n         <span class=\"").concat(qualityItemName, "\">").concat(path.path_name, "</span>\n       </div>");
        }).join('');
        return stringToDom("<div class=\"".concat(pathWrap, " ").concat(isTwoColumns ? pathMulti : '', "\">\n                                <div class=\"").concat(qualityMenu, "\">").concat(str, "</div>\n                              </div>"));
      }
    }, {
      key: "createTooltip",
      value: function createTooltip(container, ele, content) {
        var _this3 = this;

        var tip = tooltip$1(ele, {
          trigger: 'click',
          content: content,
          container: container,
          distance: 0,
          "class": "mudu-popup mudu-quality ".concat(this.isMobile ? mobile : ''),
          getMaxHeight: function getMaxHeight(_ref) {
            var height = _ref.height;
            return _this3.isMobile ? height : height - 70; // 移动端全屏不能限制高度
          }
        });
        this.onPlayer(INTERNAL_PROVIDER_REMOVED, tip.destroy);
        return tip;
      }
    }]);

    return QualitySwitch;
  }(Model);

  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var win;

  if (typeof window !== "undefined") {
      win = window;
  } else if (typeof commonjsGlobal !== "undefined") {
      win = commonjsGlobal;
  } else if (typeof self !== "undefined"){
      win = self;
  } else {
      win = {};
  }

  var window_1 = win;

  var isFunction_1 = isFunction;

  var toString = Object.prototype.toString;

  function isFunction (fn) {
    var string = toString.call(fn);
    return string === '[object Function]' ||
      (typeof fn === 'function' && string !== '[object RegExp]') ||
      (typeof window !== 'undefined' &&
       // IE8 and below
       (fn === window.setTimeout ||
        fn === window.alert ||
        fn === window.confirm ||
        fn === window.prompt))
  }

  var trim_1 = createCommonjsModule(function (module, exports) {
  exports = module.exports = trim;

  function trim(str){
    return str.replace(/^\s*|\s*$/g, '');
  }

  exports.left = function(str){
    return str.replace(/^\s*/, '');
  };

  exports.right = function(str){
    return str.replace(/\s*$/, '');
  };
  });
  var trim_2 = trim_1.left;
  var trim_3 = trim_1.right;

  var fnToStr = Function.prototype.toString;

  var constructorRegex = /^\s*class\b/;
  var isES6ClassFn = function isES6ClassFunction(value) {
  	try {
  		var fnStr = fnToStr.call(value);
  		return constructorRegex.test(fnStr);
  	} catch (e) {
  		return false; // not a function
  	}
  };

  var tryFunctionObject = function tryFunctionToStr(value) {
  	try {
  		if (isES6ClassFn(value)) { return false; }
  		fnToStr.call(value);
  		return true;
  	} catch (e) {
  		return false;
  	}
  };
  var toStr = Object.prototype.toString;
  var fnClass = '[object Function]';
  var genClass = '[object GeneratorFunction]';
  var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

  var isCallable = function isCallable(value) {
  	if (!value) { return false; }
  	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
  	if (typeof value === 'function' && !value.prototype) { return true; }
  	if (hasToStringTag) { return tryFunctionObject(value); }
  	if (isES6ClassFn(value)) { return false; }
  	var strClass = toStr.call(value);
  	return strClass === fnClass || strClass === genClass;
  };

  var toStr$1 = Object.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  var forEachArray = function forEachArray(array, iterator, receiver) {
      for (var i = 0, len = array.length; i < len; i++) {
          if (hasOwnProperty.call(array, i)) {
              if (receiver == null) {
                  iterator(array[i], i, array);
              } else {
                  iterator.call(receiver, array[i], i, array);
              }
          }
      }
  };

  var forEachString = function forEachString(string, iterator, receiver) {
      for (var i = 0, len = string.length; i < len; i++) {
          // no such thing as a sparse string.
          if (receiver == null) {
              iterator(string.charAt(i), i, string);
          } else {
              iterator.call(receiver, string.charAt(i), i, string);
          }
      }
  };

  var forEachObject = function forEachObject(object, iterator, receiver) {
      for (var k in object) {
          if (hasOwnProperty.call(object, k)) {
              if (receiver == null) {
                  iterator(object[k], k, object);
              } else {
                  iterator.call(receiver, object[k], k, object);
              }
          }
      }
  };

  var forEach = function forEach(list, iterator, thisArg) {
      if (!isCallable(iterator)) {
          throw new TypeError('iterator must be a function');
      }

      var receiver;
      if (arguments.length >= 3) {
          receiver = thisArg;
      }

      if (toStr$1.call(list) === '[object Array]') {
          forEachArray(list, iterator, receiver);
      } else if (typeof list === 'string') {
          forEachString(list, iterator, receiver);
      } else {
          forEachObject(list, iterator, receiver);
      }
  };

  var forEach_1 = forEach;

  var isArray = function(arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
      };

  var parseHeaders = function (headers) {
    if (!headers)
      return {}

    var result = {};

    forEach_1(
        trim_1(headers).split('\n')
      , function (row) {
          var index = row.indexOf(':')
            , key = trim_1(row.slice(0, index)).toLowerCase()
            , value = trim_1(row.slice(index + 1));

          if (typeof(result[key]) === 'undefined') {
            result[key] = value;
          } else if (isArray(result[key])) {
            result[key].push(value);
          } else {
            result[key] = [ result[key], value ];
          }
        }
    );

    return result
  };

  var immutable = extend;

  var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

  function extend() {
      var target = {};

      for (var i = 0; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
              if (hasOwnProperty$1.call(source, key)) {
                  target[key] = source[key];
              }
          }
      }

      return target
  }

  var xhr = createXHR;
  // Allow use of default import syntax in TypeScript
  var default_1 = createXHR;
  createXHR.XMLHttpRequest = window_1.XMLHttpRequest || noop$1;
  createXHR.XDomainRequest = "withCredentials" in (new createXHR.XMLHttpRequest()) ? createXHR.XMLHttpRequest : window_1.XDomainRequest;

  forEachArray$1(["get", "put", "post", "patch", "head", "delete"], function(method) {
      createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
          options = initParams(uri, options, callback);
          options.method = method.toUpperCase();
          return _createXHR(options)
      };
  });

  function forEachArray$1(array, iterator) {
      for (var i = 0; i < array.length; i++) {
          iterator(array[i]);
      }
  }

  function isEmpty(obj){
      for(var i in obj){
          if(obj.hasOwnProperty(i)) return false
      }
      return true
  }

  function initParams(uri, options, callback) {
      var params = uri;

      if (isFunction_1(options)) {
          callback = options;
          if (typeof uri === "string") {
              params = {uri:uri};
          }
      } else {
          params = immutable(options, {uri: uri});
      }

      params.callback = callback;
      return params
  }

  function createXHR(uri, options, callback) {
      options = initParams(uri, options, callback);
      return _createXHR(options)
  }

  function _createXHR(options) {
      if(typeof options.callback === "undefined"){
          throw new Error("callback argument missing")
      }

      var called = false;
      var callback = function cbOnce(err, response, body){
          if(!called){
              called = true;
              options.callback(err, response, body);
          }
      };

      function readystatechange() {
          if (xhr.readyState === 4) {
              setTimeout(loadFunc, 0);
          }
      }

      function getBody() {
          // Chrome with requestType=blob throws errors arround when even testing access to responseText
          var body = undefined;

          if (xhr.response) {
              body = xhr.response;
          } else {
              body = xhr.responseText || getXml(xhr);
          }

          if (isJson) {
              try {
                  body = JSON.parse(body);
              } catch (e) {}
          }

          return body
      }

      function errorFunc(evt) {
          clearTimeout(timeoutTimer);
          if(!(evt instanceof Error)){
              evt = new Error("" + (evt || "Unknown XMLHttpRequest Error") );
          }
          evt.statusCode = 0;
          return callback(evt, failureResponse)
      }

      // will load the data & process the response in a special response object
      function loadFunc() {
          if (aborted) return
          var status;
          clearTimeout(timeoutTimer);
          if(options.useXDR && xhr.status===undefined) {
              //IE8 CORS GET successful response doesn't have a status field, but body is fine
              status = 200;
          } else {
              status = (xhr.status === 1223 ? 204 : xhr.status);
          }
          var response = failureResponse;
          var err = null;

          if (status !== 0){
              response = {
                  body: getBody(),
                  statusCode: status,
                  method: method,
                  headers: {},
                  url: uri,
                  rawRequest: xhr
              };
              if(xhr.getAllResponseHeaders){ //remember xhr can in fact be XDR for CORS in IE
                  response.headers = parseHeaders(xhr.getAllResponseHeaders());
              }
          } else {
              err = new Error("Internal XMLHttpRequest Error");
          }
          return callback(err, response, response.body)
      }

      var xhr = options.xhr || null;

      if (!xhr) {
          if (options.cors || options.useXDR) {
              xhr = new createXHR.XDomainRequest();
          }else{
              xhr = new createXHR.XMLHttpRequest();
          }
      }

      var key;
      var aborted;
      var uri = xhr.url = options.uri || options.url;
      var method = xhr.method = options.method || "GET";
      var body = options.body || options.data;
      var headers = xhr.headers = options.headers || {};
      var sync = !!options.sync;
      var isJson = false;
      var timeoutTimer;
      var failureResponse = {
          body: undefined,
          headers: {},
          statusCode: 0,
          method: method,
          url: uri,
          rawRequest: xhr
      };

      if ("json" in options && options.json !== false) {
          isJson = true;
          headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
          if (method !== "GET" && method !== "HEAD") {
              headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
              body = JSON.stringify(options.json === true ? body : options.json);
          }
      }

      xhr.onreadystatechange = readystatechange;
      xhr.onload = loadFunc;
      xhr.onerror = errorFunc;
      // IE9 must have onprogress be set to a unique function.
      xhr.onprogress = function () {
          // IE must die
      };
      xhr.onabort = function(){
          aborted = true;
      };
      xhr.ontimeout = errorFunc;
      xhr.open(method, uri, !sync, options.username, options.password);
      //has to be after open
      if(!sync) {
          xhr.withCredentials = !!options.withCredentials;
      }
      // Cannot set timeout with sync request
      // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
      // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
      if (!sync && options.timeout > 0 ) {
          timeoutTimer = setTimeout(function(){
              if (aborted) return
              aborted = true;//IE9 may still call readystatechange
              xhr.abort("timeout");
              var e = new Error("XMLHttpRequest timeout");
              e.code = "ETIMEDOUT";
              errorFunc(e);
          }, options.timeout );
      }

      if (xhr.setRequestHeader) {
          for(key in headers){
              if(headers.hasOwnProperty(key)){
                  xhr.setRequestHeader(key, headers[key]);
              }
          }
      } else if (options.headers && !isEmpty(options.headers)) {
          throw new Error("Headers cannot be set on an XDomainRequest object")
      }

      if ("responseType" in options) {
          xhr.responseType = options.responseType;
      }

      if ("beforeSend" in options &&
          typeof options.beforeSend === "function"
      ) {
          options.beforeSend(xhr);
      }

      // Microsoft Edge browser sends "undefined" when send is called with undefined value.
      // XMLHttpRequest spec says to pass null as body to indicate no body
      // See https://github.com/naugtur/xhr/issues/100.
      xhr.send(body || null);

      return xhr


  }

  function getXml(xhr) {
      // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
      // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
      try {
          if (xhr.responseType === "document") {
              return xhr.responseXML
          }
          var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
          if (xhr.responseType === "" && !firefoxBugTakenEffect) {
              return xhr.responseXML
          }
      } catch (e) {}

      return null
  }

  function noop$1() {}
  xhr["default"] = default_1;

  function postLog(url, json) {
    var time = rfc3339nano();
    var keys = objectKeys(json);
    var kv = {
      time: time
    };
    keys.forEach(function (k) {
      kv[k] = safeJSONStringify(json[k]);
    });

    try {
      xhr({
        url: url + '?time=' + decodeURIComponent(time),
        method: 'POST',
        body: safeJSONStringify(kv),
        headers: {
          'Content-Type': 'application/json'
        }
      }, noop);
    } catch (err) {}
  }
  function postPerf(perfUrl, json) {
    var queryString = urlStringify(_objectSpread({}, json, {
      time: rfc3339nano()
    }));
    xhr("".concat(perfUrl, "?").concat(queryString), noop);
  }

  /**
   * when play, starts recording
   * when pause, records once and stops recording, and calcs once
   */

  var Perf =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Perf, _Model);

    function Perf(player) {
      var _this;

      _classCallCheck(this, Perf);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Perf).call(this, player));
      _this.perfLogUrl = player._config.perfLogUrl;
      _this.buffer_records = [];
      _this.metric_records = [];
      _this.provider_is_html5 = false;
      _this.provider_name = '';
      _this.stream_url = '';
      _this.perf_id = '';
      _this.perf_paused = true;
      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getMediaHeight').method('getMediaWidth').method('getMetrics');
      if (!_this.perfLogUrl) return _possibleConstructorReturn(_this, _assertThisInitialized(_assertThisInitialized(_this))); // if perfLogUrl isn't set, do not caculate

      if (isX5Layer()) return _possibleConstructorReturn(_this, _assertThisInitialized(_assertThisInitialized(_this))); // in x5 kernel, video.webkitVideoxxxx always 0
      // if (isIE() && browserVersion.major < 9) return this // in ie<10, post with application/json not allowed

      _this.calcTimer = new Timer({
        gap: 3000
      });
      _this.recordTimer = new Timer({
        gap: 800
      });

      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInited.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(INTERNAL_PROVIDER_REMOVED, _this._onProviderRemoved.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.recordTimer.on('tick', _this._onRecordTimerTick.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.recordTimer.on('start', _this._onRecordTimerTick.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.calcTimer.on('tick', _this._onCalcTimerTick.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      return _this;
    }

    _createClass(Perf, [{
      key: "remove",
      value: function remove() {
        _get(_getPrototypeOf(Perf.prototype), "remove", this).call(this);

        this.recordTimer && this.recordTimer.stop();
        this.calcTimer && this.calcTimer.stop();
      }
    }, {
      key: "getMediaHeight",
      value: function getMediaHeight() {
        if (!this.provider()) return -1;
        return this.provider().getHeight();
      }
    }, {
      key: "getMeidaWidth",
      value: function getMeidaWidth() {
        if (!this.provider()) return -1;
        return this.provider().getWidth();
      }
    }, {
      key: "getMetrics",
      value: function getMetrics() {
        if (!this.provider()) return null;
        return this.provider().getMetrics();
      }
    }, {
      key: "recordMetrics",
      value: function recordMetrics() {
        this.metric_records.push(_objectSpread({
          time: this._getTs(),
          pos: this.player.model.progress.getPosition()
        }, this.getMetrics()));
      }
    }, {
      key: "calcBufferTimes",
      value: function calcBufferTimes() {
        var ts = this._getTs();

        var last3sRecords = this.buffer_records.filter(function (item) {
          return item.time >= ts - 3000 && item.time < ts;
        });
        this.buffer_records = this.buffer_records.filter(function (item) {
          return item.time < ts - 30000;
        }); // clear history before 30s from now

        return {
          times: last3sRecords.filter(function (r) {
            return r.type === 'waiting';
          }).length,
          records: last3sRecords
        };
      }
    }, {
      key: "calcBuffer",
      value: function calcBuffer() {
        var buffer = this.player.model.progress.getBuffer();
        var length = buffer.reduce(function (l, bf) {
          return l + (bf.end - bf.start);
        }, 0);
        return {
          buffer: buffer,
          length: length
        };
      }
    }, {
      key: "calcMetrics",
      value: function calcMetrics() {
        var ts = this._getTs();

        var last3sRecords = this.metric_records.filter(function (item) {
          return item.time >= ts - 3000 && item.time <= ts;
        });
        this.metric_records = this.metric_records.filter(function (item) {
          return item.time < ts - 3000;
        });
        if (last3sRecords.length === 0) return;
        var type;
        var metric = {};
        var firstMetric = last3sRecords[0];

        if (!is('undefined', firstMetric.fps)) {
          type = 'flash';
          metric = this._calcFlashMetrics(last3sRecords);
        } else if (!is('undefined', firstMetric.mozParsedFrames)) {
          type = 'moz';
          metric = this._calcMozMetrics(last3sRecords);
        } else if (!is('undefined', firstMetric.webkitAudioDecodedByteCount)) {
          type = 'webkit';
          metric = this._calcWebkitMetrics(last3sRecords);
        } else {
          type = 'other';
        }

        return _objectSpread({}, metric, {
          type: type,
          records: last3sRecords
        });
      }
    }, {
      key: "_calcFlashMetrics",
      value: function _calcFlashMetrics(records) {
        var metric = {
          fps: 0,
          bps: 0
        };
        var fpsArr = records.map(function (re) {
          return re.fps;
        }).filter(function (fps) {
          return fps > 0;
        }); // remove fps <= 0

        var bpsArr = records.map(function (re) {
          return re.bps;
        }).filter(function (bps) {
          return bps > 0;
        });
        var fpsLen = fpsArr.length;
        var bpsLen = bpsArr.length;
        fpsArr.forEach(function (fps) {
          metric.fps += fps / fpsLen;
        });
        bpsArr.forEach(function (bps) {
          metric.bps += bps / bpsLen;
        });
        return metric;
      }
    }, {
      key: "_calcWebkitMetrics",
      value: function _calcWebkitMetrics(records) {
        var metric = {
          fps: 0,
          bps: 0,
          decodedFps: 0,
          droppedFps: 0,
          audioBps: 0,
          videoBps: 0,
          recordsLength: records.length
        };

        if (records.length === 1) {
          // one record cant calc
          return metric;
        }

        var formatRecords = records.map(function (_, i, arr) {
          if (i === 0) {
            return {
              time: 0
            };
          }

          return {
            time: arr[i].time - arr[i - 1].time,
            audioDecodedBytes: arr[i].webkitAudioDecodedByteCount - arr[i - 1].webkitAudioDecodedByteCount,
            videoDecodedBytes: arr[i].webkitVideoDecodedByteCount - arr[i - 1].webkitVideoDecodedByteCount,
            decodedFrames: arr[i].webkitDecodedFrameCount - arr[i - 1].webkitDecodedFrameCount,
            droppedFrames: arr[i].webkitDroppedFrameCount - arr[i - 1].webkitDroppedFrameCount
          };
        }).filter(function (re) {
          return re.time !== 0;
        });
        var metricArr = formatRecords.map(function (re) {
          var time = re.time / 1000;
          var me = {
            decodedFps: re.decodedFrames / time,
            droppedFps: re.droppedFrames / time,
            audioBps: re.audioDecodedBytes / time,
            videoBps: re.videoDecodedBytes / time,
            time: time
          };
          me.fps = me.decodedFps + me.droppedFps;
          me.bps = me.audioBps + me.videoBps;
          return me;
        });
        var fullTime = metricArr.reduce(function (ft, me) {
          return ft + me.time;
        }, 0);
        metricArr.forEach(function (me) {
          metric.decodedFps = me.decodedFps * me.time / fullTime + metric.decodedFps;
          metric.droppedFps = me.droppedFps * me.time / fullTime + metric.droppedFps;
          metric.audioBps = me.audioBps * me.time / fullTime + metric.audioBps;
          metric.videoBps = me.videoBps * me.time / fullTime + metric.videoBps;
        });
        metric.fps = metric.decodedFps + metric.droppedFps;
        metric.bps = metric.audioBps + metric.videoBps;
        return metric;
      }
    }, {
      key: "_calcMozMetrics",
      value: function _calcMozMetrics(records) {
        var metric = {
          fps: 0,
          parsedFps: 0,
          decodedFps: 0,
          presentedFps: 0,
          paintedFps: 0,
          recordsLength: records.length
        };

        if (records.length === 1) {
          // one record cant calc
          return metric;
        }

        var formatRecords = records.map(function (_, i, arr) {
          if (i === 0) {
            return {
              time: 0
            };
          }

          return {
            time: arr[i].time - arr[i - 1].time,
            parsedFrames: arr[i].mozParsedFrames - arr[i - 1].mozParsedFrames,
            decodedFrames: arr[i].mozDecodedFrames - arr[i - 1].mozDecodedFrames,
            presentedFrames: arr[i].mozPresentedFrames - arr[i - 1].mozPresentedFrames,
            paintedFrames: arr[i].mozPaintedFrames - arr[i - 1].mozPaintedFrames
          };
        }).filter(function (re) {
          return re.time !== 0;
        });
        var metricArr = formatRecords.map(function (re) {
          var time = re.time / 1000;
          var me = {
            parsedFps: re.parsedFrames / time,
            decodedFps: re.decodedFrames / time,
            presentedFps: re.presentedFrames / time,
            paintedFps: re.paintedFrames / time,
            time: time
          };
          me.fps = me.parsedFps;
          return me;
        });
        var fullTime = metricArr.reduce(function (ft, me) {
          return ft + me.time;
        }, 0);
        metricArr.forEach(function (me) {
          metric.parsedFps = me.parsedFps * me.time / fullTime + metric.parsedFps;
          metric.decodedFps = me.decodedFps * me.time / fullTime + metric.decodedFps;
          metric.presentedFps = me.presentedFps * me.time / fullTime + metric.presentedFps;
          metric.paintedFps = me.paintedFps * me.time / fullTime + metric.paintedFps;
        });
        metric.fps = metric.parsedFps;
        return metric;
      }
    }, {
      key: "_onProviderInited",
      value: function _onProviderInited(_ref) {
        var file = _ref.file;
        this.stream_url = file;
        this.provider_is_html5 = this.player._provider.html5;
        this.provider_name = this.player._provider.name;
        this.perf_id = this.player._status.uniqId + '_' + randomString(2);
        this.buffer_records = [];
        this.metric_records = [];
        this.onProvider(PROVIDER_WAITING, this._onWaiting.bind(this));
        this.onProvider(PROVIDER_PLAY, this._onPlay.bind(this));
        this.onProvider(PROVIDER_PAUSE, this._onPause.bind(this));
      }
    }, {
      key: "_onProviderRemoved",
      value: function _onProviderRemoved() {
        this.stream_url = '';
        this.provider_name = '';
        this.buffer_records = [];
        this.metric_records = [];
        this.calcTimer && this.calcTimer.stop();
        this.recordTimer && this.recordTimer.stop();
      }
    }, {
      key: "_onCalcTimerTick",
      value: function _onCalcTimerTick(_ref2) {
        var isStop = _ref2.isStop,
            duration = _ref2.duration;

        if (isStop) {
          return;
        }

        var metrics = this.calcMetrics();

        if (!metrics) {
          return;
        }

        var bfTimes = this.calcBufferTimes();
        var bf = this.calcBuffer();
        var firstMetricRecord = metrics.records[0];
        var lastMetricRecord = metrics.records[metrics.records.length - 1];
        var record_pos = firstMetricRecord && firstMetricRecord.pos; // eslint-disable-line

        var record_time = lastMetricRecord && lastMetricRecord.pos - firstMetricRecord.pos; // eslint-disable-line

        var json = {
          fps: metrics.fps,
          bps: metrics.bps,
          waiting_times: bfTimes.times,
          buffer_length: bf.length,
          decoded_fps: is('number', metrics.decodedFps) ? metrics.decodedFps : -1,
          dropped_fps: is('number', metrics.droppedFps) ? metrics.droppedFps : -1,
          audio_bps: is('number', metrics.audioBps) ? metrics.audioBps : -1,
          video_bps: is('number', metrics.videoBps) ? metrics.videoBps : -1,
          records_count: metrics.records.length,
          record_pos: record_pos,
          record_time: record_time,
          metric_type: metrics.type,
          buffer_detail: JSON.stringify(bf.buffer),
          metrics_detail: JSON.stringify(metrics),
          stream_url: this.stream_url,
          metric_id: this.perf_id,
          user_agent: navigator.userAgent,
          refer: window.location.href
        };
        postPerf(this.perfLogUrl, json);
      }
    }, {
      key: "_onRecordTimerTick",
      value: function _onRecordTimerTick(_ref3) {
        var isStop = _ref3.isStop;
        !isStop && this.recordMetrics();
      }
    }, {
      key: "_onWaiting",
      value: function _onWaiting() {
        this.buffer_records.push({
          type: 'waiting',
          pos: this.player.model.progress.getPosition(),
          time: this._getTs()
        });
      }
    }, {
      key: "_onPlay",
      value: function _onPlay() {
        this.buffer_records.push({
          type: 'play',
          pos: this.player.model.progress.getPosition(),
          time: this._getTs()
        });
        this.recordTimer.start();
        this.calcTimer.start();
      }
    }, {
      key: "_onPause",
      value: function _onPause() {
        this.recordTimer.tick();
        this.recordTimer.stop();
        this.calcTimer.tick();
        this.calcTimer.stop();
      }
    }, {
      key: "_getTs",
      value: function _getTs() {
        return new Date().getTime();
      }
    }]);

    return Perf;
  }(Model);

  var TextTrack =
  /*#__PURE__*/
  function (_Model) {
    _inherits(TextTrack, _Model);

    function TextTrack(player) {
      var _this;

      _classCallCheck(this, TextTrack);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(TextTrack).call(this, player));

      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInited.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getTextTracks').method('setTextTrackEnable').method('setTextTrackDisable').method('getTextTrackCues').method('getTextTrackActiveCues');
      return _this;
    }
    /**
     * 获取所有的字幕轨道
     */


    _createClass(TextTrack, [{
      key: "getTextTracks",
      value: function getTextTracks() {
        if (this.provider()) {
          return this.provider().getTextTracks();
        }

        return [];
      }
      /**
       * 获取轨道中所有的字幕
       * @param {*} index
       */

    }, {
      key: "getTextTrackCues",
      value: function getTextTrackCues() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        if (this.provider()) return this.provider().getTextTrackCues(index);
        return [];
      }
      /**
       * 获取轨道应该显示的字幕
       * @param {Number} index
       */

    }, {
      key: "getTextTrackActiveCues",
      value: function getTextTrackActiveCues() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        if (this.provider()) return this.provider().getTextTrackActiveCues(index);
        return [];
      }
      /**
       * 启用索引为index的字幕轨道，启用之后如果该轨道字幕变化，会触发cuechange事件
       * @param {*} index
       */

    }, {
      key: "setTextTrackEnable",
      value: function setTextTrackEnable() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (this.provider()) {
          return this.provider().setTextTrackEnable(index);
        }
      }
      /**
       * 禁用索引为index的字幕轨道，禁用之后如果该轨道字幕变化，不会触发cuechange事件
       * @param {*} index
       */

    }, {
      key: "setTextTrackDisable",
      value: function setTextTrackDisable() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (this.provider()) {
          return this.provider().setTextTrackDisable(index);
        }
      }
    }, {
      key: "_onProviderInited",
      value: function _onProviderInited() {
        this.onProvider(PROVIDER_TEXTTRACKADD, this._onTexttrackAdd.bind(this));
        this.onProvider(PROVIDER_TEXTTRACKCHANGE, this._onTexttrackChange.bind(this));
        this.onProvider(PROVIDER_CUECHANGE, this._onCueChange.bind(this));
      }
    }, {
      key: "_onCueChange",
      value: function _onCueChange(_ref) {
        var track = _ref.track,
            cues = _ref.cues,
            activeCues = _ref.activeCues;
        this.player.trigger(OUTER_TEXT_TRACK_CUE_CHANGE, {
          track: track,
          cues: cues,
          activeCues: activeCues,
          type: OUTER_TEXT_TRACK_CUE_CHANGE
        });
      }
    }, {
      key: "_onTexttrackAdd",
      value: function _onTexttrackAdd(track) {
        this.player.trigger(OUTER_TEXT_TRACK_ADD, {
          track: track,
          type: OUTER_TEXT_TRACK_ADD
        });
      }
    }, {
      key: "_onTexttrackChange",
      value: function _onTexttrackChange(tracks) {
        this.player.trigger(OUTER_TEXT_TRACK_CHANGE, {
          tracks: tracks,
          type: OUTER_TEXT_TRACK_CHANGE
        });
      }
    }]);

    return TextTrack;
  }(Model);

  var Subtitle =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Subtitle, _Model);

    function Subtitle(player) {
      var _this;

      _classCallCheck(this, Subtitle);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Subtitle).call(this, player));
      _this._fontSize = 0;
      _this._borderRadius = 0;
      _this._subtitleTrackIdx = -1; // 自动选择一个，选择之后就设置成track的索引

      _this._showSubtitles = player._config.showSubtitle;
      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getShowSubtitle').method('setShowSubtitle').method('setShowingTextTrackIndex').method('getShowingTextTrackIndex');

      _this.onPlayer(INTERNAL_PROVIDER_REMOVED, _this._onProviderRemoved.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(OUTER_TEXT_TRACK_ADD, _this._onTextTrackAdd.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(OUTER_TEXT_TRACK_CUE_CHANGE, _this._onCueChange.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      return _this;
    }
    /**
     * 设置是否显示字幕
     * @param {*} show
     */


    _createClass(Subtitle, [{
      key: "setShowSubtitle",
      value: function setShowSubtitle(show) {
        show = !!show;

        if (show && !this._isShowingSubtitles()) {
          // 如果设置显示，但是当前没有显示字幕，那么显示一个
          this._showRandomSubtitle();
        }

        if (!show && this._isShowingSubtitles()) {
          // 如果设置不显示，但是当前有字幕在显示，那么关闭当前显示的字幕
          this._clearShowingCues();

          this._subtitleTrackIdx = -1;
        }

        this._showSubtitles = show;
      }
      /**
       * 获取当前是否显示字幕
       */

    }, {
      key: "getShowSubtitle",
      value: function getShowSubtitle() {
        return this._showSubtitles;
      }
      /**
       * 设置显示该字幕轨道
       * 将textTrack中索引为index的轨道显示到播放器上，仅能显示(captions/subtitles)
       * 如果当前getSubtitles()返回false 则还需要setSubtitles(true)
       *
       * @param {*} index
       */

    }, {
      key: "setShowingTextTrackIndex",
      value: function setShowingTextTrackIndex() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var tracks = this.player.model.textTrack.getTextTracks();
        var track = tracks[index];
        if (index === this._subtitleTrackIdx) return;

        if (track) {
          // 禁用其他track, 因为如果有多个track enable，只有一个track能发出cueChange事件
          if (this._subtitleTrackIdx >= 0) this.player.model.textTrack.setTextTrackDisable(this._subtitleTrackIdx);
          this._subtitleTrackIdx = index; // index 仅在这里修改

          this.player.model.textTrack.setTextTrackEnable(index); // 如果设置显示该轨道，但是轨道没启用，那么启用该轨道
        }
      }
    }, {
      key: "getShowingTextTrackIndex",
      value: function getShowingTextTrackIndex() {
        return this._subtitleTrackIdx;
      }
    }, {
      key: "_onCueChange",
      value: function _onCueChange(_ref) {
        var track = _ref.track,
            activeCues = _ref.activeCues;
        var tracks = this.player.model.textTrack.getTextTracks();
        var index = tracks.indexOf(track);

        if (index === this._subtitleTrackIdx) {
          this._showActiveCues(activeCues);
        }
      }
    }, {
      key: "_onTextTrackAdd",
      value: function _onTextTrackAdd(_ref2) {
        var track = _ref2.track;

        if (this._showSubtitles && this._subtitleTrackIdx === -1) {
          // 如果当前设置显示了字幕，但是没有一个可显示的，那么显示一个
          this._showRandomSubtitle();
        }
      }
      /**
       * 设置显示中的字幕的字体大小和边框弧度
       */

    }, {
      key: "_updateSubtitleStyle",
      value: function _updateSubtitleStyle() {
        var _this2 = this;

        var subtitles = [].slice.call(document.querySelectorAll(".".concat(subtitleItem)));
        subtitles.forEach(function (sub) {
          sub.style.fontSize = _this2._fontSize + 'px';
          sub.style.borderRadius = _this2._borderRadius + 'px';
        });
      }
    }, {
      key: "_onProviderRemoved",
      value: function _onProviderRemoved() {
        this._clearShowingCues();

        this._subtitleTrackIdx = -1;
      }
      /**
       * 当前是否正在显示字幕
       */

    }, {
      key: "_isShowingSubtitles",
      value: function _isShowingSubtitles() {
        return this._showSubtitles && this._subtitleTrackIdx !== -1;
      }
      /**
       * 选择一个subtitle或者caption track
       */

    }, {
      key: "_selectSubtitleTrack",
      value: function _selectSubtitleTrack() {
        var tracks = this.player.model.textTrack.getTextTracks();
        var firstSubtitle;
        var firstHiddenSubtitle; // hidden通常是m3u8 manifest 设为default的subtitle

        for (var i = 0; i < tracks.length; i++) {
          if (tracks[i].kind === 'subtitles' || tracks[i].kind === 'captions') {
            if (!firstSubtitle) {
              firstSubtitle = {
                index: i,
                track: tracks[i]
              };
            }

            if (tracks[i].mode === 'hidden' && !firstHiddenSubtitle) {
              firstHiddenSubtitle = {
                index: i,
                track: tracks[i]
              };
            }
          }
        }

        return firstHiddenSubtitle || firstSubtitle || {
          index: -1,
          track: null
        };
      }
      /**
       * 删除显示中的字幕
       */

    }, {
      key: "_clearShowingCues",
      value: function _clearShowingCues() {
        var subtitleWrap = document.querySelector(".".concat(subtitle$1));
        subtitleWrap.innerHTML = '';
      }
    }, {
      key: "_showActiveCues",
      value: function _showActiveCues(cues) {
        if (!cues.length) return this._clearShowingCues();
        cues.sort(function (c1, c2) {
          var diff = c1.startTime - c2.startTime;

          if (diff) {
            return diff;
          } else {
            return c2.endTime - c1.endTime;
          }
        });
        var style = "font-size: ".concat(this._fontSize, "px; border-radius: ").concat(this._borderRadius, "px");
        var spans = cues.map(function (cue) {
          var span = "<span class=\"".concat(subtitleItem, "\" style=\"").concat(style, "\">&nbsp;").concat(cue.text, "&nbsp;</span>");
          return span;
        });
        var subtitleWrap = document.querySelector(".".concat(subtitle$1));
        subtitleWrap.innerHTML = spans.join('<br>');
      }
      /**
       * 根据播放器宽度来设置字幕的字体大小和边框弧度
       * @param {*} playerWidth
       */

    }, {
      key: "_setSubtitleSize",
      value: function _setSubtitleSize(playerWidth) {
        var borderRadiusMultiple = 0.003125;
        var fontSizeMultiple = 0.025;
        var minFontSize = 14;
        var maxFontSize = 40;
        var minBorderRadius = 1.5;
        this._fontSize = Math.max(playerWidth * fontSizeMultiple, minFontSize);
        this._fontSize = Math.min(this._fontSize, maxFontSize);
        this._borderRadius = Math.max(playerWidth * borderRadiusMultiple, minBorderRadius);
      }
      /**
       * 找到一个captions/subtitles 并显示它
       */

    }, {
      key: "_showRandomSubtitle",
      value: function _showRandomSubtitle() {
        var _this$_selectSubtitle = this._selectSubtitleTrack(),
            index = _this$_selectSubtitle.index;

        if (index === -1) {
          return false;
        }

        this.setShowingTextTrackIndex(index, true);
        return true;
      }
    }]);

    return Subtitle;
  }(Model);

  var OUTER_MYUN_SYNC_AVAILABLE = 'myunSyncAvailable';
  var OUTER_MYUN_SYNC_MESSAGE = 'myunSyncMessage';

  var MyunSync =
  /*#__PURE__*/
  function (_Model) {
    _inherits(MyunSync, _Model);

    function MyunSync(player) {
      var _this;

      _classCallCheck(this, MyunSync);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(MyunSync).call(this, player)); // 当前目睹云同步是否可用

      _this._available = false; // 目睹云同步时的track label对应m3u8 master里的name

      _this._textTrackLabel = player._config.myunSyncTextTrackLabel; // 当前用于同步的字幕轨道

      _this._myunSyncTrack = null; // 最新的同步信息

      _this._myunMsgCue = null;

      _this.onPlayer(INTERNAL_PROVIDER_REMOVED, _this._onProviderRemoved.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(OUTER_TEXT_TRACK_ADD, _this._onTextTrackAdd.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(OUTER_TEXT_TRACK_CUE_CHANGE, _this._onCueChange.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getMyunSyncAvailable');
      return _this;
    }

    _createClass(MyunSync, [{
      key: "getMyunSyncAvailable",
      value: function getMyunSyncAvailable() {
        return this._available;
      }
    }, {
      key: "_onProviderRemoved",
      value: function _onProviderRemoved() {
        this._myunSyncTrack = null;
        this._available = false;
        this._myunMsgCue = null;
        this.player.trigger(OUTER_MYUN_SYNC_AVAILABLE, {
          type: OUTER_MYUN_SYNC_AVAILABLE,
          available: false
        });
      }
    }, {
      key: "_onTextTrackAdd",
      value: function _onTextTrackAdd(_ref) {
        var track = _ref.track;

        if (track.label === this._textTrackLabel && track.kind === 'subtitles') {
          var tracks = this.player.model.textTrack.getTextTracks();
          var idx = tracks.indexOf(track);
          this.player.model.textTrack.setTextTrackEnable(idx);
          this._myunSyncTrack = track;
          this._available = true;
          this.player.trigger(OUTER_MYUN_SYNC_AVAILABLE, {
            type: OUTER_MYUN_SYNC_AVAILABLE,
            available: true
          });
        }
      }
    }, {
      key: "_onCueChange",
      value: function _onCueChange(_ref2) {
        var _this2 = this;

        var activeCues = _ref2.activeCues,
            cues = _ref2.cues,
            track = _ref2.track;
        if (track !== this._myunSyncTrack) return;
        if (activeCues.length === 0) return;
        var cue = activeCues.pop();
        if (cue === this._myunMsgCue) return; // 如果仅仅是cues更改，而最新的activeCue没有更改，不触发message事件

        this._myunMsgCue = cue; // 后端的webvtt消息格式改过 兼容

        var textList = JSON.parse(cue.text);

        if (Array.isArray(textList) && textList[0].ts_ms && textList[0].content) {
          textList.forEach(function (text) {
            setTimeout(function () {
              _this2.player.trigger(OUTER_MYUN_SYNC_MESSAGE, {
                type: OUTER_MYUN_SYNC_MESSAGE,
                message: text.content
              });
            }, text.ts_ms);
          });
        } else {
          this.player.trigger(OUTER_MYUN_SYNC_MESSAGE, {
            type: OUTER_MYUN_SYNC_MESSAGE,
            message: cue.text,
            cue: cue,
            cues: cues
          });
        }
      }
    }]);

    return MyunSync;
  }(Model);

  var orientation = {
    isAvailable: function isAvailable() {
      return !!(window.screen && window.screen.orientation);
    },
    lock: function lock(orientationLockType) {
      var prom = window.screen.orientation.lock(orientationLockType);
      return prom;
    },
    unlock: function unlock() {
      window.screen.orientation.unlock();
    },
    getType: function getType() {
      return window.screen.orientation.type;
    },
    getAngle: function getAngle() {
      return window.screen.orientation.angle;
    },
    getOrientationObj: function getOrientationObj() {
      return window.screen.orientation;
    }
  };

  /**
   * Orientation api还处于WIP状态，很多浏览器不支持，并且api可能被修改
   */

  var Orientation =
  /*#__PURE__*/
  function (_Model) {
    _inherits(Orientation, _Model);

    function Orientation(player) {
      var _this;

      _classCallCheck(this, Orientation);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Orientation).call(this, player));
      _this._onFullscreen = _this._onFullscreen.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this._available = orientation.isAvailable();

      if (_this._available) {
        _this.onPlayer(OUTER_FULLSCREEN, _this._onFullscreen);
      }

      return _this;
    }

    _createClass(Orientation, [{
      key: "_onFullscreen",
      value: function _onFullscreen(_ref) {
        var fullscreen = _ref.fullscreen;

        if (fullscreen) {
          if (this.provider()) {
            var videoWidth = this.provider().getWidth();
            var videoHeight = this.provider().getHeight();
            var screenAspect = getScrenAspect();
            var lockType = '';

            if (videoWidth && videoHeight) {
              var videoRatio = videoWidth / videoHeight;
              var screenRatio = screenAspect.width / screenAspect.height;

              if (videoRatio > screenRatio) {
                lockType = 'landscape';
              } else {
                lockType = 'portrait';
              }

              orientation.lock(lockType)["catch"](noop);
            }
          }
        } else {
          orientation.unlock();
        }
      }
    }]);

    return Orientation;
  }(Model);

  var RecordRestrict =
  /*#__PURE__*/
  function (_Model) {
    _inherits(RecordRestrict, _Model);

    function RecordRestrict(player) {
      var _this;

      _classCallCheck(this, RecordRestrict);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(RecordRestrict).call(this, player));
      _this._is360loneWindow = false;
      _this._timer = 0;
      var _360loneStrict = player._config.recordRestrict.enable360LoneWindowCloseStream;

      var shouldListen = _360loneStrict && (isChrome() || isIE());

      shouldListen && _this.oncePlayer(INTERNAL_PROVIDER_INITED, function () {
        player.timer.raf.on('tick', function (_ref) {
          var isStop = _ref.isStop;

          if (!isStop) {
            _this._onTimerTick();
          }
        });
      });
      return _this;
    }

    _createClass(RecordRestrict, [{
      key: "_onTimerTick",
      value: function _onTimerTick() {
        var _this2 = this;

        var is360loneWindow = this._detect360loneWindow();

        var player = this.player;

        if (this._is360loneWindow !== is360loneWindow) {
          this._is360loneWindow = is360loneWindow;

          if (this._is360loneWindow) {
            clearTimeout(this._timer);
            this._timer = setTimeout(function () {
              _this2._showRecordRestrict360();

              player.stop();

              _this2._removeProviderElement();
            }, 20);
          } else {
            this._hideRecordREstrict360();
          }
        }

        if (this._is360loneWindow) {
          player.dom.controllerWrap.style.display = 'none';
        }
      }
    }, {
      key: "_showRecordRestrict360",
      value: function _showRecordRestrict360() {
        var dom = this.player.dom.recordRestrict360;
        var styleText = 'position:absolute;top:0;left:0;right:0;bottom:0;background-color:#000;z-index:9999;';
        var browserCompatiableStyle = isIE() ? '' : 'top:50%;margin-top:-0.75em;';
        dom.setAttribute('style', styleText);
        dom.innerHTML = "<div class=\"".concat(reset, "\" style=\"position:absolute;").concat(browserCompatiableStyle, "width:100%;text-align:center;color:#fff;font-size:1.25em;line-height:1.5em;\">\u89C6\u9891\u7981\u6B62\u5728\u5C0F\u7A97\u53E3\u64AD\u653E\uFF0C\u8BF7\u9000\u51FA\u5C0F\u7A97\u540E\u5237\u65B0\u9875\u9762\u7EE7\u7EED\u89C2\u770B</div>");
      }
    }, {
      key: "_hideRecordREstrict360",
      value: function _hideRecordREstrict360() {
        var dom = this.player.dom.recordRestrict360;
        dom.setAttribute('style', '');
      }
    }, {
      key: "_detect360loneWindow",
      value: function _detect360loneWindow() {
        var provider = this.player._provider;
        var dom = this.player.dom;
        var container = dom.container;

        if (provider) {
          if (provider.html5) {
            // 360小窗会给div加上 visibility:hidden opacity:0 但是播放器不会
            var div = container.querySelector('div');
            var styleAttr = div.getAttribute('style') || '';
            var is360loneWindow = styleAttr.indexOf('visibility:hidden') >= 0 && styleAttr.indexOf('opacity:0') >= 0;
            return is360loneWindow;
          } else if (provider.flash) {
            var flash$$1 = document.querySelector('object');
            var width = flash$$1.style.width; // 360小窗会给object标签加上width，但是播放器不会

            return !!width;
          }
        } // 如果不存在provider，那就返回之前的状态


        return this._is360loneWindow;
      }
    }, {
      key: "_removeProviderElement",
      value: function _removeProviderElement() {
        var videoWrap$$1 = this.player.dom.videoWrap;
        var video$$1 = videoWrap$$1.querySelector('video');
        var object = videoWrap$$1.querySelector('object');

        if (video$$1) {
          videoWrap$$1.removeChild(video$$1);
        }

        if (object) {
          videoWrap$$1.removeChild(object);
        }
      }
    }, {
      key: "remove",
      value: function remove() {
        clearTimeout(this._timer);

        _get(_getPrototypeOf(RecordRestrict.prototype), "remove", this).call(this);
      }
    }]);

    return RecordRestrict;
  }(Model);

  var LiveEndDetect =
  /*#__PURE__*/
  function (_Model) {
    _inherits(LiveEndDetect, _Model);

    function LiveEndDetect(player) {
      var _this;

      _classCallCheck(this, LiveEndDetect);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(LiveEndDetect).call(this, player));
      _this._enableDetect = false;
      _this._isLive = false;
      _this._streamType = '';
      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('setLiveEndDetect').method('getLiveEndDetect');

      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInit.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(OUTER_IDLE, _this._onIdle.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(OUTER_ERROR, _this._onError.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(OUTER_BUFFER, _this._onBuffer.bind(_assertThisInitialized(_assertThisInitialized(_this)))); // time事件比较频繁，所以是x5才监听


      isX5Layer() && _this.onPlayer(OUTER_TIME, _this._onTime.bind(_assertThisInitialized(_assertThisInitialized(_this))));
      return _this;
    }

    _createClass(LiveEndDetect, [{
      key: "setLiveEndDetect",
      value: function setLiveEndDetect(enable) {
        this._enableDetect = !!enable;
      }
    }, {
      key: "getLiveEndDetect",
      value: function getLiveEndDetect() {
        return this._enableDetect;
      }
    }, {
      key: "_onProviderInit",
      value: function _onProviderInit(_ref) {
        var isLive = _ref.isLive,
            type = _ref.type;
        this._isLive = isLive;
        this._streamType = type;
      }
    }, {
      key: "_shouldDetect",
      value: function _shouldDetect(streamType) {
        if (streamType) {
          return this._enableDetect && this._isLive && this._streamType === streamType;
        }

        return this._enableDetect && this._isLive;
      }
    }, {
      key: "_triggerEvt",
      value: function _triggerEvt() {
        this.player.trigger(OUTER_LIVE_END_DETECT, {
          type: OUTER_LIVE_END_DETECT,
          liveEnd: true
        });
      }
    }, {
      key: "_onIdle",
      value: function _onIdle() {
        // flv/hls 断流会idle
        (this._shouldDetect('flv') || this._shouldDetect('hls') || this._shouldDetect('m3u8')) && this._triggerEvt();
      }
    }, {
      key: "_onError",
      value: function _onError(_ref2) {
        var fatal = _ref2.fatal;
        // hls.js/flash
        (this._shouldDetect('m3u8') || this._shouldDetect('hls')) && fatal && this._triggerEvt();
      }
    }, {
      key: "_onBuffer",
      value: function _onBuffer() {
        // rtmp, mobile hls
        (this._shouldDetect('rtmp') || this._shouldDetect('hls') || this._shouldDetect('m3u8')) && this._triggerEvt();
      }
    }, {
      key: "_onTime",
      value: function _onTime(_ref3) {
        var position = _ref3.position;
        // x5
        this._shouldDetect('') && this._triggerEvt();
      }
    }]);

    return LiveEndDetect;
  }(Model);

  var PlaybackMessage =
  /*#__PURE__*/
  function (_Model) {
    _inherits(PlaybackMessage, _Model);

    function PlaybackMessage(player) {
      var _this;

      _classCallCheck(this, PlaybackMessage);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(PlaybackMessage).call(this, player));

      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInited.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.onPlayer(INTERNAL_PROVIDER_REMOVED, _this._onProviderRemoved.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.msgList = null;
      _this.lastMsgIdx = -2;
      return _this;
    }

    _createClass(PlaybackMessage, [{
      key: "_onTick",
      value: function _onTick() {
        if (!this.msgList) {
          return;
        }

        var pos = this.player.model.progress.getPosition();
        var idx;

        for (var i = 0; i < this.msgList.length; i++) {
          var msg = this.msgList[i];

          if (pos < msg.time) {
            idx = i - 1;
            break;
          }
        }

        if (idx === undefined) {
          idx = this.msgList.length - 1;
        }

        if (idx !== this.lastMsgIdx) {
          this.lastMsgIdx = idx;
          this.player.trigger('playbackMessage', {
            type: 'playbackMessage',
            prev: this.msgList[idx] || null,
            next: this.msgList[idx + 1] || null
          });
        }
      }
    }, {
      key: "_onProviderInited",
      value: function _onProviderInited() {
        var activeSource = getActive.call(this.player);
        this.msgList = is('array', activeSource.playbackMessages) ? activeSource.playbackMessages : null;

        if (this.msgList) {
          this.msgList.sort(function (msg1, msg2) {
            return msg1.time - msg2.time;
          });
        }
      }
    }, {
      key: "_onProviderRemoved",
      value: function _onProviderRemoved() {
        this.msgList = null;
        this.lastMsgIdx = -2;
      }
    }]);

    return PlaybackMessage;
  }(Model);

  var PlayBackRate =
  /*#__PURE__*/
  function (_Modal) {
    _inherits(PlayBackRate, _Modal);

    function PlayBackRate(player) {
      var _this2;

      _classCallCheck(this, PlayBackRate);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(PlayBackRate).call(this, player));
      _this2.dom = null;
      _this2.rateList = player._config.playbackRates;
      _this2.playbackRatesLabel = player._config.playbackRatesLabel;

      _this2.createDom();

      _this2.onPlayer(INTERNAL_PROVIDER_INITED, function () {
        console.log(player);

        _this2.onProviderInited();
      });

      _this2.onPlayer(INTERNAL_PROVIDER_REMOVED, function () {
        player.setPlaybackRate(1);
        setActiveRate.call(player, 'null'); // 清空选中记录

        _this2.qsPopup.hide();
      });

      _this2.qsPopup = tooltip$1(player.dom.playbackRate, {
        trigger: 'click',
        content: _this2.dom,
        container: player.dom.container,
        "class": 'mudu-popup',
        getMaxHeight: function getMaxHeight(_ref) {
          var height = _ref.height;
          return height - 70;
        }
      });
      return _this2;
    }

    _createClass(PlayBackRate, [{
      key: "createDom",
      value: function createDom() {
        /* prettier-ignore */
        var menu = "<div><div class=\"".concat(reset, " ").concat(panel, " ").concat(playRatePanel, "\">") + "<div class=\"".concat(reset, " ").concat(panelMenu, "\"></div>") + "</div></div>";
        this.dom = stringToDom(menu);
      }
    }, {
      key: "onProviderInited",
      value: function onProviderInited() {
        this.updateRateItem();
        this.updateControlRate();
        this.updateSwitchText();
      }
    }, {
      key: "updateControlRate",
      value: function updateControlRate() {
        var len = this.rateList.length;
        var isLive = getActive.call(this.player).isLive;
        var container = this.player.dom.container; // 以下三种状态不支持倍速播放
        // 1. 直播状态下 2.没有配置倍速播放  3.不支持倍速播放的播放器(flash)

        var hide$$1 = isLive || len < 1 || !this.player._provider || !this.player._provider.isPlaybackRateSupported;
        classList(container).remove(playrateReg);
        classList(container).add(hide$$1 ? hidePlaybackRate : showPlaybackRate);
      }
    }, {
      key: "updateSwitchText",
      value: function updateSwitchText() {
        var activeRate = this.rateList.filter(function (v) {
          return v.active;
        })[0];

        if (activeRate) {
          this.player.dom.playbackRate.innerHTML = activeRate.label;
        } else {
          this.player.dom.playbackRate.innerHTML = this.playbackRatesLabel;
        }
      }
    }, {
      key: "updateRateItem",
      value: function updateRateItem() {
        var itemStr = this.rateList.map(function (v, i) {
          return "<div class=\"".concat(reset, " ").concat(menuitem, "\" type=\"value\" value=\"").concat(i, "\">") + "<div class=\"".concat(reset, " ").concat(menuitemLabel, "\"></div>") + "<div class=\"".concat(reset, " ").concat(menuitemContent, "\">").concat(v.label, "</div>") + "</div>";
        }).join('');
        this.dom.querySelector(".".concat(playRatePanel)).innerHTML = itemStr;
        var items = this.dom.querySelectorAll('[type="value"]');

        var _this = this;

        var _loop = function _loop(i) {
          var item = items[i];
          var rate = _this.rateList[i].playbackRate;

          item.onclick = function () {
            _this.player.setPlaybackRate(+rate);

            setActiveRate.call(_this.player, i);
            _this.player.dom.playbackRate.innerHTML = _this.rateList[i].label;

            _this.rateList.map(function (rate, index) {
              items[index].querySelector(".".concat(menuitemLabel)).innerHTML = index === i ? "<span class=\"".concat(reset, " ").concat(check, "\"></span>") : '';
            });

            _this.qsPopup.hide();
          }; // 默认播放倍速playbackrate是正常速度1


          item.querySelector(".".concat(menuitemLabel)).innerHTML = rate === 1 ? "<span class=\"".concat(reset, " ").concat(check, "\"></span>") : '';
        };

        for (var i = 0; i < items.length; i++) {
          _loop(i);
        }
      }
    }]);

    return PlayBackRate;
  }(Model);

  function initModel() {
    this.model.fullscreen = new Fullsreen(this);
    this.model.video = new Video(this);
    this.model.progress = new Progress(this);
    this.model.controls = new Controls(this);
    this.model.volume = new Volume(this);
    this.model.playlist = new Playlist(this);
    this.model.hotkeys = new HotKeys(this);
    this.model.resize = new Resize(this);
    this.model.stretch = new Stretch(this);
    this.model.logo = new Logo(this);
    this.model.focus = new Focus(this);
    this.model.bezel = new Bezel(this);
    this.model.background = new Background(this);
    this.model.dom = new Dom(this);
    this.model.title = new Title(this);
    this.model.contextMenu = new ContextMenu(this);
    this.model.error = new Error$1(this);
    this.model.progressPopup = new ProgressPopup(this);
    this.model.notice = new Notice(this);
    this.model.qualitySwitch = new QualitySwitch(this);
    this.model.perf = new Perf(this);
    this.model.textTrack = new TextTrack(this);
    this.model.subtitle = new Subtitle(this);
    this.model.myunSync = new MyunSync(this);
    this.model.orientation = new Orientation(this);
    this.model.recordRestrict = new RecordRestrict(this);
    this.model.liveEndDetect = new LiveEndDetect(this);
    this.model.playbackMessage = new PlaybackMessage(this);
    this.model.playbackRate = new PlayBackRate(this);
    this.trigger(INTERNAL_MODEL_INITED);
  }
  function destroyModel() {
    for (var i in this.model) {
      this.model[i].remove();
    }
  }

  function initTimer() {
    var _this = this;

    this.timer = {};
    var bufferDetectGap = this._config.bufferDetectGap;

    if (!is('number', bufferDetectGap) || isNaN(bufferDetectGap) || bufferDetectGap <= 0) {
      bufferDetectGap = 200;
    }

    this.timer.loading = new Timer({
      type: 'loading',
      gap: bufferDetectGap
    });
    this.timer.raf = new Timer({
      type: 'raf',
      isRaf: true
    }); // loading timer

    var lastPlayPos = 0;
    var currentPlayPos = 0;
    var bufferingDetected = false;
    this.timer.loading.on('tick', function (_ref) {
      var isStop = _ref.isStop;

      if (isStop) {
        return;
      }

      currentPlayPos = _this.model.progress.getPosition();

      var state = _this.model.video.getState();

      var isPlaying = state === 'playing' || state === 'buffering';

      if (!bufferingDetected && currentPlayPos === lastPlayPos && isPlaying) {
        var dura = _this.getDuration(); // X5内核的特殊情况


        if (!isX5Layer() && isCommonNumber(dura) && dura > 0) {
          bufferingDetected = true;

          _this.trigger('internal_buffer', true);
        }
      }

      if (bufferingDetected && currentPlayPos > lastPlayPos && isPlaying) {
        bufferingDetected = false;

        _this.trigger('internal_buffer', false);
      }

      lastPlayPos = currentPlayPos;
    });
    var lastWidth = -1;
    this.timer.raf.on('tick', function (_ref2) {
      var isStop = _ref2.isStop;

      if (isStop) {
        return;
      }

      var width = _this.model.resize.getWidth();

      var hasSmall = classList(_this.dom.container).contains(flagSmallPlayer);

      if (width < 350) {
        !hasSmall && classList(_this.dom.container).add(flagSmallPlayer);
      } else {
        hasSmall && classList(_this.dom.container).remove(flagSmallPlayer);
      }

      if (lastWidth !== width) {
        _this.model.subtitle._setSubtitleSize(width);

        _this.model.subtitle._updateSubtitleStyle();
      }

      lastWidth = width;
      var fontSize = +getComputedStyle(_this.dom.container).fontSize.replace(/[^\d]+/, '');
      _this._status.containerFontSize = fontSize < 16 ? 16 : fontSize;

      _this.model.playbackMessage._onTick();
    });
    this.timer.raf.start();
  }
  function destroyTimer() {
    this.timer.loading.stop();
    this.timer.raf.stop();
  }

  var plugins = {};
  function registerPlugin(name, Plugin) {
    if (plugins[name]) {
      console.warn("provider [".concat(name, "] is existed, so it will not be register twice, you can change a name and retry"));
      return;
    }

    plugins[name] = {
      name: name,
      Plugin: Plugin
    };
    setDefaultOptions({
      plugin: _defineProperty({}, name, Plugin.defaultOptions)
    });
  }
  function getPlugins() {
    return plugins;
  }
  function getPlugin(name) {
    return plugins[name] || null;
  }

  function initPlugins() {
    var plugins = getPlugins();

    for (var name in plugins) {
      var p = plugins[name];

      if (p.Plugin.isSupported()) {
        this.plugin[name] = new p.Plugin(this, this._config.plugin[name]);
      }
    }

    this.trigger(INTERNAL_PLUGIN_INITED);
  }
  function destroyPlugins() {
    if (this.plugin) {
      for (var name in this.plugin) {
        this.plugin[name] && this.plugin[name].remove();
      }
    }
  }

  var Player =
  /*#__PURE__*/
  function (_EventEmitter) {
    _inherits(Player, _EventEmitter);

    function Player(containerId) {
      var _this;

      _classCallCheck(this, Player);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Player).call(this));
      _this._container = document.getElementById(containerId);

      _this.formatState();

      return _this;
    }

    _createClass(Player, [{
      key: "formatState",
      value: function formatState() {
        // config
        this._config = {};
        this._config.containerId = this._container.id; // running status

        this._status = {
          uniqId: genPlayerUniqId(),
          state: 'idle',
          focus: false,
          isSetuped: false,
          flashReady: false,
          dragging: false,
          index: '',
          containerFontSize: 16 // provider

        };
        this._provider = null;
        this._extraProviders = {}; // plugin

        this.plugin = {};
        this.dom = {};
        this.timer = {};
        this.model = {};
      }
    }, {
      key: "getUniqId",
      value: function getUniqId() {
        return this._status.uniqId;
      }
    }, {
      key: "setup",
      value: function setup(options) {
        var _this2 = this;

        isDebugMode() && console.log('[setup]', options); // 如果之前进行过setup，那么就remove一次

        if (this._status && this._status.isSetuped && !this._container.querySelector(videoWrap)) {
          this.remove();
          console.warn('muduPlayer().setup(): please don`t setup twice');
        }

        this.formatState();
        var formatedOptions = formatOptions(options); // console.log(options)

        var mergedOptions = mergeOptions(getDefaultOptions(), formatedOptions);
        this._config = _objectSpread({}, this._config, mergedOptions); // console.log(mergedOptions, getDefaultOptions(), formatedOptions)

        if (this._config.uniqId) {
          this._status.uniqId = this._config.uniqId;
        }

        initPlugins.call(this);
        this.trigger(INTERNAL_OPTION_MERGED);

        if (!is('array', this._config.playlist)) {
          throw new Error('setup(options): ' + 'you should give me a video url to play, through' + ' `options.file` or `options.playlist` array');
        } // localization


        this._status.lang = chooseLanguage(this._config.language, this._config.localization);
        this._status.localization = this._config.localization[this._status.lang];
        this._status.isSetuped = true;
        this.trigger(INTERNAL_STATUS_FORMATED);
        this.trigger('setup');
        initDom.call(this);
        initModel.call(this);
        initTimer.call(this);
        setDefaultPlayItemSourceActive.call(this);
        var autoplay = this._config.autoplay;
        return initProvider.call(this).then(function () {
          initExtraProvider.call(_this2);

          if (autoplay) {
            try {
              _this2.play();
            } catch (err) {
              console.warn(err);
            }
          }

          return Promise.resolve();
        });
      }
    }, {
      key: "remove",
      value: function remove() {
        isDebugMode() && console.log('[remove]'); // 如果没有进行setup，那么就直接return，不进行remove

        if (!this._status || !this._status.isSetuped) {
          return;
        }

        destroyTimer.call(this);
        destroyModel.call(this);
        destroyPlugins.call(this);
        destroyProvider.call(this);
        destroyDom.call(this);
        this._config = null;
        this._status = null;
        this._provider = null;
        this.dom = null;
        this.timer = null;
        this.model = null; // 移除model/provider/plugin监听的事件

        this.trigger('remove'); // 移除用户监听的事件
        // this.clear()
      }
    }, {
      key: "stop",
      value: function stop() {
        isDebugMode() && console.log('[stop]');
        destroyProvider.call(this);
      }
    }]);

    return Player;
  }(EventEmitter);

  var HTML5Provider =
  /*#__PURE__*/
  function (_Provider) {
    _inherits(HTML5Provider, _Provider);

    function HTML5Provider(player, option) {
      var _this;

      _classCallCheck(this, HTML5Provider);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(HTML5Provider).call(this, player, option));
      _this._onVideoEvents = _this._onVideoEvents.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this._onTextTracksAdd = _this._onTextTracksAdd.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this._onTextTracksChange = _this._onTextTracksChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this._onTextTracksRemove = _this._onTextTracksRemove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this._onTextTrackCueChange = _this._onTextTrackCueChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.TAG = 'HTML5Provider';
      _this.video_error_report = true;
      return _this;
    }

    _createClass(HTML5Provider, [{
      key: "setup",
      value: function setup(_ref) {
        var _this2 = this;

        var file = _ref.file,
            image = _ref.image;

        this._setupEvents();

        this._duration = 0;
        this.video.src = file; // 给vidoe加上黑色背景，覆盖部分安卓手机加载流时的默认播放按钮背景

        var blackPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=';
        this.video.setAttribute('poster', blackPng); // 用于修复某些移动设备需要seek后才能播放

        this.oncePlayer('play', function () {
          _this2.oncePlayer('canSeek', function () {
            var shouldStartSeek = true;

            _this2.oncePlayer('seek', function () {
              shouldStartSeek = false;
            });

            _this2.oncePlayer('time', function (_ref2) {
              var position = _ref2.position;

              if (position !== 0) {
                shouldStartSeek = false;
              }
            });

            setTimeout(function () {
              var pos = _this2.getPosition();

              if (_this2.TAG === 'HTML5Provider' && shouldStartSeek && pos === 0) {
                _this2.seek(0.01);
              }
            }, 50);
          });
        });
      }
    }, {
      key: "getMediaElement",
      value: function getMediaElement() {
        var video$$1 = this.player.dom.videoWrap.querySelector('video'); // if current video has textTracks then we use another new video, coz video texttracks cannot be removed
        // if current video has no texttrack, we reuse the video, coz a new video cannot autoplay in some browsers

        if (video$$1) {
          var tts = video$$1.textTracks;

          if (tts && tts.length) {
            try {
              video$$1.parentNode.removeChild(video$$1);
            } catch (err) {
              console.error('remove video element error');
            }

            return null;
          }
        }

        this.video = video$$1;
        return video$$1;
      }
    }, {
      key: "createMediaElement",
      value: function createMediaElement() {
        var media = document.createElement('video');
        var preload = this.player._config.preload;
        media.setAttribute('class', video);
        media.setAttribute('preload', preload); // 设置loop会导致IOS息屏

        if (isIOS()) {
          delete this.player._config.videoAttributes.loop;
        }

        for (var attr in this.player._config.videoAttributes) {
          var val = this.player._config.videoAttributes[attr];
          media.setAttribute(attr, val);
        }

        this.video = media;
        return media;
      }
    }, {
      key: "play",
      value: function play() {
        if (this.video) {
          this.video.setAttribute('preload', 'auto'); // if preload:none, some iPhone wechat need call video.play() to play

          try {
            return this.video.play();
          } catch (error) {
            throw new Error('player cannot play');
          }
        }

        return Promise.resolve();
      }
    }, {
      key: "pause",
      value: function pause() {
        if (this.video) {
          this.video.pause();
        }

        return Promise.resolve();
      }
    }, {
      key: "remove",
      value: function remove() {
        this._removeEvents();

        if (this.video) {
          // because video.textTracks cannot be removed
          // when change hls master playlist, so remove it
          try {
            this.video.parentNode.removeChild(this.video);
          } catch (err) {}

          this.video = null;
        }

        _get(_getPrototypeOf(HTML5Provider.prototype), "remove", this).call(this);
      }
    }, {
      key: "seek",
      value: function seek(time$$1) {
        if (!this.video) {
          return;
        }

        var prePosition = this.getPosition();
        this.video.currentTime = time$$1;
        this.trigger('seek', {
          type: 'seek',
          position: prePosition,
          offset: time$$1
        });
      }
    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {
        if (this.video) {
          return this.video.playbackRate;
        }

        return 1;
      }
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(playbackRate$$1) {
        if (this.video) {
          this.video.playbackRate = playbackRate$$1;
          this.trigger('playbackrate', {
            type: 'playbackrate',
            playbackRate: playbackRate$$1
          });
        }
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this._duration;
      }
    }, {
      key: "getPosition",
      value: function getPosition() {
        if (this.video) {
          return this.video.currentTime;
        }

        return 0;
      }
    }, {
      key: "getVolume",
      value: function getVolume() {
        if (!this.video) {
          return 1;
        }

        if (this.getMute()) {
          return 0;
        }

        return this.video.volume;
      }
    }, {
      key: "getWidth",
      value: function getWidth() {
        if (!this.video) {
          return -1;
        }

        return this.video.videoWidth;
      }
    }, {
      key: "getHeight",
      value: function getHeight() {
        if (!this.video) {
          return -1;
        }

        return this.video.videoHeight;
      }
    }, {
      key: "setVolume",
      value: function setVolume(volume$$1) {
        if (!this.video) {
          return;
        }

        var muted = this.video.muted;

        if (is('number', volume$$1)) {
          if (volume$$1 < 0) {
            volume$$1 = 0;
          }

          if (volume$$1 > 1) {
            volume$$1 = 1;
          }

          this.video.volume = volume$$1;
          this.trigger('volume', {
            type: 'volume',
            volume: volume$$1
          });

          if (muted && volume$$1 > 0) {
            this.setMute(false);
          }

          if (!muted && volume$$1 === 0) {
            this.setMute(true);
          }
        }
      }
    }, {
      key: "setMute",
      value: function setMute() {
        var muted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (!this.video) {
          return;
        }

        this.video.muted = !!muted;
        this.trigger('mute', {
          type: 'mute',
          mute: !!muted
        });
      }
    }, {
      key: "getMute",
      value: function getMute() {
        if (!this.video) {
          return false;
        }

        return this.video.muted;
      }
    }, {
      key: "setStretching",
      value: function setStretching(stretching) {
        if (!this.video) return;

        switch (stretching) {
          case 'none':
          case 'contain':
          case 'fill':
          case 'cover':
          case 'scale-down':
            this.video.style.objectFit = stretching;
            break;

          default:
            this.video.style.objectFit = 'contain';
        }
      }
    }, {
      key: "getStretching",
      value: function getStretching() {
        return this.video.style.objectFit;
      }
    }, {
      key: "getBuffer",
      value: function getBuffer() {
        if (!this.video) {
          return [];
        }

        var video$$1 = this.video;
        var buffered = video$$1.buffered;
        var ret = [];

        for (var i = 0; i < buffered.length; i++) {
          ret.push({
            start: buffered.start(i),
            end: buffered.end(i)
          });
        }

        return ret.sort(function (a, b) {
          var diff = a.start - b.start;

          if (diff) {
            return diff;
          } else {
            return b.end - a.end;
          }
        });
      }
    }, {
      key: "getMetrics",
      value: function getMetrics() {
        var video$$1 = this.video;
        if (!video$$1) return _get(_getPrototypeOf(HTML5Provider.prototype), "getMetrics", this).call(this);
        return {
          videoHeight: video$$1.videoHeight,
          videoWidth: video$$1.videoWidth,
          mozParsedFrames: video$$1.mozParsedFrames,
          mozDecodedFrames: video$$1.mozDecodedFrames,
          mozPresentedFrames: video$$1.mozPresentedFrames,
          mozPaintedFrames: video$$1.mozPaintedFrames,
          mozFrameDelay: video$$1.mozFrameDelay,
          mozHasAudio: video$$1.mozHasAudio,
          networkState: video$$1.networkState,
          msHorizontalMirror: video$$1.msHorizontalMirror,
          msInsertVideoEffect: video$$1.msInsertVideoEffect,
          msIsStereo3D: video$$1.msIsStereo3D,
          webkitAudioDecodedByteCount: video$$1.webkitAudioDecodedByteCount,
          webkitVideoDecodedByteCount: video$$1.webkitVideoDecodedByteCount,
          webkitDecodedFrameCount: video$$1.webkitDecodedFrameCount,
          webkitDroppedFrameCount: video$$1.webkitDroppedFrameCount
        };
      }
    }, {
      key: "getTextTracks",
      value: function getTextTracks() {
        var _this3 = this;

        if (!this.video) return [];
        var tracks = [].slice.call(this.video.textTracks).map(function (track) {
          _this3._addCustomTrack(track);

          var ctrack = track.customTrack;
          return ctrack;
        });
        return tracks;
      }
    }, {
      key: "setTextTrackEnable",
      value: function setTextTrackEnable(index) {
        var tracks = this.video && this.video.textTracks;
        var track = tracks && tracks[index];
        if (!track) return;
        if (!track.customTrack) this._addCustomTrack(track);
        track.customTrack.mode = 'hidden'; // track.mode = 'hidden'

        track.mode = 'hidden';
      }
    }, {
      key: "setTextTrackDisable",
      value: function setTextTrackDisable(index) {
        var tracks = this.video && this.video.textTracks;
        var track = tracks && tracks[index];
        if (!track) return;
        if (!track.customTrack) this._addCustomTrack(track);
        track.customTrack.mode = 'disabled';
        track.mode = 'disabled';
      }
    }, {
      key: "getTextTrackCues",
      value: function getTextTrackCues(index) {
        var _this4 = this;

        var tracks = this.video && this.video.textTracks;
        var track = tracks && tracks[index];
        if (!track) return;
        var cues = [].slice.call(track.cues || []).map(function (v) {
          _this4._addCustomCue(v);

          return v.customCue;
        });
        return cues;
      }
    }, {
      key: "getTextTrackActiveCues",
      value: function getTextTrackActiveCues(index) {
        var _this5 = this;

        var tracks = this.video && this.video.textTracks;
        var track = tracks && tracks[index];
        if (!track) return;
        var cues = [].slice.call(track.activeCues || []).map(function (v) {
          _this5._addCustomCue(v);

          return v.customCue;
        });
        return cues;
      }
    }, {
      key: "_setupEvents",
      value: function _setupEvents() {
        var _this6 = this;

        HTML5Provider.mediaEvents.forEach(function (name) {
          addEventListener(_this6.video, name, _this6._onVideoEvents);
        });

        if (this.video.textTracks) {
          addEventListener(this.video.textTracks, 'change', this._onTextTracksChange);
          addEventListener(this.video.textTracks, 'addtrack', this._onTextTracksAdd);
          addEventListener(this.video.textTracks, 'removetrack', this._onTextTracksRemove);
        }
      }
    }, {
      key: "_removeEvents",
      value: function _removeEvents() {
        var _this7 = this;

        if (this.video) {
          HTML5Provider.mediaEvents.forEach(function (name) {
            removeEventListener(_this7.video, name, _this7._onVideoEvents);
          });

          for (var i = 0; i < this.video.textTracks.length; i++) {
            removeEventListener(this.video.textTracks[i], 'cuechange', this._onTextTrackCueChange);
          }

          removeEventListener(this.video.textTracks, 'change', this._onTextTracksChange);
          removeEventListener(this.video.textTracks, 'addtrack', this._onTextTracksAdd);
          removeEventListener(this.video.textTracks, 'removetrack', this._onTextTracksRemove);
        }
      }
    }, {
      key: "_onTextTracksChange",
      value: function _onTextTracksChange() {
        if (!this.video) return;
        this.trigger(PROVIDER_TEXTTRACKCHANGE, this.getTextTracks());
      }
    }, {
      key: "_onTextTracksAdd",
      value: function _onTextTracksAdd(event) {
        if (!this.video) return; // 当track添加到textTracks中

        var track = event.track;

        this._addCustomTrack(track);

        this.trigger(PROVIDER_TEXTTRACKADD, track.customTrack);
        addEventListener(track, 'cuechange', this._onTextTrackCueChange);
      }
    }, {
      key: "_onTextTracksRemove",
      value: function _onTextTracksRemove(event) {// no method to remove a text track, so just not handle it
      }
    }, {
      key: "_onTextTrackCueChange",
      value: function _onTextTrackCueChange(event) {
        if (!this.video) return;
        var track = event.target;

        var trackIndex = this._getIndexByTrack(track);

        this.trigger(PROVIDER_CUECHANGE, {
          cues: this.getTextTrackCues(trackIndex),
          activeCues: this.getTextTrackActiveCues(trackIndex),
          track: track.customTrack
        });
      }
    }, {
      key: "_getIndexByTrack",
      value: function _getIndexByTrack(track) {
        var tracks = this.video.textTracks;
        var len = tracks.length;

        for (var i = 0; i < len; i++) {
          if (tracks[i] === track) return i;
        }

        return -1;
      }
    }, {
      key: "_addCustomTrack",
      value: function _addCustomTrack(track) {
        track.customTrack = track.customTrack || {};
        var ct = track.customTrack;
        ct.id = track.id;
        ct.kind = track.kind;
        ct.label = track.label;
        ct.language = track.language;
        ct.mode = track.mode;
      }
    }, {
      key: "_addCustomCue",
      value: function _addCustomCue(cue) {
        cue.customCue = cue.customCue || {};
        var cu = cue.customCue;
        cu.startTime = cue.startTime;
        cu.endTime = cue.endTime;
        cu.text = cue.text;
      }
    }, {
      key: "_onVideoEvents",
      value: function _onVideoEvents(event) {
        var type = event.type;

        switch (type) {
          case 'error':
            var error = this.video.error || {};
            var message = error.message;
            var code = error.code;
            var networkState = this.video.networkState;

            if (code === 3) {
              // 解码错误，微信x5下直播会出现解码错误
              if (this.TAG === 'HTML5Provider' && isX5Layer()) {
                console.log('x5 layer error');
                this.play();
                return;
              }
            }

            if (!message && networkState === 3) {
              message = 'networkError';
            }

            this.video_error_report && this.trigger('error', {
              message: message,
              code: code,
              networkState: networkState,
              fatal: code > 1
            });
            break;

          case 'playing':
            this.trigger('play', event);
            this.trigger(type, event);
            break;

          case 'durationchange':
            if (this.video.duration !== 1) {
              this._duration = this.video.duration;
              this.trigger('duration');
            }

            this.trigger(type, event);
            break;

          default:
            this.trigger(type, event);
        }
      }
    }]);

    return HTML5Provider;
  }(Provider);

  HTML5Provider.mediaEvents = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'mozaudioavailable', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting'];

  HTML5Provider.canPlay = function (_ref3) {
    var mimeType = _ref3.mimeType;
    var video$$1 = document.createElement('video');
    return video$$1.canPlayType(mimeType);
  };

  HTML5Provider.isSupported = function () {
    return !isIE() || isIE() && browserVersion$1.major > 8;
  };

  HTML5Provider.isPlaybackRateSupported = function () {
    return true;
  };

  HTML5Provider.isHTML5 = function (_) {
    return true;
  };

  HTML5Provider.isFlash = function (_) {
    return false;
  };

  HTML5Provider.version = "0.36.3";

  var Dash =
  /*#__PURE__*/
  function (_HTML5Provider) {
    _inherits(Dash, _HTML5Provider);

    function Dash(player, option) {
      var _this;

      _classCallCheck(this, Dash);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Dash).call(this, player, option));
      _this.video_error_report = false; // disable HTML5Provider error report

      _this.TAG = 'DashjsProvider';
      return _this;
    }

    _createClass(Dash, [{
      key: "loadFiles",
      value: function loadFiles() {
        var loader = new ScriptLoader(this.player._config.fileCdnPath + '/dash.js');
        return loader.load();
      }
    }, {
      key: "setup",
      value: function setup(_ref) {
        var _this2 = this;

        var file = _ref.file;

        _get(_getPrototypeOf(Dash.prototype), "setup", this).call(this, {
          file: file
        });

        this.file = file;

        if (this.player._config.preload === 'auto') {
          this.loadDash();
        } else {
          this.oncePlayer('beforePlay', function () {
            return _this2.loadDash();
          });
        }
      }
    }, {
      key: "loadDash",
      value: function loadDash() {
        this.dashPlayer = window.dashjs.MediaPlayer().create();
        this.dashPlayer.initialize(this.video, this.file, false);
      }
    }, {
      key: "remove",
      value: function remove() {
        _get(_getPrototypeOf(Dash.prototype), "remove", this).call(this);

        if (this.dashPlayer) {
          this.dashPlayer.reset();
        }
      }
    }]);

    return Dash;
  }(HTML5Provider);

  Dash.formats = {
    'application/dash+xml': 'dash'
  };
  Dash.types = ['mpd', 'dash'];

  Dash.canPlay = function (_ref2) {
    var type = _ref2.type;

    if (Dash.types.indexOf(type) >= 0) {
      return 'maybe';
    }

    return '';
  };

  Dash.isSupported = function () {
    var mediaSource = window.MediaSource || window.WebKitMediaSource;
    var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
    var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'); // if SourceBuffer is exposed ensure its API is valid
    // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible

    var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
    return !!isTypeSupported && !!sourceBufferValidAPI;
  };

  Dash.isFlash = function (_) {
    return false;
  };

  Dash.isHTML5 = function (_) {
    return true;
  };

  Dash.HlsP2pisPlaybackRateSupported = function () {
    return true;
  };

  Dash.isPlaybackRateSupported = function () {
    return true;
  };

  Dash.version = "2.9.0";

  var Flvjs =
  /*#__PURE__*/
  function (_HTML5Provider) {
    _inherits(Flvjs, _HTML5Provider);

    function Flvjs(player, option) {
      var _this;

      _classCallCheck(this, Flvjs);

      option = option || {};
      _this = _possibleConstructorReturn(this, _getPrototypeOf(Flvjs).call(this, player, option));
      _this.video_error_report = false; // disable HTML5Provider error report

      _this.TAG = 'FlvjsProvider';
      return _this;
    }

    _createClass(Flvjs, [{
      key: "loadFiles",
      value: function loadFiles() {
        var loader = new ScriptLoader(this.player._config.fileCdnPath + '/flv.js');
        return loader.load();
      }
    }, {
      key: "setup",
      value: function setup(_ref) {
        var _this2 = this;

        var file = _ref.file,
            isLive = _ref.isLive;

        _get(_getPrototypeOf(Flvjs.prototype), "setup", this).call(this, {
          file: file
        });

        this.onFlvError = function (type, details, other) {
          var message = "".concat(type, "_").concat(details);

          if (type === window.flvjs.ErrorTypes.NETWORK_ERROR) {
            if (other.code) {
              message += "_".concat(other.code);
            }

            if (other.msg) {
              message += "_".concat(other.msg);
            }
          }

          _this2.trigger(PROVIDER_ERROR, {
            message: message,
            details: details,
            fatal: true,
            data: {
              type: type,
              details: details,
              other: other
            }
          });
        };

        var flvConfig = this.option['flv.js'] || {};
        this.flvPlayer = window.flvjs.createPlayer({
          type: 'flv',
          url: file,
          isLive: !!isLive
        }, flvConfig);
        this.flvPlayer.attachMediaElement(this.getMediaElement());
        this.flvPlayer.on(window.flvjs.Events.ERROR, this.onFlvError);

        if (this.player._config.preload === 'auto') {
          this.flvPlayer.load();
        } else {
          this.oncePlayer('beforePlay', function () {
            return _this2.flvPlayer.load();
          });
        }
      }
    }, {
      key: "remove",
      value: function remove() {
        _get(_getPrototypeOf(Flvjs.prototype), "remove", this).call(this);

        if (this.flvPlayer) {
          this.flvPlayer.off(window.flvjs.Events.ERROR, this.onFlvError);
          this.flvPlayer.detachMediaElement();
          this.flvPlayer.destroy();
        }
      }
    }]);

    return Flvjs;
  }(HTML5Provider);

  Flvjs.formats = {
    'video/flv': 'FLV',
    'video/x-flv': 'FLV'
  };

  Flvjs.canPlay = function (_ref2) {
    var type = _ref2.type,
        isLive = _ref2.isLive;

    if (type === 'flv' && (!isLive || isLive && Flvjs.isLiveSupported())) {
      return 'maybe';
    }

    return '';
  };

  Flvjs.canPlaySource = function () {};

  Flvjs.isSupported = function () {
    return window.MediaSource && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
  };

  Flvjs.isLiveSupported = function () {
    var env = getEnvor();
    var browser = env.browser; // https://github.com/Bilibili/flv.js/blob/master/src/io/fetch-stream-loader.js#L32
    // https://github.com/Bilibili/flv.js/blob/master/docs/livestream.md#compatibility

    try {
      var isWorkWellEdge = browser.msedge && (browser.version.major > 15 || browser.version.major === 15 && browser.version.minor >= 15048);
      var browserNotBlacklisted = browser.msedge ? isWorkWellEdge : true;
      return window.fetch && window.ReadableStream && browserNotBlacklisted;
    } catch (e) {
      return false;
    }
  };

  Flvjs.isFlash = function (_) {
    return false;
  };

  Flvjs.isHTML5 = function (_) {
    return true;
  };

  Flvjs.HlsP2pisPlaybackRateSupported = function () {
    return true;
  };

  Flvjs.isPlaybackRateSupported = function () {
    return true;
  };

  Flvjs.version = "1.4.2";

  function getHlsCustom() {
    var XHRLoader =
    /*#__PURE__*/
    function (_window$Hls$DefaultCo) {
      _inherits(XHRLoader, _window$Hls$DefaultCo);

      function XHRLoader() {
        _classCallCheck(this, XHRLoader);

        return _possibleConstructorReturn(this, _getPrototypeOf(XHRLoader).apply(this, arguments));
      }

      _createClass(XHRLoader, [{
        key: "loadInternal",
        value: function loadInternal() {
          var xhr;
          var context = this.context;
          xhr = this.loader = new window.XMLHttpRequest();
          var stats = this.stats;
          stats.tfirst = 0;
          stats.loaded = 0;
          var xhrSetup = this.xhrSetup;
          var requestUrl = window.location.protocol === 'https:' ? context.url.replace(/^http:/, 'https:') : context.url;

          try {
            if (xhrSetup) {
              try {
                xhrSetup(xhr, requestUrl);
              } catch (e) {
                // fix xhrSetup: (xhr, url) => {xhr.setRequestHeader("Content-Language", "test");}
                // not working, as xhr.setRequestHeader expects xhr.readyState === OPEN
                xhr.open('GET', requestUrl, true);
                xhrSetup(xhr, requestUrl);
              }
            }

            if (!xhr.readyState) {
              xhr.open('GET', requestUrl, true);
            }
          } catch (e) {
            // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
            this.callbacks.onError({
              code: xhr.status,
              text: e.message
            }, context, xhr);
            return;
          }

          if (context.rangeEnd) {
            xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
          }

          xhr.onreadystatechange = this.readystatechange.bind(this);
          xhr.onprogress = this.loadprogress.bind(this);
          xhr.responseType = context.responseType; // setup timeout before we perform request

          this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout);
          xhr.send();
        }
      }]);

      return XHRLoader;
    }(window.Hls.DefaultConfig.loader);

    return {
      XHRLoader: XHRLoader
    };
  }

  var Hlsjs =
  /*#__PURE__*/
  function (_HTML5Provider) {
    _inherits(Hlsjs, _HTML5Provider);

    function Hlsjs(player, option) {
      var _this;

      _classCallCheck(this, Hlsjs);

      option = option || {};
      _this = _possibleConstructorReturn(this, _getPrototypeOf(Hlsjs).call(this, player, option));
      _this.onHlsError = _this.onHlsError.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.option = option;
      _this.video_error_report = false; // disable HTML5Provider error report

      _this.onPlayer('buffer', _this._onPlayerBuffer.bind(_assertThisInitialized(_assertThisInitialized(_this))));

      _this.TAG = 'HlsjsProvider';
      return _this;
    }

    _createClass(Hlsjs, [{
      key: "loadFiles",
      value: function loadFiles() {
        var loader = new ScriptLoader(this.player._config.fileCdnPath + '/hls.js');
        return loader.load();
      }
    }, {
      key: "setup",
      value: function setup(data) {
        var _this2 = this;

        var file = data.file;

        _get(_getPrototypeOf(Hlsjs.prototype), "setup", this).call(this, data);

        this.file = file;

        if (this.player._config.preload === 'auto') {
          this.loadHls();
        } else {
          this.oncePlayer(OUTER_BEFORE_PLAY, function () {
            return _this2.loadHls();
          });
        }
      }
    }, {
      key: "play",
      value: function play() {
        var state = this.player.getState();
        var pos = this.getPosition();

        if (state === 'idle' && pos > 0) {
          // hls not trigger end event, manually replay it https://github.com/video-dev/hls.js/issues/1599
          this.seek(0);
        }

        return _get(_getPrototypeOf(Hlsjs.prototype), "play", this).call(this);
      }
    }, {
      key: "loadHls",
      value: function loadHls() {
        var _getHlsCustom = getHlsCustom(),
            XHRLoader = _getHlsCustom.XHRLoader;

        var defaultConfig = {
          fLoader: XHRLoader
        };

        var config = _objectSpread({}, this.option['hls.js'] || {}, defaultConfig);

        var hlsPlayer = this.hlsPlayer = new window.Hls(config);
        hlsPlayer.subtitleDisplay = false; // 设置字幕默认不显示

        hlsPlayer.loadSource(this.file);
        hlsPlayer.attachMedia(this.video);
        hlsPlayer.on(window.Hls.Events.ERROR, this.onHlsError);
      }
    }, {
      key: "onHlsError",
      value: function onHlsError(_, data) {
        var type = data.type,
            details = data.details,
            fatal = data.fatal;
        var message = "".concat(type, "_").concat(details);
        var notHandleDetails = [window.Hls.ErrorDetails.BUFFER_STALLED_ERROR, window.Hls.ErrorDetails.BUFFER_NUDGE_ON_STALL];

        if (notHandleDetails.indexOf(details) !== -1) {
          return;
        }

        if (type === window.Hls.ErrorTypes.NETWORK_ERROR) {
          var ntDetail = data.networkDetails;

          if (ntDetail) {
            if (ntDetail.status) {
              message += "_".concat(ntDetail.status);
            }

            if (ntDetail.statusText) {
              message += "_".concat(ntDetail.statusText);
            }
          }
        }

        this.trigger(PROVIDER_ERROR, {
          message: message,
          fatal: fatal,
          details: details,
          data: data
        });
      }
    }, {
      key: "remove",
      value: function remove() {
        _get(_getPrototypeOf(Hlsjs.prototype), "remove", this).call(this);

        if (this.hlsPlayer) {
          this.hlsPlayer.off(window.Hls.Events.ERROR, this.onHlsError);
          this.hlsPlayer.detachMedia();
          this.hlsPlayer.destroy();
        }
      }
    }, {
      key: "_onPlayerBuffer",
      value: function _onPlayerBuffer(_ref) {
        var oldState = _ref.oldState;

        // subscribe buffer event to avoid hls.js bug: https://github.com/video-dev/hls.js/issues/1599
        if (oldState === 'playing') {
          var pos = this.getPosition();
          var dura = this.getDuration();

          if (dura - pos < 1 && pos > 0 && dura > 2) {
            // '2' use to avoid dura not ready(parsing m3u8 file not done), why not '1', `1` in x5 is fucked
            this.pause();
            this.trigger('ended'); // manully trigger ended event to remove buffer
          }
        }
      }
    }]);

    return Hlsjs;
  }(HTML5Provider);

  Hlsjs.formats = {
    'application/vnd.apple.mpegurl': 'hls'
  };
  Hlsjs.type = ['m3u8', 'hls'];

  Hlsjs.canPlay = function (_ref2) {
    var type = _ref2.type,
        isTimeShift = _ref2.isTimeShift;

    if (isTimeShift && isX5Layer()) {
      return false;
    }

    return Hlsjs.type.indexOf(type) >= 0;
  };

  Hlsjs.isHlsSupported = function () {
    var mediaSource = window.MediaSource || window.WebKitMediaSource;
    var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
    var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'); // if SourceBuffer is exposed ensure its API is valid
    // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible

    var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
    return !!isTypeSupported && !!sourceBufferValidAPI;
  };

  Hlsjs.isSupported = function () {
    return Hlsjs.isHlsSupported();
  };

  Hlsjs.isFlash = function (_) {
    return false;
  };

  Hlsjs.isHTML5 = function (_) {
    return true;
  };

  Hlsjs.HlsP2pisPlaybackRateSupported = function () {
    return true;
  };

  Hlsjs.isPlaybackRateSupported = function () {
    return true;
  };

  Hlsjs.version = "0.12.4";

  var Plugin =
  /*#__PURE__*/
  function (_EventEmitter) {
    _inherits(Plugin, _EventEmitter);

    function Plugin(player, option) {
      var _this;

      _classCallCheck(this, Plugin);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Plugin).call(this));
      _this.player = player;
      _this.p_player_events = [];
      _this.p_dom_events = [];
      _this.option = option;
      return _this;
    }

    _createClass(Plugin, [{
      key: "onPlayer",
      value: function onPlayer(evt, fn) {
        this.player.on(evt, fn);
        this.p_player_events.push({
          evt: evt,
          fn: fn
        });
      }
    }, {
      key: "oncePlayer",
      value: function oncePlayer(evt, fn) {
        this.player.once(evt, fn);
        this.p_player_events.push({
          evt: evt,
          fn: fn
        });
      }
    }, {
      key: "onDom",
      value: function onDom(ele, evt, fn) {
        var needRemove = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        addEventListener(ele, evt, fn);
        needRemove && this.p_dom_events.push({
          ele: ele,
          evt: evt,
          fn: fn
        });
      }
    }, {
      key: "remove",
      value: function remove() {
        var _this2 = this;

        this.p_player_events.forEach(function (v) {
          return _this2.player.off(v.evt, v.fn);
        });
        this.p_dom_events.forEach(function (v) {
          return removeEventListener(v.ele, v.evt, v.fn);
        });
      }
    }]);

    return Plugin;
  }(EventEmitter);

  Plugin.isSupported = returnFalse;
  Plugin.defaultOptions = {};

  /**
   * android x5 适配插件
   */

  var X5 =
  /*#__PURE__*/
  function (_Plugin) {
    _inherits(X5, _Plugin);

    function X5(player, option) {
      var _this;

      _classCallCheck(this, X5);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(X5).call(this, player, option));
      var isX5 = isX5Layer();
      var x5Inline;
      var x5Layer$$1;
      var appendOptions = {
        x5Layer: {
          'x5-video-player-type': 'h5',
          'x5-video-player-fullscreen': 'true',
          'x5-video-orientation': 'portrait'
        },
        x5Inline: {
          'x5-playsinline': ''
        }
      };
      _this.eventIds = [];
      var eid1 = player.once('internal_option_merged', function () {
        x5Inline = option.inline;
        x5Layer$$1 = option.layer;
        var height = player._config.height;
        !is('number', height) && x5Layer$$1 && console.error('x5 plugin: 使用x5插件的layer选项时，高度应该设置为具体的px值');

        if (x5Inline && isX5) {
          _this.player._config.videoAttributes = _objectSpread({}, _this.player._config.videoAttributes, appendOptions.x5Inline);
        }

        if (x5Layer$$1 && isX5) {
          _this.player._config.videoAttributes = _objectSpread({}, _this.player._config.videoAttributes, appendOptions.x5Layer);
        }

        if (isX5) {
          // x5模式下 autoplay 会失败，且造成idle状态切换到pause 状态，见 #100
          _this.player._config.autoplay = false;
        }

        if (x5Layer$$1 && isX5) {
          var eid2 = player.on('internal_model_inited', function () {
            var fullBtn = _this.player.dom.container.querySelector(".".concat(fullscreenIcon));

            fullBtn.style.display = 'none';
            _this.fakeFullBtn = stringToDom("<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(fakefullscreenIcon, " ").concat(full, "\"></button>"));

            _this.player.appendRightControllerButton(_this.fakeFullBtn);

            _this.fakeFullBtn.addEventListener('click', function () {
              // 修改高度并弹出提示
              _this.fakeFullBtn.style.display = 'none';
              classList(player.dom.container).remove(x5Layer);

              _this.player.notice('点击右下角全屏');
            });
          });
          var eid3 = player.on('play', function () {
            // 修改video高度
            classList(player.dom.container).add(x5Layer);
            _this.fakeFullBtn.style.display = 'inline-block';
          });
          var eid4 = player.on('pause', function () {
            _this.fakeFullBtn.style.display = 'none';
          });
          var eid5 = player.on('buffer', function () {
            // 当使用x5时, 直播下, video.currentTime一直等于0.001, 手动去除错误的loading状态
            player.getDuration() === Infinity && player.trigger('internal_buffer', false);
          });

          _this.eventIds.push({
            name: 'internal_model_inited',
            id: eid2
          }, {
            name: 'play',
            id: eid3
          }, {
            name: 'pause',
            id: eid4
          }, {
            name: 'buffer',
            id: eid5
          });
        }
      });

      _this.eventIds.push({
        name: 'internal_option_merged',
        id: eid1
      });

      return _this;
    }

    _createClass(X5, [{
      key: "remove",
      value: function remove() {
        var _this2 = this;

        this.eventIds.forEach(function (e) {
          _this2.player.off(e.name, e.id);
        });
      }
    }]);

    return X5;
  }(Plugin);

  X5.isSupported = returnTrue;
  X5.defaultOptions = {
    inline: false,
    layer: false
  };

  /**
   * 弹幕插件
   */

  var DanmakuPlugin =
  /*#__PURE__*/
  function (_Plugin) {
    _inherits(DanmakuPlugin, _Plugin);

    function DanmakuPlugin() {
      _classCallCheck(this, DanmakuPlugin);

      return _possibleConstructorReturn(this, _getPrototypeOf(DanmakuPlugin).apply(this, arguments));
    }

    _createClass(DanmakuPlugin, [{
      key: "init",
      value: function init() {
        var _this = this;

        var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var loader = new ScriptLoader(this.player._config.fileCdnPath + '/danmaku.js');
        return loader.load().then(function () {
          var danmaku$$1 = new window.Danmaku();
          danmaku$$1.init(_objectSpread({
            container: _this.player.dom.container.querySelector(".".concat(danmaku))
          }, opt));
          Delegator(_this, danmaku$$1).method('resize').method('show').method('hide').method('destroy').method('clear');
          _this.danmaku = danmaku$$1;

          var visibility = _this.getCompaVisibility();

          var handleResize = function handleResize() {
            if (is('function', _this.resize)) {
              _this.resize();
            }
          };

          var handleVisiblity = function handleVisiblity() {
            _this.danmaku.clear();

            _this.disableSend = document[visibility.hidden];
          };

          _this.onPlayer('play', function () {
            danmaku$$1.paused = false;
          });

          _this.onPlayer('pause', function () {
            danmaku$$1.paused = true;
          });

          _this.onPlayer('resize', handleResize);

          _this.onDom(window, 'resize', handleResize);

          visibility && _this.onDom(document, visibility.visibilitychange, handleVisiblity);
          return danmaku$$1;
        });
      }
    }, {
      key: "emit",
      value: function emit(d) {
        if (!this.disableSend) {
          this.danmaku.emit(d);
        }
      }
    }, {
      key: "getCompaVisibility",
      value: function getCompaVisibility() {
        if (!is('undefined', document.hidden)) {
          return {
            hidden: 'hidden',
            visibilitychange: 'visibilitychange'
          };
        }

        if (!is('undefined', document.msHidden)) {
          return {
            hidden: 'msHidden',
            visibilitychange: 'msvisibilitychange'
          };
        }

        if (!is('undefined', document.webkitHidden)) {
          return {
            hidden: 'webkitHidden',
            visibilitychange: 'webkitvisibilitychange'
          };
        }
      }
    }, {
      key: "setSpeed",
      value: function setSpeed(speed) {
        if (this.danmaku) {
          this.danmaku.speed = speed;
        }
      }
    }, {
      key: "remove",
      value: function remove() {
        _get(_getPrototypeOf(DanmakuPlugin.prototype), "remove", this).call(this);

        if (is('function', this.destroy)) {
          this.destroy();
        }
      }
    }]);

    return DanmakuPlugin;
  }(Plugin);

  DanmakuPlugin.isSupported = function () {
    var env = getEnvor();
    var isIE8 = env.browser.msie && env.browser.version.major === 8;
    return !isIE8;
  };

  /**
   * 播放计时插件
   */

  var Tick =
  /*#__PURE__*/
  function (_Plugin) {
    _inherits(Tick, _Plugin);

    function Tick(player, option) {
      var _this;

      _classCallCheck(this, Tick);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Tick).call(this, player, option));
      _this.timer = new Timer(_objectSpread({}, option, {
        gap: _this.option.gap || 60 * 1000
      }));

      _this.timer.on('tick', function (data) {
        _this.trigger('tick', data);
      });

      _this.onPlayer('play', function () {
        _this.timer.start();
      });

      _this.onPlayer('pause', function () {
        _this.timer.stop();
      });

      _this.onPlayer('idle', function () {
        _this.timer.stop();
      });

      _this.onPlayer('complete', function () {
        _this.timer.stop();
      });

      _this.onDom(document, 'visibilitychange', function () {
        _this.timer.tick();
      });

      _this.onDom(window, 'pagehide', function () {
        _this.timer.tick();
      });

      _this.onDom(window, 'unload', function () {
        _this.timer.tick();
      });

      _this.onDom(window, 'beforeunload', function () {
        _this.timer.tick();
      });

      if (is('function', _this.option.onTick)) {
        _this.on('tick', _this.option.onTick);
      }

      return _this;
    }

    _createClass(Tick, [{
      key: "remove",
      value: function remove() {
        _get(_getPrototypeOf(Tick.prototype), "remove", this).call(this);

        this.timer.stop();
      }
    }]);

    return Tick;
  }(Plugin);

  Tick.isSupported = returnTrue;

  var toggleSelection = function () {
    var selection = document.getSelection();
    if (!selection.rangeCount) {
      return function () {};
    }
    var active = document.activeElement;

    var ranges = [];
    for (var i = 0; i < selection.rangeCount; i++) {
      ranges.push(selection.getRangeAt(i));
    }

    switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
      case 'INPUT':
      case 'TEXTAREA':
        active.blur();
        break;

      default:
        active = null;
        break;
    }

    selection.removeAllRanges();
    return function () {
      selection.type === 'Caret' &&
      selection.removeAllRanges();

      if (!selection.rangeCount) {
        ranges.forEach(function(range) {
          selection.addRange(range);
        });
      }

      active &&
      active.focus();
    };
  };

  var defaultMessage = 'Copy to clipboard: #{key}, Enter';

  function format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
    return message.replace(/#{\s*key\s*}/g, copyKey);
  }

  function copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) { options = {}; }
    debug = options.debug || false;
    try {
      reselectPrevious = toggleSelection();

      range = document.createRange();
      selection = document.getSelection();

      mark = document.createElement('span');
      mark.textContent = text;
      // reset user styles for span element
      mark.style.all = 'unset';
      // prevents scrolling to the end of the page
      mark.style.position = 'fixed';
      mark.style.top = 0;
      mark.style.clip = 'rect(0, 0, 0, 0)';
      // used to preserve spaces and line breaks
      mark.style.whiteSpace = 'pre';
      // do not inherit user-select (it may be `none`)
      mark.style.webkitUserSelect = 'text';
      mark.style.MozUserSelect = 'text';
      mark.style.msUserSelect = 'text';
      mark.style.userSelect = 'text';

      document.body.appendChild(mark);

      range.selectNode(mark);
      selection.addRange(range);

      var successful = document.execCommand('copy');
      if (!successful) {
        throw new Error('copy command was unsuccessful');
      }
      success = true;
    } catch (err) {
      debug && console.error('unable to copy using execCommand: ', err);
      debug && console.warn('trying IE specific stuff');
      try {
        window.clipboardData.setData('text', text);
        success = true;
      } catch (err) {
        debug && console.error('unable to copy using clipboardData: ', err);
        debug && console.error('falling back to prompt');
        message = format('message' in options ? options.message : defaultMessage);
        window.prompt(message, text);
      }
    } finally {
      if (selection) {
        if (typeof selection.removeRange == 'function') {
          selection.removeRange(range);
        } else {
          selection.removeAllRanges();
        }
      }

      if (mark) {
        document.body.removeChild(mark);
      }
      reselectPrevious();
    }

    return success;
  }

  var copyToClipboard = copy;

  var LogPlugin =
  /*#__PURE__*/
  function (_Plugin) {
    _inherits(LogPlugin, _Plugin);

    function LogPlugin(player, option) {
      var _this;

      _classCallCheck(this, LogPlugin);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(LogPlugin).call(this, player, option));
      _this.logs = [];
      _this.errorLogUrl = player._config.errorLogUrl;

      _this.onPlayer(INTERNAL_STATUS_FORMATED, function () {
        _this.player._config.contextMenus.unshift({
          key: 'copy-log',
          text: _this.player._status.localization['Copy debug info']
        }, {
          key: 'upload-log',
          text: _this.player._status.localization['Upload debug info']
        });
      });

      _this.onPlayer(OUTER_CONTEXT_MENU_CLICK, function (_ref) {
        var key = _ref.key;

        if (key === 'copy-log') {
          _this.copyLog();
        }

        if (key === 'upload-log') {
          _this.uploadLog();
        }
      });

      _this.onPlayer('all', function (event) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var ts = rfc3339nano();

        _this.logs.push({
          type: event,
          time: ts,
          args: args
        });
      });

      _this.onPlayer('error', function (error$$1) {
        var otherInfo = _this.getOtherInfo();

        otherInfo.errorId = error$$1.errorId;
        otherInfo.error = error$$1; // 'flash not allowed' error do not upload

        if (error$$1.message === Flash.Error.NotAllowedError) {
          if (_this.player._provider && _this.player._provider.flash) {
            return;
          }
        }

        _this.uploadError(otherInfo);
      });

      return _this;
    }

    _createClass(LogPlugin, [{
      key: "copyLog",
      value: function copyLog() {
        var debugInfo = this.getDebugInfo();
        copyToClipboard(JSON.stringify(debugInfo));
        this.player.model.bezel["switch"](check);
      }
    }, {
      key: "uploadLog",
      value: function uploadLog() {
        var url = this.errorLogUrl;
        var debugInfo = this.getDebugInfo();
        url && postLog(url, debugInfo);
        this.player.model.bezel["switch"](check);
      }
    }, {
      key: "uploadError",
      value: function uploadError(err) {
        var url = this.errorLogUrl;
        url && postLog(url, err);
      }
    }, {
      key: "filterLog",
      value: function filterLog() {
        // remove extra time event [time, time, ..., time] => [time, time]
        var logs = [];
        this.logs.forEach(function (v, i, arr) {
          var pre = arr[i - 1];
          var next = arr[i + 1];

          if (v.type === 'time' && pre && pre.type === 'time' && next && next.type === 'time') {
            return;
          }

          logs.push(v);
        });
        this.logs = logs;
        return logs;
      }
    }, {
      key: "getDebugInfo",
      value: function getDebugInfo() {
        var log = this.filterLog();
        var info = this.getOtherInfo();
        info.log = log;
        return info;
      }
    }, {
      key: "getOtherInfo",
      value: function getOtherInfo() {
        var status = _objectSpread({}, this.player._status, {
          localization: ''
        });

        var config = this.player._config;
        var env = getEnvor();
        var provider = {};

        if (this.player._provider) {
          provider.name = this.player._provider.name;
        }

        var plugins = objectKeys(this.player.plugin);
        var container = document.getElementById(this.player._config.containerId);
        var html = container && container.outerHTML;
        var info = {
          uniqId: status.uniqId,
          status: status,
          config: config,
          env: env,
          provider: provider,
          plugins: plugins,
          ua: navigator.userAgent,
          version: "0.36.3",
          url: window.location.href,
          documentTitle: document.title,
          html: html,
          cookie: document.cookie
        };
        return info;
      }
    }]);

    return LogPlugin;
  }(Plugin);

  LogPlugin.isSupported = returnTrue;
  LogPlugin.defaultOptions = {};

  var VRProvider =
  /*#__PURE__*/
  function (_HTML5Provider) {
    _inherits(VRProvider, _HTML5Provider);

    function VRProvider(player, option) {
      var _this;

      _classCallCheck(this, VRProvider);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(VRProvider).call(this, player, option));
      _this.player = player;
      _this.option = option;
      _this.TAG = 'vrProvider';
      _this.inited = false;
      _this.isFullscreen = false;
      return _this;
    }

    _createClass(VRProvider, [{
      key: "loadFiles",
      value: function loadFiles() {
        // let loader = new ScriptLoader('https://localhost:9000/mudu-vr-player.umd.js')
        var loader = new ScriptLoader('https://static.mudu.tv/mudu-vr-player/v0.1.0/mudu-vr-player.umd.js');
        return loader.load();
      }
    }, {
      key: "setup",
      value: function setup() {
        if (this.inited) {
          this.destroy();
        }

        this.initVRPlayer();
      }
    }, {
      key: "initVRPlayer",
      value: function initVRPlayer() {
        var _this2 = this;

        this.inited = true;
        this.containerElem = this.player.dom.videoWrap;
        this.videoElem = this.player.dom.videoWrap.querySelector('video');
        this.containerElem.classList.add(vrMode);
        this.vrPlayer = new window.muduVRPlayer.VRPlayer(this.containerElem, this.videoElem, _objectSpread({}, this.option, {
          onSuccess: function onSuccess() {
            return _this2._onVRInitSuccess();
          }
        }));
        this.subEvents();
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.vrPlayer.destroy();
        this.inited = false;
      }
    }, {
      key: "subEvents",
      value: function subEvents() {
        var _this3 = this;

        this.onDom(this.containerElem, 'click', function (e) {
          e.stopPropagation();
        });
        this.onDom(window, 'resize', function () {
          _this3.vrPlayer.resize();
        });
        this.onPlayer(OUTER_FULLSCREEN, function (e) {
          setTimeout(function () {
            _this3.vrPlayer.resize(_this3.containerElem.clientWidth, _this3.containerElem.clientHeight);
          }, 0);
        });
        this.oncePlayer(INTERNAL_PROVIDER_REMOVED, function (e) {
          _this3.destroy();
        });
      }
    }, {
      key: "_onVRInitSuccess",
      value: function _onVRInitSuccess() {
        this.videoElem.classList.add(hideVideo);
        document.body.appendChild(this.videoElem);

        if (typeof this.option.onSuccess === 'function') {
          this.option.onSuccess();
        }
      }
    }]);

    return VRProvider;
  }(HTML5Provider);

  VRProvider.isSupported = function () {
    return true;
  };

  VRProvider.defaultOptions = {
    projection: 'sphere'
  };

  VRProvider.canPlay = function (type) {
    console.log('vr: play type', type);

    if (type === 'flash') {
      return false;
    }

    return true;
  };

  VRProvider.isLiveSupported = function () {
    console.log('vr is live supported');
    return true;
  };

  var index$1 = 0; // eslint-disable-line

  var instances = {};

  function muduPlayer(containerId) {
    var container = document.getElementById(containerId);

    if (!container) {
      throw new Error("muduPlayer(container): container should be an id of a div in the body, but not found");
    }

    if (instances[containerId]) {
      if (instances[containerId]._status) {
        return instances[containerId];
      }
    }

    index$1++;
    var player = new Player(containerId);
    instances[containerId] = player;
    player._status.index = index$1;
    return player;
  }

  muduPlayer.VERSION = "0.36.3";
  muduPlayer.setDefaultOptions = setDefaultOptions;
  muduPlayer.getDefaultOptions = getDefaultOptions;
  muduPlayer.registerProvider = registerProvider;
  muduPlayer.registerExtraProvider = registerExtraProvider;
  muduPlayer.getProvider = getProvider;
  muduPlayer.getExtraProvider = getExtraProvider;
  muduPlayer.getProviders = getProviders;
  muduPlayer.getExtraProviders = getExtraProviders;
  muduPlayer.chooseProvider = chooseProvider;
  muduPlayer.registerPlugin = registerPlugin;
  muduPlayer.getPlugin = getPlugin;
  muduPlayer.getPlugins = getPlugins;
  muduPlayer.utils = {
    formatPlaylist: formatPlaylist,
    Timer: Timer,
    ScriptLoader: ScriptLoader,
    browser: browser$1,
    Cache: Cache,
    delegates: Delegator
  };
  muduPlayer.registerExtraProvider('vr', VRProvider);
  muduPlayer.registerProvider('html5', HTML5Provider);
  muduPlayer.registerProvider('flash', Flash);
  muduPlayer.registerProvider('dash', Dash);
  muduPlayer.registerProvider('flvjs', Flvjs);
  muduPlayer.registerProvider('hlsjs', Hlsjs); // muduPlayer.registerProvider('hlsjs-p2p', HlsjsP2pProvider)

  muduPlayer.registerPlugin('plugin', Plugin); // muduPlayer.registerPlugin('x5', X5Plugin)

  muduPlayer.registerPlugin('tick', Tick);
  muduPlayer.registerPlugin('danmaku', DanmakuPlugin); // muduPlayer.registerPlugin('googleAnalysis', GoogleAnalysisPlugin)
  // muduPlayer.registerPlugin('memorizePosition', MemorizePositionPlugin)

  muduPlayer.registerPlugin('log', LogPlugin);

  return muduPlayer;

})));
